(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5555],{

/***/ 66054:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/australianHeart.d993bda8.png","height":49,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA3ElEQVR42mNgYLjAyIAT7GECUyYhd0ItY+9NS6l7aZAUf90kLu7axKamOy5gSUvPiyEdqYf/z03a8b8j88BvH/+Lf9PSz/2PTzj5PzHxnD0Dk/GJSYtil/5/lpP8ZWHYnP8BMaf/x8Uf/RIWufO/ouKaegZ55c1G7ta7/4e5Hf4fF3jsp6//yR/RcYf+Gxgu/cnAUKPBAAaKW4MYOPf+L6k6/j8scs9/B6c1fwQFu3zAcnrGB5lBtA7vbGV15VXNcvKLGxgYGuVAYiLCi8ByDCoqO5kZ0ICU1GywGABzslWprhArBwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 33664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75632);
/* harmony import */ var _hooks_useMods__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19531);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





var SwitchToTraqqWideText = function(param) {
    var mods = param.mods;
    var className = (0,_hooks_useMods__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(SwitchToTraqqWideText, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQyIiBoZWlnaHQ9IjI0OCIgdmlld0JveD0iMCAwIDM0MiAyNDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zMzkuMzMxIDc5Ljk5MjJDMzM3LjkyIDQzLjA4NTMgMzA4LjAwMiAxMy43NzY4IDI2OS4yNjggMTEuMzU2TDkwLjE1NyAwLjE2MTc4OUM0NS42MTYgLTIuNjIxOTYgNi40ODUzMiAzMC44Njk3IDQuNTcwNjIgNzMuNDE0NkwwLjA3MzA4OTYgMTczLjM0OUMtMS45Mjg3MSAyMTcuODI5IDM3LjQ2NTEgMjUyLjU4OSA4NC4xMTYxIDI0Ny41MDVMMjcwLjM0MiAyMjcuMjEzQzMxMS44OTcgMjIyLjY4NSAzNDMuNDU5IDE4Ny45NjQgMzQxLjk0OCAxNDguNDM5TDMzOS4zMzEgNzkuOTkyMloiIGZpbGw9IiNGOTU4NDIiLz4KPC9zdmc+Cg==",
                alt: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,_utils_css__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("\n                text-[98px] font-[900] leading-[84px]\n                480:(text-[114px] leading-[100px])\n                768:(text-[150px] leading-[134px])\n                "),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                    children: [
                        "30%",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                        "off"
                    ]
                })
            })
        ]
    });
};
SwitchToTraqqWideText.displayName = "Switch-To-Traqq-Wide__Text";
SwitchToTraqqWideText.propTypes = {
    mods: (prop_types__WEBPACK_IMPORTED_MODULE_4___default().object)
};
SwitchToTraqqWideText.defaultProps = {
    mods: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (SwitchToTraqqWideText);


/***/ }),

/***/ 4711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Grid; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Grid/Grid.jsx







var Grid = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, cols = param.cols, xs = param.xs, sm = param.sm, md = param.md, lg = param.lg, xl = param.xl, items = param.items, justify = param.justify, g = param.g, gx = param.gx, gy = param.gy, p = param.p, pt = param.pt, pb = param.pb, px = param.px, py = param.py, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Grid, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            cols: cols,
            g: g,
            gx: gx,
            gy: gy,
            items: items,
            justify: justify,
            lg: lg,
            md: md,
            p: p,
            pb: pb,
            pt: pt,
            px: px,
            py: py,
            sm: sm,
            xl: xl,
            xs: xs
        })
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
Grid.displayName = "Grid";
Grid.propTypes = {
    children: (prop_types_default()).node,
    cols: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).number
    ]),
    g: (prop_types_default()).number,
    gx: (prop_types_default()).number,
    gy: (prop_types_default()).number,
    items: (prop_types_default()).string,
    justify: (prop_types_default()).string,
    lg: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    md: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    p: (prop_types_default()).number,
    pb: (prop_types_default()).number,
    pt: (prop_types_default()).number,
    px: (prop_types_default()).number,
    py: (prop_types_default()).number,
    sm: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    xl: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ]),
    xs: prop_types_default().oneOfType([
        (prop_types_default()).number,
        (prop_types_default()).string
    ])
};
Grid.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Grid_Grid = (Grid);

;// CONCATENATED MODULE: ./src/components/Grid/index.js

/* harmony default export */ var components_Grid = (Grid_Grid);


/***/ }),

/***/ 54491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Info; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Info/Info.jsx







var Info = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, gap = param.gap, tag = param.tag, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Info, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            gap: gap
        })
    }).className;
    var TagName = tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagName, {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
Info.displayName = "Info";
Info.propTypes = {
    children: (prop_types_default()).node,
    gap: (prop_types_default()).number,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    tag: (prop_types_default()).string
};
Info.defaultProps = {
    mix: {},
    mods: {},
    tag: "div"
};
/* harmony default export */ var Info_Info = (Info);

;// CONCATENATED MODULE: ./src/components/Info/index.js

/* harmony default export */ var components_Info = (Info_Info);


/***/ }),

/***/ 19812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "JL": function() { return /* reexport */ Nav_Nav; },
  "LY": function() { return /* reexport */ Nav_NavItem; },
  "OL": function() { return /* reexport */ Nav_NavLink; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Nav/Nav.jsx







var Nav = function(param) {
    var children = param.children, mix = param.mix, mods = param.mods, direction = param.direction, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Nav, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            direction: direction
        })
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
Nav.displayName = "Nav";
Nav.propTypes = {
    children: (prop_types_default()).node,
    direction: (prop_types_default()).string,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Nav.defaultProps = {
    direction: "col",
    mix: {},
    mods: {}
};
/* harmony default export */ var Nav_Nav = (Nav);

;// CONCATENATED MODULE: ./src/components/Nav/NavItem.jsx




var NavItem = function(param) {
    var children = param.children, mods = param.mods, onClick = param.onClick;
    var className = (0,useMods/* default */.Z)(NavItem, {
        mods: mods
    }, true).className;
    return(// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events
    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: className,
        onClick: onClick,
        children: children
    }));
};
NavItem.displayName = "Nav-Item";
NavItem.propTypes = {
    children: (prop_types_default()).node,
    mods: (prop_types_default()).object,
    onClick: (prop_types_default()).func
};
NavItem.defaultProps = {
    mods: {}
};
/* harmony default export */ var Nav_NavItem = (NavItem);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Nav/NavLink.jsx








var NavLink = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, href = param.href, active = param.active, onClick = param.onClick, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(NavLink, {
        mix: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mix), {
            active: active
        }),
        mods: mods
    }).className;
    var cn = (0,css/* default */.Z)(className, classNameTail);
    return href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: cn,
            children: children
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: cn,
        onClick: onClick,
        children: children
    });
};
NavLink.displayName = "Nav-Link";
NavLink.propTypes = {
    active: (prop_types_default()).bool,
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string.isRequired
};
NavLink.defaultProps = {
    mods: {}
};
/* harmony default export */ var Nav_NavLink = (NavLink);

;// CONCATENATED MODULE: ./src/components/Nav/index.js






/***/ }),

/***/ 62091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Section_SectionHeadline; },
  "Z": function() { return /* binding */ components_Section; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Section/Section.jsx




var Section = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Section, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
Section.displayName = "Section";
Section.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Section.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Section_Section = (Section);

;// CONCATENATED MODULE: ./src/components/Section/SectionHeadline.jsx




var SectionHeadline = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(SectionHeadline, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
SectionHeadline.displayName = "Section__Headline";
SectionHeadline.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
SectionHeadline.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Section_SectionHeadline = (SectionHeadline);

;// CONCATENATED MODULE: ./src/components/Section/index.js



/* harmony default export */ var components_Section = (Section_Section);


/***/ }),

/***/ 40845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ NextSeoTraqq; },
/* harmony export */   "gA": function() { return /* binding */ DefaultSeoTraqq; }
/* harmony export */ });
/* unused harmony exports ArticleJsonLd, BrandJsonLd, BreadCrumbJsonLd, CarouselJsonLd, CollectionPageJsonLd, CorporateContactJsonLd, CourseJsonLd, DatasetJsonLd, EventJsonLd, FAQPageJsonLd, howToJsonLd, ImageJsonLd, JobPostingJsonLd, LocalBusinessJsonLd, LogoJsonLd, NewsArticleJsonLd, OrganizationJsonLd, ProductJsonLd, ProfilePageJsonLd, QAPageJsonLd, RecipeJsonLd, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd, SoftwareAppJsonLd, VideoGameJsonLd, VideoJsonLd, WebPageJsonLd */
/* harmony import */ var _swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82222);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);



function _interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var React__default = /*#__PURE__*/ _interopDefaultLegacy(react__WEBPACK_IMPORTED_MODULE_0__);
var Head__default = /*#__PURE__*/ _interopDefaultLegacy((next_head__WEBPACK_IMPORTED_MODULE_1___default()));
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _excluded$x = [
    "keyOverride"
];
var defaults = {
    templateTitle: "",
    noindex: false,
    nofollow: false,
    norobots: false,
    defaultOpenGraphImageWidth: 0,
    defaultOpenGraphImageHeight: 0,
    defaultOpenGraphVideoWidth: 0,
    defaultOpenGraphVideoHeight: 0
};
var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
    if (media === void 0) {
        media = [];
    }
    var _ref = _temp === void 0 ? {} : _temp, defaultWidth = _ref.defaultWidth, defaultHeight = _ref.defaultHeight;
    return media.reduce(function(tags, medium, index) {
        tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
            key: "og:" + mediaType + ":0" + index,
            property: "og:" + mediaType,
            content: medium.url
        }));
        if (medium.alt) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":alt0" + index,
                property: "og:" + mediaType + ":alt",
                content: medium.alt
            }));
        }
        if (medium.secureUrl) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":secure_url0" + index,
                property: "og:" + mediaType + ":secure_url",
                content: medium.secureUrl.toString()
            }));
        }
        if (medium.type) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":type0" + index,
                property: "og:" + mediaType + ":type",
                content: medium.type.toString()
            }));
        }
        if (medium.width) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":width0" + index,
                property: "og:" + mediaType + ":width",
                content: medium.width.toString()
            }));
        } else if (defaultWidth) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":width0" + index,
                property: "og:" + mediaType + ":width",
                content: defaultWidth.toString()
            }));
        }
        if (medium.height) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":height" + index,
                property: "og:" + mediaType + ":height",
                content: medium.height.toString()
            }));
        } else if (defaultHeight) {
            tags.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:" + mediaType + ":height" + index,
                property: "og:" + mediaType + ":height",
                content: defaultHeight.toString()
            }));
        }
        return tags;
    }, []);
};
var buildTags = function buildTags(config) {
    var _config$openGraph, _config$openGraph3, _config$additionalLin;
    var tagsToRender = [];
    if (config.titleTemplate) {
        defaults.templateTitle = config.titleTemplate;
    }
    var updatedTitle = "";
    if (config.title) {
        updatedTitle = config.title;
        if (defaults.templateTitle) {
            updatedTitle = defaults.templateTitle.replace(/%s/g, function() {
                return updatedTitle;
            });
        }
    } else if (config.defaultTitle) {
        updatedTitle = config.defaultTitle;
    }
    if (updatedTitle) {
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("title", {
            key: "title"
        }, updatedTitle));
    }
    var noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
    var nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
    var norobots =  false || config.norobots;
    defaults.norobots = norobots;
    var robotsParams = "";
    if (config.robotsProps) {
        var _config$robotsProps = config.robotsProps, nosnippet = _config$robotsProps.nosnippet, maxSnippet = _config$robotsProps.maxSnippet, maxImagePreview = _config$robotsProps.maxImagePreview, maxVideoPreview = _config$robotsProps.maxVideoPreview, noarchive = _config$robotsProps.noarchive, noimageindex = _config$robotsProps.noimageindex, notranslate = _config$robotsProps.notranslate, unavailableAfter = _config$robotsProps.unavailableAfter;
        robotsParams = "" + (nosnippet ? ",nosnippet" : "") + (maxSnippet ? ",max-snippet:" + maxSnippet : "") + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : "") + (noarchive ? ",noarchive" : "") + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : "") + (noimageindex ? ",noimageindex" : "") + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : "") + (notranslate ? ",notranslate" : "");
    }
    if (!norobots) {
        if (noindex || nofollow) {
            if (config.dangerouslySetAllPagesToNoIndex) {
                defaults.noindex = true;
            }
            if (config.dangerouslySetAllPagesToNoFollow) {
                defaults.nofollow = true;
            }
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "robots",
                name: "robots",
                content: (noindex ? "noindex" : "index") + "," + (nofollow ? "nofollow" : "follow") + robotsParams
            }));
        } else {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "robots",
                name: "robots",
                content: "index,follow" + robotsParams
            }));
        }
    }
    if (config.description) {
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
            key: "description",
            name: "description",
            content: config.description
        }));
    }
    if (config.themeColor) {
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
            key: "theme-color",
            name: "theme-color",
            content: config.themeColor
        }));
    }
    if (config.mobileAlternate) {
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("link", {
            rel: "alternate",
            key: "mobileAlternate",
            media: config.mobileAlternate.media,
            href: config.mobileAlternate.href
        }));
    }
    if (config.languageAlternates && config.languageAlternates.length > 0) {
        config.languageAlternates.forEach(function(languageAlternate) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("link", {
                rel: "alternate",
                key: "languageAlternate-" + languageAlternate.hrefLang,
                hrefLang: languageAlternate.hrefLang,
                href: languageAlternate.href
            }));
        });
    }
    if (config.twitter) {
        if (config.twitter.cardType) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "twitter:card",
                name: "twitter:card",
                content: config.twitter.cardType
            }));
        }
        if (config.twitter.site) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "twitter:site",
                name: "twitter:site",
                content: config.twitter.site
            }));
        }
        if (config.twitter.handle) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "twitter:creator",
                name: "twitter:creator",
                content: config.twitter.handle
            }));
        }
    }
    if (config.facebook) {
        if (config.facebook.appId) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "fb:app_id",
                property: "fb:app_id",
                content: config.facebook.appId
            }));
        }
    }
    if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
        var _config$openGraph2;
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
            key: "og:title",
            property: "og:title",
            content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
        }));
    }
    if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
        var _config$openGraph4;
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
            key: "og:description",
            property: "og:description",
            content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
        }));
    }
    if (config.openGraph) {
        if (config.openGraph.url || config.canonical) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:url",
                property: "og:url",
                content: config.openGraph.url || config.canonical
            }));
        }
        if (config.openGraph.type) {
            var type = config.openGraph.type.toLowerCase();
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:type",
                property: "og:type",
                content: type
            }));
            if (type === "profile" && config.openGraph.profile) {
                if (config.openGraph.profile.firstName) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "profile:first_name",
                        property: "profile:first_name",
                        content: config.openGraph.profile.firstName
                    }));
                }
                if (config.openGraph.profile.lastName) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "profile:last_name",
                        property: "profile:last_name",
                        content: config.openGraph.profile.lastName
                    }));
                }
                if (config.openGraph.profile.username) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "profile:username",
                        property: "profile:username",
                        content: config.openGraph.profile.username
                    }));
                }
                if (config.openGraph.profile.gender) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "profile:gender",
                        property: "profile:gender",
                        content: config.openGraph.profile.gender
                    }));
                }
            } else if (type === "book" && config.openGraph.book) {
                if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
                    config.openGraph.book.authors.forEach(function(author, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "book:author:0" + index,
                            property: "book:author",
                            content: author
                        }));
                    });
                }
                if (config.openGraph.book.isbn) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "book:isbn",
                        property: "book:isbn",
                        content: config.openGraph.book.isbn
                    }));
                }
                if (config.openGraph.book.releaseDate) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "book:release_date",
                        property: "book:release_date",
                        content: config.openGraph.book.releaseDate
                    }));
                }
                if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
                    config.openGraph.book.tags.forEach(function(tag, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "book:tag:0" + index,
                            property: "book:tag",
                            content: tag
                        }));
                    });
                }
            } else if (type === "article" && config.openGraph.article) {
                if (config.openGraph.article.publishedTime) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "article:published_time",
                        property: "article:published_time",
                        content: config.openGraph.article.publishedTime
                    }));
                }
                if (config.openGraph.article.modifiedTime) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "article:modified_time",
                        property: "article:modified_time",
                        content: config.openGraph.article.modifiedTime
                    }));
                }
                if (config.openGraph.article.expirationTime) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "article:expiration_time",
                        property: "article:expiration_time",
                        content: config.openGraph.article.expirationTime
                    }));
                }
                if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
                    config.openGraph.article.authors.forEach(function(author, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "article:author:0" + index,
                            property: "article:author",
                            content: author
                        }));
                    });
                }
                if (config.openGraph.article.section) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "article:section",
                        property: "article:section",
                        content: config.openGraph.article.section
                    }));
                }
                if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
                    config.openGraph.article.tags.forEach(function(tag, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "article:tag:0" + index,
                            property: "article:tag",
                            content: tag
                        }));
                    });
                }
            } else if ((type === "video.movie" || type === "video.episode" || type === "video.tv_show" || type === "video.other") && config.openGraph.video) {
                if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
                    config.openGraph.video.actors.forEach(function(actor, index) {
                        if (actor.profile) {
                            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                                key: "video:actor:0" + index,
                                property: "video:actor",
                                content: actor.profile
                            }));
                        }
                        if (actor.role) {
                            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                                key: "video:actor:role:0" + index,
                                property: "video:actor:role",
                                content: actor.role
                            }));
                        }
                    });
                }
                if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
                    config.openGraph.video.directors.forEach(function(director, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "video:director:0" + index,
                            property: "video:director",
                            content: director
                        }));
                    });
                }
                if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
                    config.openGraph.video.writers.forEach(function(writer, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "video:writer:0" + index,
                            property: "video:writer",
                            content: writer
                        }));
                    });
                }
                if (config.openGraph.video.duration) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "video:duration",
                        property: "video:duration",
                        content: config.openGraph.video.duration.toString()
                    }));
                }
                if (config.openGraph.video.releaseDate) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "video:release_date",
                        property: "video:release_date",
                        content: config.openGraph.video.releaseDate
                    }));
                }
                if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
                    config.openGraph.video.tags.forEach(function(tag, index) {
                        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                            key: "video:tag:0" + index,
                            property: "video:tag",
                            content: tag
                        }));
                    });
                }
                if (config.openGraph.video.series) {
                    tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                        key: "video:series",
                        property: "video:series",
                        content: config.openGraph.video.series
                    }));
                }
            }
        }
        // images
        if (config.defaultOpenGraphImageWidth) {
            defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
        }
        if (config.defaultOpenGraphImageHeight) {
            defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
        }
        if (config.openGraph.images && config.openGraph.images.length) {
            tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags("image", config.openGraph.images, {
                defaultWidth: defaults.defaultOpenGraphImageWidth,
                defaultHeight: defaults.defaultOpenGraphImageHeight
            }));
        }
        // videos
        if (config.defaultOpenGraphVideoWidth) {
            defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
        }
        if (config.defaultOpenGraphVideoHeight) {
            defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
        }
        if (config.openGraph.videos && config.openGraph.videos.length) {
            tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags("video", config.openGraph.videos, {
                defaultWidth: defaults.defaultOpenGraphVideoWidth,
                defaultHeight: defaults.defaultOpenGraphVideoHeight
            }));
        }
        // audio
        if (config.openGraph.audio) {
            tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags("audio", config.openGraph.audio));
        }
        if (config.openGraph.locale) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:locale",
                property: "og:locale",
                content: config.openGraph.locale
            }));
        }
        if (config.openGraph.siteName || config.openGraph.site_name) {
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", {
                key: "og:site_name",
                property: "og:site_name",
                content: config.openGraph.siteName || config.openGraph.site_name
            }));
        }
    }
    if (config.canonical) {
        tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("link", {
            rel: "canonical",
            href: config.canonical,
            key: "canonical"
        }));
    }
    if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
        config.additionalMetaTags.forEach(function(_ref2) {
            var _ref3, _ref4;
            var keyOverride = _ref2.keyOverride, tag = _objectWithoutPropertiesLoose(_ref2, _excluded$x);
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("meta", _extends({
                key: "meta:" + ((_ref3 = (_ref4 = keyOverride != null ? keyOverride : tag.name) != null ? _ref4 : tag.property) != null ? _ref3 : tag.httpEquiv)
            }, tag)));
        });
    }
    if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
        config.additionalLinkTags.forEach(function(tag) {
            var _tag$keyOverride;
            tagsToRender.push(/*#__PURE__*/ React__default["default"].createElement("link", _extends({
                key: "link" + ((_tag$keyOverride = tag.keyOverride) != null ? _tag$keyOverride : tag.href) + tag.rel
            }, tag)));
        });
    }
    return tagsToRender;
};
var WithHead = function WithHead(props) {
    return /*#__PURE__*/ React__default["default"].createElement(Head__default["default"], null, buildTags(props));
};
var DefaultSeoTraqq = function DefaultSeoTraqq(_ref) {
    var title = _ref.title, titleTemplate = _ref.titleTemplate, defaultTitle = _ref.defaultTitle, themeColor = _ref.themeColor, _ref$dangerouslySetAl = _ref.dangerouslySetAllPagesToNoIndex, dangerouslySetAllPagesToNoIndex = _ref$dangerouslySetAl === void 0 ? false : _ref$dangerouslySetAl, _ref$dangerouslySetAl2 = _ref.dangerouslySetAllPagesToNoFollow, dangerouslySetAllPagesToNoFollow = _ref$dangerouslySetAl2 === void 0 ? false : _ref$dangerouslySetAl2, description = _ref.description, canonical = _ref.canonical, facebook = _ref.facebook, openGraph = _ref.openGraph, additionalMetaTags = _ref.additionalMetaTags, twitter = _ref.twitter, defaultOpenGraphImageWidth = _ref.defaultOpenGraphImageWidth, defaultOpenGraphImageHeight = _ref.defaultOpenGraphImageHeight, defaultOpenGraphVideoWidth = _ref.defaultOpenGraphVideoWidth, defaultOpenGraphVideoHeight = _ref.defaultOpenGraphVideoHeight, mobileAlternate = _ref.mobileAlternate, languageAlternates = _ref.languageAlternates, additionalLinkTags = _ref.additionalLinkTags, robotsProps = _ref.robotsProps, norobots = _ref.norobots;
    return /*#__PURE__*/ React__default["default"].createElement(WithHead, {
        title: title,
        titleTemplate: titleTemplate,
        defaultTitle: defaultTitle,
        themeColor: themeColor,
        dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
        dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
        description: description,
        canonical: canonical,
        facebook: facebook,
        openGraph: openGraph,
        additionalMetaTags: additionalMetaTags,
        twitter: twitter,
        defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
        defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
        defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
        defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
        mobileAlternate: mobileAlternate,
        languageAlternates: languageAlternates,
        additionalLinkTags: additionalLinkTags,
        robotsProps: robotsProps,
        norobots: norobots
    });
};
var NextSeoTraqq = function NextSeoTraqq(_ref) {
    var title = _ref.title, themeColor = _ref.themeColor, _ref$noindex = _ref.noindex, noindex = _ref$noindex === void 0 ? false : _ref$noindex, nofollow = _ref.nofollow, robotsProps = _ref.robotsProps, norobots = _ref.norobots, description = _ref.description, canonical = _ref.canonical, openGraph = _ref.openGraph, facebook = _ref.facebook, twitter = _ref.twitter, additionalMetaTags = _ref.additionalMetaTags, titleTemplate = _ref.titleTemplate, defaultTitle = _ref.defaultTitle, mobileAlternate = _ref.mobileAlternate, languageAlternates = _ref.languageAlternates, additionalLinkTags = _ref.additionalLinkTags, _ref$useAppDir = _ref.useAppDir, useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir;
    return /*#__PURE__*/ React__default["default"].createElement(React__default["default"].Fragment, null, useAppDir ? buildTags({
        title: title,
        themeColor: themeColor,
        noindex: noindex,
        nofollow: nofollow,
        robotsProps: robotsProps,
        norobots: norobots,
        description: description,
        canonical: canonical,
        facebook: facebook,
        openGraph: openGraph,
        additionalMetaTags: additionalMetaTags,
        twitter: twitter,
        titleTemplate: titleTemplate,
        defaultTitle: defaultTitle,
        mobileAlternate: mobileAlternate,
        languageAlternates: languageAlternates,
        additionalLinkTags: additionalLinkTags
    }) : /*#__PURE__*/ React__default["default"].createElement(WithHead, {
        title: title,
        themeColor: themeColor,
        noindex: noindex,
        nofollow: nofollow,
        robotsProps: robotsProps,
        norobots: norobots,
        description: description,
        canonical: canonical,
        facebook: facebook,
        openGraph: openGraph,
        additionalMetaTags: additionalMetaTags,
        twitter: twitter,
        titleTemplate: titleTemplate,
        defaultTitle: defaultTitle,
        mobileAlternate: mobileAlternate,
        languageAlternates: languageAlternates,
        additionalLinkTags: additionalLinkTags
    }));
};
var toJson = function toJson(type, jsonld) {
    var data = jsonld;
    if (Array.isArray(data) && data.length === 1) {
        data = _extends({}, jsonld[0]);
    }
    var jsonLdObject = Array.isArray(data) ? data.map(function(item) {
        return formatObjectForSchema(type, item);
    }) : formatObjectForSchema(type, data);
    return {
        __html: JSON.stringify(jsonLdObject, safeJsonLdReplacer)
    };
};
var formatObjectForSchema = function formatObjectForSchema(type, jsonld) {
    var _jsonld$id = jsonld.id, id = _jsonld$id === void 0 ? undefined : _jsonld$id;
    var updated = _extends({}, id ? {
        "@id": jsonld.id
    } : {}, jsonld);
    delete updated.id;
    return _extends({
        "@context": "https://schema.org",
        "@type": type
    }, updated);
};
var ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;"
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join("") + "]", "g");
var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
    return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */ var safeJsonLdReplacer = function() {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return function(_, value) {
        switch(typeof value === "undefined" ? "undefined" : (0,_swc_helpers_src_type_of_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(value)){
            case "object":
                // Omit null values.
                if (value === null) {
                    return undefined;
                }
                return value;
            // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value;
            // These values are not risky.
            case "string":
                return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);
            default:
                {
                    // JSON.stringify will remove this element.
                    return undefined;
                }
        }
    };
}();
var _excluded$w = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "scriptKey",
    "scriptId",
    "dataArray",
    "useAppDir"
]));
function JsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Thing" : _ref$type, keyOverride = _ref.keyOverride, scriptKey = _ref.scriptKey, _ref$scriptId = _ref.scriptId, scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId, dataArray = _ref.dataArray, _ref$useAppDir = _ref.useAppDir, useAppDir = _ref$useAppDir === void 0 ? false : _ref$useAppDir, rest = _objectWithoutPropertiesLoose(_ref, _excluded$w);
    var JsonLdScript = function JsonLdScript() {
        return /*#__PURE__*/ React__default["default"].createElement("script", {
            type: "application/ld+json",
            id: scriptId,
            "data-testid": scriptId,
            dangerouslySetInnerHTML: toJson(type, dataArray === undefined ? _extends({}, rest) : dataArray),
            key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : "")
        });
    };
    if (useAppDir) {
        return /*#__PURE__*/ React__default["default"].createElement(JsonLdScript, null);
    }
    return /*#__PURE__*/ React__default["default"].createElement(Head__default["default"], null, JsonLdScript());
}
/**
 * Generate author information
 * @param author
 * @returns
 */ function generateAuthorInfo(author) {
    if (typeof author === "string") {
        return {
            "@type": "Person",
            name: author
        };
    } else if (!!author.name) {
        var _author$type;
        return {
            "@type": (_author$type = author == null ? void 0 : author.type) != null ? _author$type : "Person",
            name: author.name,
            url: author == null ? void 0 : author.url
        };
    }
    return;
}
function setAuthor(author) {
    if (Array.isArray(author)) {
        return author.map(function(item) {
            return generateAuthorInfo(item);
        }).filter(function(item) {
            return !!item;
        });
    } else if (author) {
        return generateAuthorInfo(author);
    }
    return;
}
function setImage(image) {
    if (image) {
        return {
            "@type": "ImageObject",
            url: image
        };
    }
    return undefined;
}
function setPublisher(publisherName, publisherLogo) {
    if (!publisherName) {
        return undefined;
    }
    return {
        "@type": "Organization",
        name: publisherName,
        logo: setImage(publisherLogo)
    };
}
function setReviewRating(rating) {
    if (rating) {
        return _extends({}, rating, {
            "@type": "Rating"
        });
    }
    return undefined;
}
var _excluded$v = (/* unused pure expression or super */ null && ([
    "reviewRating",
    "author",
    "publisher"
]));
function setReviews(reviews) {
    var mapReview = function mapReview(_ref) {
        var reviewRating = _ref.reviewRating, author = _ref.author, publisher = _ref.publisher, rest = _objectWithoutPropertiesLoose(_ref, _excluded$v);
        return _extends({}, rest, {
            "@type": "Review"
        }, author && {
            author: setAuthor(author)
        }, reviewRating && {
            reviewRating: setReviewRating(reviewRating)
        }, publisher && {
            publisher: setPublisher(publisher.name)
        });
    };
    if (Array.isArray(reviews)) {
        return reviews.map(mapReview);
    } else if (reviews) {
        return mapReview(reviews);
    }
    return undefined;
}
function setNutrition(calories) {
    if (calories) {
        return {
            "@type": "NutritionInformation",
            calories: calories + " calories"
        };
    }
    return undefined;
}
function setAggregateRating(aggregateRating) {
    if (aggregateRating) {
        return {
            "@type": "AggregateRating",
            ratingCount: aggregateRating.ratingCount,
            reviewCount: aggregateRating.reviewCount,
            bestRating: aggregateRating.bestRating,
            ratingValue: aggregateRating.ratingValue
        };
    }
    return undefined;
}
function setClip(clips) {
    var mapClip = function mapClip(clip) {
        return _extends({}, clip, {
            "@type": "Clip"
        });
    };
    if (Array.isArray(clips)) {
        return clips.map(mapClip);
    } else if (clips) {
        return mapClip(clips);
    }
    return undefined;
}
function setInteractionStatistic(watchCount) {
    if (watchCount) {
        return {
            "@type": "InteractionCounter",
            interactionType: "https://schema.org/WatchAction",
            userInteractionCount: watchCount
        };
    }
    return undefined;
}
function setBroadcastEvent(publication) {
    var mapBroadcastEvent = function mapBroadcastEvent(publication) {
        return _extends({}, publication, {
            "@type": "BroadcastEvent"
        });
    };
    if (publication) {
        if (Array.isArray(publication)) {
            return publication.map(mapBroadcastEvent);
        }
        return mapBroadcastEvent(publication);
    }
    return undefined;
}
var _excluded$u = (/* unused pure expression or super */ null && ([
    "thumbnailUrls",
    "hasPart",
    "watchCount",
    "publication"
]));
function setVideo(video, setContext) {
    var mapVideo = function mapVideo(_ref, context) {
        var thumbnailUrls = _ref.thumbnailUrls, hasPart = _ref.hasPart, watchCount = _ref.watchCount, publication = _ref.publication, rest = _objectWithoutPropertiesLoose(_ref, _excluded$u);
        return _extends({}, rest, {
            "@type": "VideoObject"
        }, context && {
            "@context": "https://schema.org"
        }, {
            thumbnailUrl: thumbnailUrls,
            hasPart: setClip(hasPart),
            interactionStatistic: setInteractionStatistic(watchCount),
            publication: setBroadcastEvent(publication)
        });
    };
    if (setContext === void 0) {
        setContext = false;
    }
    if (video) {
        return mapVideo(video, setContext);
    }
    return undefined;
}
function setInstruction(instruction) {
    if (instruction) {
        return _extends({}, instruction, {
            "@type": "HowToStep"
        });
    }
    return undefined;
}
var _excluded$t = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "ofType",
    "data"
])), _excluded2$1 = (/* unused pure expression or super */ null && ([
    "authorName",
    "images",
    "yields",
    "category",
    "calories",
    "aggregateRating",
    "video",
    "ingredients",
    "instructions",
    "cuisine"
]));
function CarouselJsonLd(_ref) {
    var generateList = function generateList(data, ofType) {
        switch(ofType){
            case "default":
                return data.map(function(item, index) {
                    return {
                        "@type": "ListItem",
                        position: "" + (index + 1),
                        url: item.url
                    };
                });
            case "course":
                return data.map(function(item, index) {
                    return {
                        "@type": "ListItem",
                        position: "" + (index + 1),
                        item: {
                            "@context": "https://schema.org",
                            "@type": "Course",
                            url: item.url,
                            name: item.courseName,
                            description: item.description,
                            provider: {
                                "@type": "Organization",
                                name: item.providerName,
                                sameAs: item.providerUrl
                            }
                        }
                    };
                });
            case "movie":
                return data.map(function(item, index) {
                    return {
                        "@type": "ListItem",
                        position: "" + (index + 1),
                        item: {
                            "@context": "https://schema.org",
                            "@type": "Movie",
                            name: item.name,
                            url: item.url,
                            image: item.image,
                            dateCreated: item.dateCreated,
                            director: item.director ? Array.isArray(item.director) ? item.director.map(function(director) {
                                return {
                                    "@type": "Person",
                                    name: director.name
                                };
                            }) : {
                                "@type": "Person",
                                name: item.director.name
                            } : undefined,
                            review: setReviews(item.review)
                        }
                    };
                });
            case "recipe":
                return data.map(function(_ref2, index) {
                    var authorName = _ref2.authorName, images = _ref2.images, yields = _ref2.yields, category = _ref2.category, calories = _ref2.calories, aggregateRating = _ref2.aggregateRating, video = _ref2.video, ingredients = _ref2.ingredients, instructions = _ref2.instructions, cuisine = _ref2.cuisine, rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
                    return {
                        "@type": "ListItem",
                        position: "" + (index + 1),
                        item: _extends({
                            "@context": "https://schema.org",
                            "@type": "Recipe"
                        }, rest, {
                            author: setAuthor(authorName),
                            image: images,
                            recipeYield: yields,
                            recipeCategory: category,
                            recipeCuisine: cuisine,
                            nutrition: setNutrition(calories),
                            aggregateRating: setAggregateRating(aggregateRating),
                            video: setVideo(video),
                            recipeIngredient: ingredients,
                            recipeInstructions: instructions.map(setInstruction)
                        })
                    };
                });
        }
    };
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Carousel" : _ref$type, keyOverride = _ref.keyOverride, ofType = _ref.ofType, data = _ref.data, rest = _objectWithoutPropertiesLoose(_ref, _excluded$t);
    var jsonLdData = _extends({
        "@type": "ItemList",
        itemListElement: generateList(data, ofType)
    }, rest);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, jsonLdData, {
        scriptKey: "Carousel"
    }));
}
var _excluded$s = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "url",
    "title",
    "images",
    "section",
    "dateCreated",
    "datePublished",
    "dateModified",
    "authorName",
    "authorType",
    "publisherName",
    "publisherLogo",
    "body",
    "isAccessibleForFree"
]));
function NewsArticleJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "NewsArticle" : _ref$type, keyOverride = _ref.keyOverride, url = _ref.url, title = _ref.title, images = _ref.images, section = _ref.section, dateCreated = _ref.dateCreated, datePublished = _ref.datePublished, dateModified = _ref.dateModified, authorName = _ref.authorName, publisherName = _ref.publisherName, publisherLogo = _ref.publisherLogo, body = _ref.body, isAccessibleForFree = _ref.isAccessibleForFree, rest = _objectWithoutPropertiesLoose(_ref, _excluded$s);
    var data = _extends({}, rest, {
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: images,
        articleSection: section,
        dateCreated: dateCreated || datePublished,
        datePublished: datePublished,
        dateModified: dateModified || datePublished,
        author: setAuthor(authorName),
        publisher: setPublisher(publisherName, publisherLogo),
        articleBody: body,
        isAccessibleForFree: isAccessibleForFree
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "NewsArticle"
    }));
}
var _excluded$r = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "baseSalary",
    "hiringOrganization",
    "applicantLocationRequirements",
    "experienceRequirements",
    "jobLocation"
]));
function JobPostingJsonLd(_ref) {
    var setBaseSalary = function setBaseSalary(baseSalary) {
        if (baseSalary) {
            return {
                "@type": "MonetaryAmount",
                currency: baseSalary.currency,
                value: _extends({
                    "@type": "QuantitativeValue",
                    unitText: baseSalary.unitText
                }, Array.isArray(baseSalary.value) ? {
                    minValue: baseSalary.value[0],
                    maxValue: baseSalary.value[1]
                } : {
                    value: baseSalary.value
                })
            };
        }
        return undefined;
    };
    var setHiringOrganization = function setHiringOrganization(org) {
        return {
            "@type": "Organization",
            name: org.name,
            sameAs: org.sameAs,
            logo: org.logo
        };
    };
    var setJobLocation = function setJobLocation(location) {
        if (location) {
            return {
                "@type": "Place",
                address: {
                    "@type": "PostalAddress",
                    addressCountry: location.addressCountry,
                    addressLocality: location.addressLocality,
                    addressRegion: location.addressRegion,
                    postalCode: location.postalCode,
                    streetAddress: location.streetAddress
                }
            };
        }
        return undefined;
    };
    var setApplicantLocationRequirements = function setApplicantLocationRequirements(requirements) {
        if (requirements) {
            return {
                "@type": "Country",
                name: requirements
            };
        }
        return undefined;
    };
    var setOccupationalExperienceRequirements = function setOccupationalExperienceRequirements(requirements) {
        if (requirements) {
            return {
                "@type": requirements["@type"] ? requirements["@type"] : "OccupationalExperienceRequirements",
                monthsOfExperience: requirements.minimumMonthsOfExperience
            };
        }
        return undefined;
    };
    var setEducationalOccupationalCredential = function setEducationalOccupationalCredential(requirements) {
        if (requirements) {
            return {
                "@type": requirements["@type"] ? requirements["@type"] : "EducationalOccupationalCredential",
                credentialCategory: requirements.credentialCategory
            };
        }
        return undefined;
    };
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "JobPosting" : _ref$type, keyOverride = _ref.keyOverride, baseSalary = _ref.baseSalary, hiringOrganization = _ref.hiringOrganization, applicantLocationRequirements = _ref.applicantLocationRequirements, experienceRequirements = _ref.experienceRequirements, jobLocation = _ref.jobLocation, rest = _objectWithoutPropertiesLoose(_ref, _excluded$r);
    var data = _extends({}, rest, {
        baseSalary: setBaseSalary(baseSalary),
        hiringOrganization: setHiringOrganization(hiringOrganization),
        jobLocation: setJobLocation(jobLocation),
        applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements),
        experienceRequirements: setOccupationalExperienceRequirements(experienceRequirements == null ? void 0 : experienceRequirements.occupational),
        educationRequirements: setEducationalOccupationalCredential(experienceRequirements == null ? void 0 : experienceRequirements.educational),
        experienceInPlaceOfEducation: experienceRequirements == null ? void 0 : experienceRequirements.experienceInPlaceOfEducation
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "JobPosting"
    }));
}
function setAddress(address) {
    if (!address) return undefined;
    if (!Array.isArray(address)) return toPostalAddress(address);
    // If array of one address, replace with single address
    if (address.length === 1) return toPostalAddress(address[0]);
    // If array, return mapped array of PostalAddresses
    return address.map(toPostalAddress);
}
function toPostalAddress(address) {
    if (typeof address === "string") return address;
    return _extends({
        "@type": "PostalAddress"
    }, address);
}
function setGeo(geo) {
    if (geo) {
        return _extends({}, geo, {
            "@type": "GeoCoordinates"
        });
    }
    return undefined;
}
function setAction(action) {
    if (action) {
        return {
            "@type": action.actionType,
            name: action.actionName,
            target: action.target
        };
    }
    return undefined;
}
function setGeoCircle(geoCircle) {
    if (geoCircle) {
        return {
            "@type": "GeoCircle",
            geoMidpoint: {
                "@type": "GeoCoordinates",
                latitude: geoCircle.geoMidpoint.latitude,
                longitude: geoCircle.geoMidpoint.longitude
            },
            geoRadius: geoCircle.geoRadius
        };
    }
    return undefined;
}
function setOffer(offer) {
    var setPriceSpecification = function setPriceSpecification(priceSpecification) {
        if (priceSpecification) {
            return {
                "@type": priceSpecification.type,
                priceCurrency: priceSpecification.priceCurrency,
                price: priceSpecification.price
            };
        }
        return undefined;
    };
    var setItemOffered = function setItemOffered(itemOffered) {
        if (itemOffered) {
            return _extends({}, itemOffered, {
                "@type": "Service"
            });
        }
        return undefined;
    };
    if (offer) {
        return _extends({}, offer, {
            "@type": "Offer",
            priceSpecification: setPriceSpecification(offer.priceSpecification),
            itemOffered: setItemOffered(offer.itemOffered)
        });
    }
    return undefined;
}
function setOpeningHours(openingHours) {
    if (openingHours) {
        return _extends({}, openingHours, {
            "@type": "OpeningHoursSpecification"
        });
    }
    return undefined;
}
var _excluded$q = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "address",
    "geo",
    "rating",
    "review",
    "action",
    "areaServed",
    "makesOffer",
    "openingHours",
    "images"
]));
function LocalBusinessJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "LocalBusiness" : _ref$type, keyOverride = _ref.keyOverride, address = _ref.address, geo = _ref.geo, rating = _ref.rating, review = _ref.review, action = _ref.action, areaServed = _ref.areaServed, makesOffer = _ref.makesOffer, openingHours = _ref.openingHours, images = _ref.images, rest = _objectWithoutPropertiesLoose(_ref, _excluded$q);
    var data = _extends({}, rest, {
        image: images,
        address: setAddress(address),
        geo: setGeo(geo),
        aggregateRating: setAggregateRating(rating),
        review: setReviews(review),
        potentialAction: setAction(action),
        areaServed: areaServed && areaServed.map(setGeoCircle),
        makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
        openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "LocalBusiness"
    }));
}
var _excluded$p = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "mainEntity"
])), _excluded2 = (/* unused pure expression or super */ null && ([
    "upvoteCount"
]));
function QAPageJsonLd(_ref) {
    var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "QAPage" : _ref$type, keyOverride = _ref.keyOverride, mainEntity = _ref.mainEntity, rest = _objectWithoutPropertiesLoose(_ref, _excluded$p);
    var data = _extends({}, rest, {
        mainEntity: _extends({}, mainEntity, {
            "@type": "Question",
            author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
        }, mainEntity.acceptedAnswer && {
            acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
                "@type": "Answer",
                author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
            })
        }, mainEntity.suggestedAnswer && {
            suggestedAnswer: mainEntity.suggestedAnswer.map(function(_ref2) {
                var _rest$author;
                var upvoteCount = _ref2.upvoteCount, rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
                return _extends({}, rest, {
                    "@type": "Answer",
                    upvoteCount: upvoteCount || 0,
                    author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
                });
            })
        })
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "QAPage"
    }));
}
function setItemListElements(items) {
    if (items && items.length) {
        return items.map(function(item) {
            return {
                "@type": "ListItem",
                position: item.position,
                item: {
                    "@id": item.item,
                    name: item.name
                }
            };
        });
    }
    return undefined;
}
var _excluded$o = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "breadcrumb"
]));
function ProfilePageJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "ProfilePage" : _ref$type, keyOverride = _ref.keyOverride, breadcrumb = _ref.breadcrumb, rest = _objectWithoutPropertiesLoose(_ref, _excluded$o);
    var data = _extends({}, rest, {
        breadcrumb: Array.isArray(breadcrumb) ? {
            "@type": "BreadcrumbList",
            itemListElement: setItemListElements(breadcrumb)
        } : breadcrumb
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "ProfilePage"
    }));
}
var _excluded$n = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "potentialActions"
]));
function SiteLinksSearchBoxJsonLd(_ref) {
    var setPotentialAction = function setPotentialAction(action) {
        if (action) {
            var target = action.target, queryInput = action.queryInput;
            return {
                "@type": "SearchAction",
                target: target + "={" + queryInput + "}",
                "query-input": "required name=" + queryInput
            };
        }
        return undefined;
    };
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "WebSite" : _ref$type, keyOverride = _ref.keyOverride, potentialActions = _ref.potentialActions, rest = _objectWithoutPropertiesLoose(_ref, _excluded$n);
    var data = _extends({}, rest, {
        potentialAction: potentialActions.map(setPotentialAction)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "jsonld-siteLinksSearchBox"
    }));
}
var _excluded$m = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "authorName",
    "images",
    "yields",
    "category",
    "cuisine",
    "calories",
    "aggregateRating",
    "video",
    "ingredients",
    "instructions"
]));
function RecipeJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Recipe" : _ref$type, keyOverride = _ref.keyOverride, authorName = _ref.authorName, images = _ref.images, yields = _ref.yields, category = _ref.category, cuisine = _ref.cuisine, calories = _ref.calories, aggregateRating = _ref.aggregateRating, video = _ref.video, ingredients = _ref.ingredients, instructions = _ref.instructions, rest = _objectWithoutPropertiesLoose(_ref, _excluded$m);
    var data = _extends({}, rest, {
        author: setAuthor(authorName),
        image: images,
        recipeYield: yields,
        recipeCategory: category,
        recipeCuisine: cuisine,
        nutrition: setNutrition(calories),
        aggregateRating: setAggregateRating(aggregateRating),
        video: setVideo(video),
        recipeIngredient: ingredients,
        recipeInstructions: instructions ? instructions.map(setInstruction) : undefined
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "recipe"
    }));
}
function setLocation(location) {
    if (!location) {
        return undefined;
    }
    if (typeof location === "string") {
        return location;
    }
    if ("url" in location) {
        return setVirtualLocation(location);
    } else {
        return setPlace(location);
    }
}
function setVirtualLocation(location) {
    return _extends({}, location, {
        "@type": "VirtualLocation"
    });
}
function setPlace(location) {
    return _extends({}, location, {
        address: setAddress(location.address),
        "@type": "Place"
    });
}
var _excluded$l = (/* unused pure expression or super */ null && ([
    "type"
]));
function setPerformer(performer) {
    if (performer) {
        var type = performer.type, restPerformer = _objectWithoutPropertiesLoose(performer, _excluded$l);
        return _extends({}, restPerformer, {
            "@type": type || "PerformingGroup"
        });
    }
    return undefined;
}
var _excluded$k = (/* unused pure expression or super */ null && ([
    "seller"
]));
function setOffers(offers) {
    var mapOffer = function mapOffer(_ref) {
        var seller = _ref.seller, rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
        return _extends({}, rest, {
            "@type": "Offer"
        }, seller && {
            seller: {
                "@type": "Organization",
                name: seller.name
            }
        });
    };
    if (Array.isArray(offers)) {
        return offers.map(mapOffer);
    } else if (offers) {
        return mapOffer(offers);
    }
    return undefined;
}
function setAggregateOffer(aggregateOffer) {
    if (aggregateOffer) {
        return {
            "@type": "AggregateOffer",
            priceCurrency: aggregateOffer.priceCurrency,
            highPrice: aggregateOffer.highPrice,
            lowPrice: aggregateOffer.lowPrice,
            offerCount: aggregateOffer.offerCount,
            offers: setOffers(aggregateOffer.offers)
        };
    }
    return undefined;
}
var _excluded$j = (/* unused pure expression or super */ null && ([
    "type"
]));
function setOrganizer(organizer) {
    if (organizer) {
        var type = organizer.type, restOrganizer = _objectWithoutPropertiesLoose(organizer, _excluded$j);
        return _extends({}, restOrganizer, {
            "@type": type || "Person"
        });
    }
    return undefined;
}
var _excluded$i = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "location",
    "images",
    "offers",
    "aggregateOffer",
    "performers",
    "organizer",
    "eventStatus",
    "eventAttendanceMode"
]));
function EventJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Event" : _ref$type, keyOverride = _ref.keyOverride, location = _ref.location, images = _ref.images, offers = _ref.offers, aggregateOffer = _ref.aggregateOffer, performers = _ref.performers, organizer = _ref.organizer, eventStatus = _ref.eventStatus, eventAttendanceMode = _ref.eventAttendanceMode, rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
    var data = _extends({}, rest, {
        location: setLocation(location),
        image: images,
        offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
        performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
        organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
        eventStatus: eventStatus ? "https://schema.org/" + eventStatus : undefined,
        eventAttendanceMode: eventAttendanceMode ? "https://schema.org/" + eventAttendanceMode : undefined
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "Event"
    }));
}
function setContactPoint(contactPoint) {
    if (contactPoint) {
        return _extends({}, contactPoint, {
            "@type": "ContactPoint"
        });
    }
    return undefined;
}
var _excluded$h = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "contactPoint"
]));
function CorporateContactJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Organization" : _ref$type, keyOverride = _ref.keyOverride, contactPoint = _ref.contactPoint, rest = _objectWithoutPropertiesLoose(_ref, _excluded$h);
    var data = _extends({}, rest, {
        contactPoint: contactPoint.map(setContactPoint)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "CorporateContact"
    }));
}
function setCreativeWork(creativeWork) {
    if (creativeWork) {
        return _extends({}, creativeWork, {
            "@type": "CreativeWork"
        });
    }
    return undefined;
}
var _excluded$g = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "hasPart"
]));
function CollectionPageJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "CollectionPage" : _ref$type, keyOverride = _ref.keyOverride, hasPart = _ref.hasPart, rest = _objectWithoutPropertiesLoose(_ref, _excluded$g);
    var data = _extends({}, rest, {
        hasPart: hasPart.map(setCreativeWork)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "CollectionPage"
    }));
}
function setManufacturer(manufacturer) {
    if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
        return {
            "@type": "Organization",
            name: manufacturer.manufacturerName,
            logo: setImage(manufacturer.manufacturerLogo)
        };
    }
    return undefined;
}
function setBrand(brand) {
    if (brand) {
        return {
            "@type": "Brand",
            name: brand
        };
    }
    return undefined;
}
var _excluded$f = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "images",
    "brand",
    "reviews",
    "aggregateRating",
    "manufacturerLogo",
    "manufacturerName",
    "offers",
    "aggregateOffer",
    "productName"
]));
function ProductJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Product" : _ref$type, keyOverride = _ref.keyOverride, images = _ref.images, brand = _ref.brand, reviews = _ref.reviews, aggregateRating = _ref.aggregateRating, manufacturerLogo = _ref.manufacturerLogo, manufacturerName = _ref.manufacturerName, offers = _ref.offers, aggregateOffer = _ref.aggregateOffer, productName = _ref.productName, rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
    var data = _extends({}, rest, {
        image: images,
        brand: setBrand(brand),
        review: setReviews(reviews),
        aggregateRating: setAggregateRating(aggregateRating),
        manufacturer: setManufacturer({
            manufacturerLogo: manufacturerLogo,
            manufacturerName: manufacturerName
        }),
        offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
        name: productName
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "Product"
    }));
}
var _excluded$e = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "priceCurrency",
    "price",
    "aggregateRating",
    "review"
]));
function SoftwareAppJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "SoftwareApplication" : _ref$type, keyOverride = _ref.keyOverride, priceCurrency = _ref.priceCurrency, price = _ref.price, aggregateRating = _ref.aggregateRating, review = _ref.review, rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
    var data = _extends({}, rest, {
        offers: {
            "@type": "Offer",
            price: price,
            priceCurrency: priceCurrency
        },
        aggregateRating: setAggregateRating(aggregateRating),
        review: setReviews(review)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "SoftwareApp"
    }));
}
var _excluded$d = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride"
]));
function VideoJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Video" : _ref$type, keyOverride = _ref.keyOverride, rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
    var data = setVideo(rest, true);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "Video"
    }));
}
function setProducer(producer) {
    if (producer) {
        return {
            "@type": "Organization",
            sameAs: producer.url,
            name: producer.name
        };
    }
    return undefined;
}
function setProvider(provider) {
    if (provider) {
        return {
            "@type": provider.type || "Organization",
            name: provider.name,
            sameAs: provider.url
        };
    }
    return undefined;
}
var _excluded$c = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "aggregateRating",
    "trailer",
    "reviews",
    "image",
    "authorName",
    "provider",
    "producerName",
    "producerUrl",
    "offers",
    "operatingSystemName",
    "platformName",
    "translatorName",
    "languageName",
    "genreName",
    "publisherName"
]));
function VideoGameJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "VideoGame" : _ref$type, keyOverride = _ref.keyOverride, aggregateRating = _ref.aggregateRating, trailer = _ref.trailer, reviews = _ref.reviews, image = _ref.image, authorName = _ref.authorName, provider = _ref.provider, producerName = _ref.producerName, producerUrl = _ref.producerUrl, offers = _ref.offers, operatingSystemName = _ref.operatingSystemName, platformName = _ref.platformName, translatorName = _ref.translatorName, languageName = _ref.languageName, genreName = _ref.genreName, publisherName = _ref.publisherName, rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
    var data = _extends({}, rest, {
        aggregateRating: setAggregateRating(aggregateRating),
        trailer: setVideo(trailer),
        review: setReviews(reviews),
        image: setImage(image),
        author: setAuthor(authorName),
        provider: setProvider(provider),
        producer: setProducer({
            name: producerName,
            url: producerUrl
        }),
        offers: setOffers(offers),
        operatingSystem: operatingSystemName,
        gamePlatform: platformName,
        translator: translatorName,
        inLanguage: languageName,
        genre: genreName,
        publisher: publisherName
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "VideoGame"
    }));
}
function setContactPoints(contactPoint) {
    if (contactPoint && contactPoint.length) {
        return contactPoint.map(function(contactPoint) {
            return _extends({
                "@type": "ContactPoint"
            }, contactPoint);
        });
    }
    return undefined;
}
var _excluded$b = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "address",
    "contactPoints",
    "contactPoint"
]));
function OrganizationJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Organization" : _ref$type, keyOverride = _ref.keyOverride, address = _ref.address, contactPoints = _ref.contactPoints, contactPoint = _ref.contactPoint, rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
    var data = _extends({}, rest, {
        address: setAddress(address),
        contactPoint: setContactPoints(contactPoint || contactPoints)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "organization"
    }));
}
function setQuestions(questions) {
    if (questions && questions.length) {
        return questions.map(function(question) {
            return {
                "@type": "Question",
                name: question.questionName,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: question.acceptedAnswerText
                }
            };
        });
    }
    return undefined;
}
var _excluded$a = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "mainEntity"
]));
function FAQPageJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "FAQPage" : _ref$type, keyOverride = _ref.keyOverride, mainEntity = _ref.mainEntity, rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
    var data = _extends({}, rest, {
        mainEntity: setQuestions(mainEntity)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "faq-page"
    }));
}
var _excluded$9 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride"
]));
function LogoJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Organization" : _ref$type, keyOverride = _ref.keyOverride, rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, rest, {
        scriptKey: "Logo"
    }));
}
var _excluded$8 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride"
]));
function DatasetJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Dataset" : _ref$type, keyOverride = _ref.keyOverride, rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, rest, {
        scriptKey: "dataset"
    }));
}
var _excluded$7 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "courseName",
    "provider"
]));
function CourseJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Course" : _ref$type, keyOverride = _ref.keyOverride, courseName = _ref.courseName, provider = _ref.provider, rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
    var data = _extends({
        name: courseName
    }, rest, {
        provider: setProvider(provider)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "course"
    }));
}
var _excluded$6 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "itemListElements"
]));
function BreadCrumbJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "BreadcrumbList" : _ref$type, keyOverride = _ref.keyOverride, itemListElements = _ref.itemListElements, rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
    var data = _extends({}, rest, {
        itemListElement: setItemListElements(itemListElements)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "breadcrumb"
    }));
}
var _excluded$5 = (/* unused pure expression or super */ null && ([
    "type",
    "id",
    "keyOverride",
    "aggregateRating"
]));
function BrandJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Brand" : _ref$type, id = _ref.id, keyOverride = _ref.keyOverride, aggregateRating = _ref.aggregateRating, rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
    var data = _extends({
        aggregateRating: setAggregateRating(aggregateRating),
        "@id": id
    }, rest);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "brand"
    }));
}
var _excluded$4 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "url",
    "title",
    "images",
    "datePublished",
    "dateModified",
    "authorName",
    "publisherName",
    "publisherLogo",
    "description",
    "isAccessibleForFree"
]));
function ArticleJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "Article" : _ref$type, keyOverride = _ref.keyOverride, url = _ref.url, title = _ref.title, images = _ref.images, datePublished = _ref.datePublished, dateModified = _ref.dateModified, authorName = _ref.authorName, _ref$publisherName = _ref.publisherName, publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName, _ref$publisherLogo = _ref.publisherLogo, publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo, description = _ref.description, isAccessibleForFree = _ref.isAccessibleForFree, rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
    var data = _extends({
        datePublished: datePublished,
        description: description,
        mainEntityOfPage: {
            "@type": "WebPage",
            "@id": url
        },
        headline: title,
        image: images,
        dateModified: dateModified || datePublished,
        author: setAuthor(authorName),
        publisher: setPublisher(publisherName, publisherLogo),
        isAccessibleForFree: isAccessibleForFree
    }, rest);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "article"
    }));
}
function setReviewedBy(reviewedBy) {
    if (reviewedBy) {
        return _extends({
            "@type": (reviewedBy == null ? void 0 : reviewedBy.type) || "Organization"
        }, reviewedBy);
    }
    return undefined;
}
var _excluded$3 = (/* unused pure expression or super */ null && ([
    "keyOverride",
    "reviewedBy"
]));
function WebPageJsonLd(_ref) {
    var keyOverride = _ref.keyOverride, reviewedBy = _ref.reviewedBy, rest = _objectWithoutPropertiesLoose(_ref, _excluded$3);
    var data = _extends({}, rest, {
        reviewedBy: setReviewedBy(reviewedBy)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        keyOverride: keyOverride
    }, data, {
        type: "WebPage",
        scriptKey: "WebPage"
    }));
}
var _excluded$2 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride"
]));
function SocialProfileJsonLd(_ref) {
    var type = _ref.type, keyOverride = _ref.keyOverride, rest = _objectWithoutPropertiesLoose(_ref, _excluded$2);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, rest, {
        scriptKey: "social"
    }));
}
function setCost(cost) {
    if (cost) {
        return _extends({}, cost, {
            "@type": "MonetaryAmount"
        });
    }
    return undefined;
}
function setSupply(supply) {
    if (supply) {
        return supply.map(function(supplyItem) {
            return {
                "@type": "HowToSupply",
                name: supplyItem
            };
        });
    }
    return undefined;
}
function setTool(tool) {
    if (tool) {
        return tool.map(function(toolItem) {
            return {
                "@type": "HowToTool",
                name: toolItem
            };
        });
    }
    return undefined;
}
function setStep(step) {
    if (step) {
        return step.map(function(stepElement) {
            var itemListElement = stepElement.itemListElement, image = stepElement.image;
            var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function(_ref) {
                var type = _ref.type, text = _ref.text;
                return {
                    "@type": type,
                    text: text
                };
            });
            return _extends({}, stepElement, {
                "@type": "HowToStep",
                itemListElement: currentListElements,
                image: setImage(image)
            });
        });
    }
    return undefined;
}
var _excluded$1 = (/* unused pure expression or super */ null && ([
    "type",
    "keyOverride",
    "image",
    "estimatedCost",
    "supply",
    "tool",
    "step"
]));
function howToJsonLd(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "HowTo" : _ref$type, keyOverride = _ref.keyOverride, image = _ref.image, estimatedCost = _ref.estimatedCost, supply = _ref.supply, tool = _ref.tool, step = _ref.step, rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
    var data = _extends({}, rest, {
        image: setImage(image),
        estimatedCost: setCost(estimatedCost),
        supply: setSupply(supply),
        tool: setTool(tool),
        step: setStep(step)
    });
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({
        type: type,
        keyOverride: keyOverride
    }, data, {
        scriptKey: "howTo"
    }));
}
var _excluded = (/* unused pure expression or super */ null && ([
    "keyOverride",
    "images"
]));
function ImageJsonLd(_ref) {
    var keyOverride = _ref.keyOverride, images = _ref.images, rest = _objectWithoutPropertiesLoose(_ref, _excluded);
    return /*#__PURE__*/ React__default["default"].createElement(JsonLd, _extends({}, rest, {
        type: "ImageObject",
        keyOverride: keyOverride,
        dataArray: images,
        scriptKey: "image"
    }));
}



/***/ }),

/***/ 92317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Button/Button.jsx









var Button = /*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var children = param.children, mods = param.mods, mix = param.mix, tag = param.tag, href = param.href, type = param.type, target = param.target, variant = param.variant, color = param.color, size = param.size, disabled = param.disabled, buttonProps = param.buttonProps, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onMouseDown = param.onMouseDown, onMouseLeave = param.onMouseLeave, id = param.id, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Button, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            color: color,
            size: size,
            variant: variant
        })
    }, true).className;
    var TagName = tag;
    var cn = (0,css/* default */.Z)(className, classNameTail);
    return type === "link" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        ref: ref,
        prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            id: id,
            className: cn,
            target: target
        }, buttonProps), {
            children: [
                variant === "link_external" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "arrow-up",
                    color: [
                        "violet-700"
                    ],
                    size: 16
                }),
                children,
                variant === "link" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                    name: "solid-circle-chevron-right",
                    color: [
                        "violet-700",
                        "#ffffff"
                    ],
                    size: 20
                })
            ]
        }))
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(TagName, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        id: id
    }, type && !href ? {
        type: type
    } : null), {
        className: cn,
        target: target,
        disabled: disabled
    }), buttonProps), {
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseDown: onMouseDown,
        onMouseLeave: onMouseLeave,
        ref: ref,
        children: children
    }));
});
Button.displayName = "Button";
Button.propTypes = {
    buttonProps: (prop_types_default()).object,
    children: (prop_types_default()).node,
    color: (prop_types_default()).string,
    disabled: (prop_types_default()).bool,
    href: (prop_types_default()).string,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    onClick: (prop_types_default()).func,
    onMouseDown: (prop_types_default()).func,
    onMouseEnter: (prop_types_default()).func,
    onMouseLeave: (prop_types_default()).func,
    size: (prop_types_default()).string,
    tag: (prop_types_default()).string,
    target: (prop_types_default()).string,
    type: (prop_types_default()).string,
    variant: (prop_types_default()).string
};
Button.defaultProps = {
    disabled: false,
    mix: {},
    mods: {},
    tag: "button",
    type: "button"
};
/* harmony default export */ var Button_Button = (Button);

;// CONCATENATED MODULE: ./src/components/UI/Button/index.js

/* harmony default export */ var UI_Button = (Button_Button);


/***/ }),

/***/ 37938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_ButtonGroup; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/ButtonGroup/ButtonGroup.jsx






var ButtonGroup = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, direction = param.direction, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(ButtonGroup, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            direction: direction
        })
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
ButtonGroup.displayName = "Button-Group";
ButtonGroup.propTypes = {
    children: (prop_types_default()).node,
    direction: (prop_types_default()).string,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
ButtonGroup.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var ButtonGroup_ButtonGroup = (ButtonGroup);

;// CONCATENATED MODULE: ./src/components/UI/ButtonGroup/index.js

/* harmony default export */ var UI_ButtonGroup = (ButtonGroup_ButtonGroup);


/***/ }),

/***/ 76956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Container/Container.jsx





var Container = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Container, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
Container.displayName = "Container";
Container.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Container.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Container_Container = (Container);

;// CONCATENATED MODULE: ./src/components/UI/Container/index.js

/* harmony default export */ var UI_Container = (Container_Container);


/***/ }),

/***/ 42080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Divider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Divider/Divider.jsx






var Divider = function(param) {
    var mods = param.mods, variant = param.variant, style = param.style;
    var className = (0,useMods/* default */.Z)(Divider, {
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            style: style,
            variant: variant
        })
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className
    });
};
Divider.displayName = "Divider";
Divider.propTypes = {
    mods: (prop_types_default()).object,
    style: (prop_types_default()).string,
    variant: (prop_types_default()).string
};
Divider.defaultProps = {
    mods: {},
    style: "solid",
    variant: "horizontal"
};
/* harmony default export */ var Divider_Divider = (Divider);

;// CONCATENATED MODULE: ./src/components/UI/Divider/index.js

/* harmony default export */ var UI_Divider = (Divider_Divider);


/***/ }),

/***/ 60726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Icon; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-inlinesvg/esm/index.js + 3 modules
var esm = __webpack_require__(97847);
;// CONCATENATED MODULE: ./src/utils/colorScheme.js
/* harmony default export */ var colorScheme = ({
    green: {
        100: "#EBFAF4",
        300: "#ABEAD3",
        500: "#45D7A2",
        650: "#32CD95",
        700: "#33CA94",
        900: "#20C288"
    },
    neutral: {
        100: "#F9F9FD",
        300: "#EFF0F9",
        400: "#DFE1EA",
        450: "#D0D2DC",
        500: "#B0B3C1",
        600: "#7F818F",
        700: "#585668",
        900: "#3D3B4F"
    },
    red: {
        100: "#FFEBE8",
        300: "#FFC8C0",
        500: "#FF7664",
        700: "#FF604A",
        900: "#F95842"
    },
    violet: {
        100: "#F2F3FF",
        300: "#DEDFFF",
        500: "#8C90E3",
        600: "#868BFF",
        700: "#676BD2",
        800: "#7176FB",
        900: "#575BBE"
    },
    yellow: {
        100: "#FFF8DD",
        300: "#FFEFB7",
        500: "#FFD952",
        700: "#FFCD3D",
        900: "#FFC621"
    },
    blue: {
        100: "#CAD5EA",
        500: "#5F94FF",
        700: "#3E8DF6"
    }
});

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__(1469);
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);
;// CONCATENATED MODULE: ./src/components/UI/Icon/IconsSvg.js



var isStartWithHash = function(element) {
    return new RegExp("^#", "g").test(element);
};
var findColorByName = function(colors) {
    if (isArray_default()(colors)) {
        colors.forEach(function(color, index) {
            if (!isStartWithHash(color)) {
                var ref = (0,_sliced_to_array/* default */.Z)(color.split("-"), 2), colorName = ref[0], colorValue = ref[1];
                colors[index] = colorScheme[colorName][colorValue];
            }
        });
    } else {
        if (!isStartWithHash(colors)) {
            var ref = (0,_sliced_to_array/* default */.Z)(colors.split("-"), 2), colorName = ref[0], colorValue = ref[1];
            colors = colorScheme[colorName][colorValue];
        }
        colors = [
            colors,
            colors
        ];
    }
    return colors;
};
var getIcon = function(size, firstColor, secondColor) {
    return {
        "about-us": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M26.096 3.00006C27.1454 3.00541 27.9949 3.89478 28 4.99353C28 7.00653 24.5 9 24.5 9C24.5 9 21 6.97722 21 4.99353C21 3.89258 21.8524 3.00006 22.904 3.00006C23.5477 2.9948 24.1495 3.33378 24.5 3.89907C24.8529 3.33653 25.4532 2.99843 26.096 3.00006ZM6.09599 17.5001C7.14541 17.5054 7.99489 18.3948 8 19.4935C8 21.5065 4.50001 23.5 4.50001 23.5C4.50001 23.5 1 21.4772 1 19.4935C1 18.3926 1.85244 17.5001 2.90401 17.5001C3.5477 17.4948 4.14949 17.8338 4.50001 18.3991C4.85292 17.8365 5.45316 17.4984 6.09599 17.5001ZM29 24.9935C28.9949 23.8948 28.1454 23.0054 27.096 23.0001C26.4532 22.9984 25.8529 23.3365 25.5 23.8991C25.1495 23.3338 24.5477 22.9948 23.904 23.0001C22.8524 23.0001 22 23.8926 22 24.9935C22 26.9772 25.5 29 25.5 29C25.5 29 29 27.0065 29 24.9935Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M4.03017 15.1418C4.4696 8.91544 9.66121 4 16 4C16.884 4 17.7446 4.09542 18.5724 4.27615C19.112 4.39396 19.6449 4.05204 19.7627 3.51247C19.8805 2.97289 19.5386 2.43998 18.999 2.32218C18.032 2.11105 17.0284 2 16 2C8.60382 2 2.54795 7.73477 2.03514 15.001C1.99626 15.5519 2.41134 16.0301 2.96226 16.0689C3.51317 16.1078 3.99129 15.6927 4.03017 15.1418ZM28.6522 9.99948C28.4153 9.50062 27.8187 9.28833 27.3199 9.52531C26.821 9.76229 26.6087 10.3588 26.8457 10.8577C27.5855 12.415 28 14.1577 28 16C28 17.5789 27.6956 19.0842 27.1432 20.4622C26.9377 20.9749 27.1867 21.557 27.6994 21.7625C28.212 21.968 28.7942 21.719 28.9996 21.2064C29.6453 19.5956 30 17.838 30 16C30 13.8546 29.5168 11.8193 28.6522 9.99948ZM7.52856 24.4991C7.13741 24.1092 6.50424 24.1102 6.11435 24.5014C5.72446 24.8925 5.72549 25.5257 6.11664 25.9156C8.64777 28.4386 12.1425 30 16 30C17.6222 30 19.1819 29.7237 20.6335 29.2148C21.1546 29.032 21.429 28.4614 21.2463 27.9402C21.0635 27.4191 20.4929 27.1447 19.9717 27.3274C18.7299 27.7628 17.3937 28 16 28C12.693 28 9.70012 26.6636 7.52856 24.4991ZM10 13C10 12.4477 10.4477 12 11 12C11.5523 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14C13.5523 14 14 13.5523 14 13C14 11.3431 12.6569 10 11 10C9.34317 10 8.00002 11.3431 8.00002 13C8.00002 13.5523 8.44774 14 9.00002 14C9.55231 14 10 13.5523 10 13ZM21 12C20.4477 12 20 12.4477 20 13C20 13.5523 19.5523 14 19 14C18.4477 14 18 13.5523 18 13C18 11.3431 19.3432 10 21 10C22.6569 10 24 11.3431 24 13C24 13.5523 23.5523 14 23 14C22.4477 14 22 13.5523 22 13C22 12.4477 21.5523 12 21 12ZM21.7593 20.6508C22.1187 20.2315 22.0701 19.6002 21.6508 19.2408C21.2315 18.8813 20.6002 18.9299 20.2407 19.3492C18.8936 20.9209 17.4907 21.5403 16.251 21.6952C14.9863 21.8533 13.8099 21.5369 12.9472 21.1056C12.4532 20.8586 11.8526 21.0588 11.6056 21.5528C11.3586 22.0468 11.5588 22.6475 12.0528 22.8944C13.1901 23.4631 14.7637 23.8967 16.499 23.6798C18.2593 23.4598 20.1064 22.5792 21.7593 20.6508Z"/>\n            </svg>\n        '),
        "access-level": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="14" y="6" width="4" height="4" rx="2"/>\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="22" y="14" width="4" height="4" rx="2"/>\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="14" y="22" width="4" height="4" rx="2"/>\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="6" y="6" width="4" height="4" rx="2"/>\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="6" y="14" width="4" height="4" rx="2"/>\n                <rect stroke=').concat(secondColor, ' strokeWidth="2" x="6" y="22" width="4" height="4" rx="2"/>\n                <rect fill=').concat(firstColor, ' x="21" y="5" width="6" height="6" rx="3"/>\n                <rect fill=').concat(firstColor, ' x="13" y="13" width="6" height="6" rx="3"/>\n                <rect fill=').concat(firstColor, ' x="21" y="21" width="6" height="6" rx="3"/>\n            </svg>\n        '),
        "account-manager": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M16 27H22C23.6569 27 25 25.6569 25 24V13C25 8.02944 20.9706 4 16 4C11.0294 4 7 8.02944 7 13V18.5"/>\n                <circle fill=').concat(firstColor, ' cx="16" cy="27" r="2"/>\n                <rect fill=').concat(firstColor, ' x="23" y="13" width="3.75" height="10" rx="1"/>\n                <rect fill=').concat(firstColor, ' x="24.25" y="14.25" width="3.75" height="7.5" rx="1"/>\n                <rect fill=').concat(firstColor, ' width="3.75" height="10" rx="1" transform="matrix(-1 0 0 1 9 13)"/>\n                <rect fill=').concat(firstColor, ' width="3.75" height="7.5" rx="1" transform="matrix(-1 0 0 1 7.75 14.25)"/>\n            </svg>\n        '),
        "activity-tracking": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect stroke=').concat(firstColor, ' strokeWidth="2" x="4" y="14" width="24" height="12" rx="4"/>\n                <circle fill=').concat(firstColor, ' cx="8" cy="18" r="1"/>\n                <circle fill=').concat(firstColor, ' cx="8" cy="22" r="1"/>\n                <circle fill=').concat(firstColor, ' cx="12" cy="18" r="1"/>\n                <circle fill=').concat(firstColor, ' cx="16" cy="18" r="1"/>\n                <circle fill=').concat(secondColor, ' cx="20" cy="18" r="1"/>\n                <circle fill=').concat(firstColor, ' cx="24" cy="18" r="1"/>\n                <circle fill=').concat(firstColor, ' cx="24" cy="22" r="1"/>\n                <rect fill=').concat(secondColor, ' x="11" y="21" width="10" height="2" rx="1"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16 14V11C16 9.89543 16.8954 9 18 9V9C19.1046 9 20 8.10457 20 7V5"/>\n            </svg>\n        '),
        answer: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M4.18262 20.1235C7.18451 22.6255 16.753 22.6255 19.8174 20.1235C22.8818 17.6216 22.5691 6.92572 19.8174 4.11102C17.0657 1.29633 6.93435 1.29633 4.18262 4.11102C1.4309 6.92572 1.11821 17.6216 4.18262 20.1235ZM14.0942 16C14.0105 15.7229 13.9173 15.4382 13.8146 15.1457C13.7118 14.8533 13.611 14.5608 13.5121 14.2684H10.4308C10.3319 14.5608 10.2311 14.8533 10.1284 15.1457C10.0257 15.4382 9.93248 15.7229 9.84879 16H8C8.29672 15.138 8.57822 14.3415 8.84451 13.6104C9.1108 12.8793 9.37137 12.1905 9.62625 11.544C9.88112 10.8975 10.1322 10.2838 10.3795 9.70274C10.6267 9.12169 10.8835 8.55412 11.1498 8H12.8502C13.1089 8.55412 13.3638 9.12169 13.6148 9.70274C13.8659 10.2838 14.1189 10.8975 14.3738 11.544C14.6286 12.1905 14.8892 12.8793 15.1555 13.6104C15.4218 14.3415 15.7033 15.138 16 16H14.0942ZM11.9601 9.81241C11.922 9.92785 11.865 10.0856 11.7889 10.2857C11.7128 10.4858 11.6253 10.7167 11.5264 10.9784C11.4275 11.24 11.3191 11.5286 11.2011 11.8442C11.0832 12.1597 10.9634 12.4906 10.8417 12.8369H13.0899C12.9681 12.4906 12.8502 12.1597 12.7361 11.8442C12.622 11.5286 12.5136 11.24 12.4108 10.9784C12.3081 10.7167 12.2187 10.4858 12.1427 10.2857C12.0666 10.0856 12.0057 9.92785 11.9601 9.81241Z" />\n            </svg>\n        '),
        app: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M18 9.00488H10.5C9.67157 9.00488 9 9.67646 9 10.5049V18.0049C9 18.8333 9.67157 19.5049 10.5 19.5049H18C18.8284 19.5049 19.5 18.8333 19.5 18.0049V10.5049C19.5 9.67646 18.8284 9.00488 18 9.00488ZM10.5 6.00488C8.01472 6.00488 6 8.0196 6 10.5049V18.0049C6 20.4902 8.01472 22.5049 10.5 22.5049H18C20.4853 22.5049 22.5 20.4902 22.5 18.0049V10.5049C22.5 8.0196 20.4853 6.00488 18 6.00488H10.5Z" />\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M18 28.5049H10.5C9.67157 28.5049 9 29.1765 9 30.0049V37.5049C9 38.3333 9.67157 39.0049 10.5 39.0049H18C18.8284 39.0049 19.5 38.3333 19.5 37.5049V30.0049C19.5 29.1765 18.8284 28.5049 18 28.5049ZM10.5 25.5049C8.01472 25.5049 6 27.5196 6 30.0049V37.5049C6 39.9902 8.01472 42.0049 10.5 42.0049H18C20.4853 42.0049 22.5 39.9902 22.5 37.5049V30.0049C22.5 27.5196 20.4853 25.5049 18 25.5049H10.5Z" />\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M39 6.00488H31.5C29.8431 6.00488 28.5 7.34803 28.5 9.00488V16.5049C28.5 18.1617 29.8431 19.5049 31.5 19.5049H39C40.6569 19.5049 42 18.1617 42 16.5049V9.00488C42 7.34803 40.6569 6.00488 39 6.00488ZM31.5 3.00488C28.1863 3.00488 25.5 5.69117 25.5 9.00488V16.5049C25.5 19.8186 28.1863 22.5049 31.5 22.5049H39C42.3137 22.5049 45 19.8186 45 16.5049V9.00488C45 5.69117 42.3137 3.00488 39 3.00488H31.5Z" />\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M37.5 28.5049H30C29.1716 28.5049 28.5 29.1765 28.5 30.0049V37.5049C28.5 38.3333 29.1716 39.0049 30 39.0049H37.5C38.3284 39.0049 39 38.3333 39 37.5049V30.0049C39 29.1765 38.3284 28.5049 37.5 28.5049ZM30 25.5049C27.5147 25.5049 25.5 27.5196 25.5 30.0049V37.5049C25.5 39.9902 27.5147 42.0049 30 42.0049H37.5C39.9853 42.0049 42 39.9902 42 37.5049V30.0049C42 27.5196 39.9853 25.5049 37.5 25.5049H30Z" />\n            </svg>\n        '),
        "arrow-angle-right": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="').concat(firstColor, '" xmlns="http://www.w3.org/2000/svg">\n                <circle fill="evenodd" cx="12" cy="12.001" r="10"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M10.5 8.00098L14.5 12.001L10.5 16.001"/>\n            </svg>\n        '),
        "arrow-up": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M12.25 3.75098H4.75004V5.25098H9.68945L2.79297 12.1475L3.85363 13.2081L10.75 6.31171V11.251H12.25V3.75098Z" />\n            </svg>\n        '),
        attendance: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M12.4955 12.698C11.9432 12.698 11.4955 13.1457 11.4955 13.698C11.4955 14.2503 11.9432 14.698 12.4955 14.698H12.5045C13.0568 14.698 13.5045 14.2503 13.5045 13.698C13.5045 13.1457 13.0568 12.698 12.5045 12.698H12.4955Z" />\n                <path fill=').concat(firstColor, ' d="M7.79431 13.698C7.79431 13.1457 8.24203 12.698 8.79431 12.698H8.80329C9.35558 12.698 9.80329 13.1457 9.80329 13.698C9.80329 14.2503 9.35558 14.698 8.80329 14.698H8.79431C8.24203 14.698 7.79431 14.2503 7.79431 13.698Z" />\n                <path fill=').concat(firstColor, ' d="M8.79431 15.698C8.24203 15.698 7.79431 16.1457 7.79431 16.698C7.79431 17.2503 8.24203 17.698 8.79431 17.698H8.80329C9.35558 17.698 9.80329 17.2503 9.80329 16.698C9.80329 16.1457 9.35558 15.698 8.80329 15.698H8.79431Z" />\n                <path fill=').concat(firstColor, ' d="M20.5692 18.5686C20.8733 18.2874 20.8919 17.8129 20.6106 17.5088C20.3294 17.2047 19.8548 17.1862 19.5508 17.4674L17.9503 18.9477L17.4703 18.4677C17.1774 18.1748 16.7026 18.1748 16.4097 18.4677C16.1168 18.7606 16.1168 19.2355 16.4097 19.5284L17.3997 20.5184C17.6845 20.8032 18.1435 20.8122 18.4392 20.5386L20.5692 18.5686Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M8.5 1.24805C8.91421 1.24805 9.25 1.58383 9.25 1.99805V2.74805H15.75V1.99805C15.75 1.58383 16.0858 1.24805 16.5 1.24805C16.9142 1.24805 17.25 1.58383 17.25 1.99805V2.7783C18.7859 2.90613 20.0038 3.43839 20.8621 4.36271C21.8464 5.42269 22.25 6.88308 22.25 8.49805V16.0898C22.8722 16.894 23.25 17.9002 23.25 18.998C23.25 19.8866 23.0017 20.7307 22.5615 21.4466C21.7406 22.8226 20.232 23.748 18.5 23.748C17.4087 23.748 16.3998 23.3826 15.5965 22.748H8.5C6.60705 22.748 5.13152 22.2034 4.1379 21.1334C3.15363 20.0734 2.75 18.613 2.75 16.998V8.49805C2.75 6.88308 3.15363 5.42269 4.1379 4.36271C4.9962 3.43839 6.21409 2.90613 7.75 2.7783V1.99805C7.75 1.58383 8.08579 1.24805 8.5 1.24805ZM7.75 4.99805V4.28433C6.56502 4.40472 5.76412 4.81582 5.2371 5.38339C4.62127 6.04659 4.27737 7.03274 4.25157 8.33813H20.7484C20.7226 7.03274 20.3787 6.04659 19.7629 5.38339C19.2359 4.81582 18.435 4.40472 17.25 4.28433V4.99805C17.25 5.41226 16.9142 5.74805 16.5 5.74805C16.0858 5.74805 15.75 5.41226 15.75 4.99805V4.24805H9.25V4.99805C9.25 5.41226 8.91421 5.74805 8.5 5.74805C8.08579 5.74805 7.75 5.41226 7.75 4.99805ZM4.25 16.998V9.83813H20.75V14.816L20.7154 14.7975C20.0558 14.4477 19.3024 14.248 18.5 14.248C15.8758 14.248 13.75 16.3738 13.75 18.998C13.75 19.8057 13.9552 20.5767 14.3231 21.248H8.5C6.89295 21.248 5.86848 20.7927 5.2371 20.1127C4.59637 19.4227 4.25 18.3831 4.25 16.998ZM18.5 15.748C19.473 15.748 20.341 16.1765 20.9359 16.8523L20.9368 16.8534C21.4442 17.4353 21.75 18.1819 21.75 18.998C21.75 19.6074 21.5795 20.1814 21.2816 20.6644L21.2754 20.6746C20.7156 21.6158 19.6859 22.248 18.5 22.248C17.6779 22.248 16.9366 21.9484 16.3729 21.4417C16.3661 21.4355 16.3591 21.4294 16.352 21.4234C16.109 21.2196 15.8948 20.9664 15.7278 20.6801L15.7184 20.6644C15.4205 20.1814 15.25 19.6074 15.25 18.998C15.25 17.2023 16.7042 15.748 18.5 15.748Z" />\n            </svg>\n        '),
        "attendance-tracking": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M21 15.0049C21 18.3186 18.3137 21.0049 15 21.0049C11.6863 21.0049 9 18.3186 9 15.0049C9 11.6912 11.6863 9.00488 15 9.00488C18.3137 9.00488 21 11.6912 21 15.0049ZM20.3357 22.2534C22.5582 20.6146 24 17.9781 24 15.0049C24 10.0343 19.9706 6.00488 15 6.00488C10.0294 6.00488 6 10.0343 6 15.0049C6 17.9781 7.44177 20.6146 9.66432 22.2534C5.71434 24.2175 3 28.2942 3 33.0049V40.5049C3 41.3333 3.67157 42.0049 4.5 42.0049C5.32843 42.0049 6 41.3333 6 40.5049V33.0049C6 28.0343 10.0294 24.0049 15 24.0049C19.9706 24.0049 24 28.0343 24 33.0049V40.5049C24 41.3333 24.6716 42.0049 25.5 42.0049C26.3284 42.0049 27 41.3333 27 40.5049V33.0049C27 28.2942 24.2857 24.2175 20.3357 22.2534Z" />\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M30 21.0049C30 20.1765 30.6716 19.5049 31.5 19.5049H36C36.8284 19.5049 37.5 20.1765 37.5 21.0049C37.5 21.8333 36.8284 22.5049 36 22.5049H31.5C30.6716 22.5049 30 21.8333 30 21.0049Z" />\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M31.5 13.5049C32.3284 13.5049 33 14.1765 33 15.0049V21.0049C33 21.8333 32.3284 22.5049 31.5 22.5049C30.6716 22.5049 30 21.8333 30 21.0049V15.0049C30 14.1765 30.6716 13.5049 31.5 13.5049Z" />\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M31.5117 10.5166C29.8094 10.5166 28.2059 10.9205 26.7876 11.6364C26.048 12.0097 25.1459 11.7128 24.7726 10.9733C24.3993 10.2337 24.6962 9.33157 25.4357 8.95827C27.2637 8.03561 29.3292 7.5166 31.5117 7.5166C38.9675 7.5166 45.0117 13.5608 45.0117 21.0166C45.0117 28.4724 38.9675 34.5166 31.5117 34.5166C31.0571 34.5166 30.6073 34.4941 30.1635 34.45C29.3391 34.3682 28.7371 33.6335 28.819 32.8091C28.9008 31.9848 29.6355 31.3828 30.4599 31.4647C30.8054 31.499 31.1562 31.5166 31.5117 31.5166C37.3106 31.5166 42.0117 26.8156 42.0117 21.0166C42.0117 15.2176 37.3106 10.5166 31.5117 10.5166Z" />\n            </svg>\n        '),
        audit: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M12 9.00586C10.3431 9.00586 9 10.349 9 12.0059V39.0059C9 40.6627 10.3431 42.0059 12 42.0059H36C37.6569 42.0059 39 40.6627 39 39.0059V12.0059C39 10.349 37.6569 9.00586 36 9.00586H35.25C34.4216 9.00586 33.75 8.33429 33.75 7.50586C33.75 6.67743 34.4216 6.00586 35.25 6.00586H36C39.3137 6.00586 42 8.69215 42 12.0059V39.0059C42 42.3196 39.3137 45.0059 36 45.0059H12C8.68629 45.0059 6 42.3196 6 39.0059V12.0059C6 8.69215 8.68629 6.00586 12 6.00586H12.75C13.5784 6.00586 14.25 6.67743 14.25 7.50586C14.25 8.33429 13.5784 9.00586 12.75 9.00586H12Z" />\n                <path fill=').concat(secondColor, ' d="M16.5 6.00586C16.5 4.34901 17.8431 3.00586 19.5 3.00586H28.5C30.1569 3.00586 31.5 4.34901 31.5 6.00586C31.5 7.66271 30.1569 9.00586 28.5 9.00586H19.5C17.8431 9.00586 16.5 7.66271 16.5 6.00586Z" />\n                <path fill=').concat(secondColor, ' d="M22.2438 31.2747C22.1006 31.4231 21.9052 31.5059 21.7023 31.5059C21.4994 31.5059 21.304 31.4231 21.1609 31.2747L16.8366 26.8187C16.3878 26.3564 16.3878 25.6066 16.8366 25.1452L17.378 24.5871C17.8269 24.1248 18.5538 24.1248 19.0026 24.5871L21.7023 27.3688L28.9974 19.8526C29.4463 19.3903 30.1739 19.3903 30.622 19.8526L31.1634 20.4106C31.6122 20.873 31.6122 21.6226 31.1634 22.0842L22.2438 31.2747Z" />\n            </svg>\n        '),
        atom: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\n                <circle fill=').concat(firstColor, ' cx="16.1243" cy="16" r="2"/>\n                <circle fill=').concat(firstColor, ' cx="19" cy="5" r="2"/>\n                <circle fill=').concat(firstColor, ' cx="25" cy="24" r="2"/>\n                <circle fill=').concat(firstColor, ' cx="5" cy="19" r="2"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M16.3438 2.0092C16.2709 2.00308 16.1978 2 16.1243 2C14.1508 2 12.3999 4.22309 11.3064 7.65455C7.78763 6.88569 4.9867 7.29045 3.99992 8.99959C2.59153 11.439 5.33208 15.7503 10.2985 19.363C10.4115 20.4325 10.5772 21.4535 10.7888 22.4103C10.3178 22.5106 9.86559 22.5864 9.43561 22.6376C8.31098 22.7718 7.42489 22.7281 6.7888 22.5788C6.25055 22.8483 5.64303 23 5.00009 23C4.62633 23 4.26455 22.9487 3.92139 22.8529C3.94598 22.9025 3.97219 22.9514 4.00001 22.9996C4.98675 24.7087 7.78755 25.1135 11.3061 24.3447C12.3996 27.7766 14.1507 30 16.1243 30C18.9411 30 21.3046 25.4707 21.95 19.3631C22.8196 18.7305 23.621 18.0765 24.3438 17.4149C24.6662 17.7726 24.958 18.1264 25.2174 18.4732C25.6973 19.1147 26.0405 19.6974 26.2671 20.2049C27.2622 20.537 28.0833 21.2495 28.5577 22.1699C28.8888 20.4999 27.8211 18.2624 25.7604 15.9996C28.1856 13.3368 29.2355 10.7087 28.2487 8.99959C26.8403 6.56018 21.7363 6.77793 16.1243 9.27266C15.1417 8.83584 14.1746 8.46884 13.2403 8.17368C13.3889 7.71578 13.5494 7.2863 13.7199 6.88834C14.1381 5.91261 14.5868 5.19647 15.0098 4.71837C15.0846 3.64237 15.585 2.68359 16.3438 2.0092ZM18.5115 10.4583C18.7157 10.5705 18.92 10.6855 19.1243 10.8034C21.1251 11.9586 22.8928 13.2561 24.3438 14.5844C24.6662 14.2266 24.958 13.8728 25.2175 13.526C25.9465 12.5516 26.36 11.713 26.5284 11.0674C26.6938 10.4334 26.5927 10.1313 26.5167 9.99959C26.4406 9.86787 26.2296 9.62925 25.5978 9.45551C24.9545 9.27857 24.0215 9.21742 22.8131 9.36154C21.5427 9.51306 20.0776 9.87832 18.5115 10.4583ZM22.9276 15.9996C21.612 14.8049 19.9897 13.6125 18.1243 12.5355C16.2589 11.4585 14.4152 10.6497 12.7227 10.1078C12.3458 11.8446 12.1243 13.8459 12.1243 16C12.1243 18.1538 12.3457 20.1549 12.7225 21.8915C14.4151 21.3495 16.2589 20.5407 18.1244 19.4637C19.9897 18.3867 21.612 17.1944 22.9276 15.9996ZM13.24 23.8256C13.3887 24.2838 13.5493 24.7135 13.7199 25.1117C14.1993 26.2302 14.7187 27.0076 15.1937 27.4763C15.66 27.9366 15.9722 28 16.1243 28C16.2764 28 16.5885 27.9366 17.0549 27.4763C17.5298 27.0076 18.0492 26.2302 18.5286 25.1117C19.0327 23.9356 19.4489 22.4841 19.7297 20.8377C19.5304 20.9584 19.3286 21.0778 19.1244 21.1957C17.1235 22.3509 15.1159 23.2331 13.24 23.8256ZM9.43552 9.36154C9.86558 9.41283 10.3179 9.48861 10.7889 9.58892C10.3641 11.5098 10.1243 13.6895 10.1243 16C10.1243 16.2357 10.1268 16.47 10.1317 16.7029C8.84642 15.6366 7.79761 14.5505 7.03117 13.526C6.30218 12.5516 5.88865 11.713 5.72019 11.0674C5.55479 10.4334 5.65592 10.1313 5.73197 9.99959C5.80802 9.86787 6.01905 9.62925 6.65079 9.45551C7.29418 9.27857 8.22716 9.21742 9.43552 9.36154Z"/>\n            </svg>\n        '),
        blog: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M8 8.33887C6.34315 8.33887 5 9.68201 5 11.3389V24.5555C5 24.8689 5.09276 25.1752 5.2666 25.436C5.78301 26.2106 6.85208 26.3766 7.57904 25.795L10.1209 23.7615C10.4629 23.4879 10.8878 23.3389 11.3257 23.3389H23C24.6569 23.3389 26 21.9957 26 20.3389V15.5C26 14.9477 26.4477 14.5 27 14.5C27.5523 14.5 28 14.9477 28 15.5V20.3389C28 23.1003 25.7614 25.3389 23 25.3389H11.3508L8.82843 27.3568C7.18555 28.671 4.76954 28.2959 3.6025 26.5454C3.20964 25.9561 3 25.2637 3 24.5555V11.3389C3 8.57744 5.23858 6.33887 8 6.33887H17C17.5523 6.33887 18 6.78658 18 7.33887C18 7.89115 17.5523 8.33887 17 8.33887H8Z"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M25.3284 3.06081C26.6952 1.69398 28.9113 1.69398 30.2782 3.06081C31.645 4.42765 31.645 6.64372 30.2782 8.01056L23.7193 14.5694C22.4512 15.8376 20.9343 16.8296 19.2641 17.4831L17.9219 18.0084C16.2977 18.6439 14.6951 17.0412 15.3306 15.4171L15.8558 14.0748C16.5094 12.4047 17.5014 10.8878 18.7696 9.61963L25.3284 3.06081ZM28.8639 4.47502C28.2782 3.88924 27.3284 3.88924 26.7426 4.47503L20.1838 11.0338C19.1107 12.1069 18.2713 13.3904 17.7183 14.8036L17.1931 16.1459L18.5353 15.6207C19.9486 15.0677 21.2321 14.2282 22.3051 13.1552L28.8639 6.59635C29.4497 6.01056 29.4497 5.06081 28.8639 4.47502Z"/>\n                <rect fill=').concat(firstColor, ' x="7" y="12" width="6" height="2" rx="1"/>\n                <rect fill=').concat(firstColor, ' x="7" y="16" width="6" height="2" rx="1"/>\n            </svg>\n        '),
        "burger-close": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n                <rect x="6.10046" y="24.4854" width="26" height="2" rx="1" transform="rotate(-45 6.10046 24.4854)"/>\n                <rect x="7.51465" y="6.10059" width="26" height="2" rx="1" transform="rotate(45 7.51465 6.10059)"/>\n            </svg>\n        '),
        "burger-open": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n                <rect x="3" y="8" width="26" height="2" rx="1"/>\n                <rect x="3" y="15" width="26" height="2" rx="1"/>\n                <rect x="3" y="22" width="26" height="2" rx="1"/>\n            </svg>\n        '),
        businesses: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16 16.0008L8.92889 8.92969"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinejoin="round" d="M10.0691 10.0684L5.90301 5.90231L7.78863 2.13107L11.9548 6.29721L10.0691 10.0684Z"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinejoin="round" d="M10.0692 10.0686L5.90304 5.90246L2.1318 7.78808L6.29795 11.9542L10.0692 10.0686Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M3.30276 13.2027C2.38481 17.3876 3.55304 21.9382 6.80744 25.1926C11.8843 30.2694 20.1154 30.2694 25.1922 25.1926C30.269 20.1158 30.269 11.8847 25.1922 6.80786C21.9378 3.55346 17.3872 2.38523 13.2023 3.30318L14.9493 5.05022C18.1034 4.7494 21.3626 5.80668 23.778 8.22207C28.0738 12.5178 28.0738 19.4827 23.778 23.7784C19.4822 28.0742 12.5174 28.0742 8.22165 23.7784C5.80626 21.363 4.74898 18.1038 5.0498 14.9497L3.30276 13.2027ZM7.13874 14.4206C6.64271 17.2173 7.47508 20.2034 9.63587 22.3642C13.1506 25.8789 18.8491 25.8789 22.3638 22.3642C25.8785 18.8495 25.8785 13.151 22.3638 9.63628C20.203 7.4755 17.2169 6.64313 14.4202 7.13916L13.4072 9.16503L13.6477 9.40551C16.1144 8.52764 18.9751 9.07597 20.9496 11.0505C23.6832 13.7842 23.6832 18.2163 20.9496 20.95C18.2159 23.6837 13.7837 23.6837 11.0501 20.95C9.07556 18.9755 8.52723 16.1148 9.40509 13.6481L9.16461 13.4077L7.13874 14.4206ZM12.4643 19.5358C11.3076 18.3791 10.8361 16.7966 11.0498 15.2929L13.8785 18.1216C15.0501 19.2931 16.9496 19.2931 18.1211 18.1216C19.2927 16.95 19.2927 15.0505 18.1211 13.8789L15.2925 11.0502C16.7962 10.8365 18.3787 11.308 19.5354 12.4647C21.488 14.4173 21.488 17.5832 19.5354 19.5358C17.5827 21.4884 14.4169 21.4884 12.4643 19.5358Z"/>\n            </svg>\n        '),
        "card": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' d="M2 8.50977H22" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n                <path stroke=').concat(firstColor, ' d="M6 16.5098H8" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n                <path stroke=').concat(firstColor, ' d="M10.5 16.5098H14.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n                <path stroke=').concat(firstColor, ' d="M6.44 3.50977H17.55C21.11 3.50977 22 4.38977 22 7.89977V16.1098C22 19.6198 21.11 20.4998 17.56 20.4998H6.44C2.89 20.5098 2 19.6298 2 16.1198V7.89977C2 4.38977 2.89 3.50977 6.44 3.50977Z" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>\n            </svg>\n        '),
        "caret-down": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M16.8802 9.95737L13.1736 14.7057C13.1027 14.7963 13.0038 14.871 12.8862 14.9229C12.7686 14.9747 12.6362 15.002 12.5016 15.002C12.367 15.002 12.2346 14.9747 12.117 14.9229C11.9994 14.871 11.9004 14.7963 11.8295 14.7057L8.11822 9.95737C8.04409 9.86247 8.00335 9.7536 8.0002 9.64203C7.99705 9.53047 8.03161 9.42027 8.10031 9.32283C8.16901 9.2254 8.26934 9.14428 8.39093 9.08786C8.51251 9.03144 8.65093 9.00178 8.79185 9.00195H16.2081C16.3491 9.00178 16.4875 9.03144 16.6091 9.08786C16.7307 9.14428 16.831 9.2254 16.8997 9.32283C16.9684 9.42027 17.003 9.53047 16.9998 9.64203C16.9967 9.7536 16.9559 9.86247 16.8818 9.95737H16.8802Z"/>\n            </svg>\n        '),
        "caret-right": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M6.63695 5.07986L9.80248 7.55091C9.86288 7.59818 9.91273 7.66415 9.94729 7.74255C9.98186 7.82096 10 7.90921 10 7.99895C10 8.08868 9.98186 8.17693 9.94729 8.25534C9.91273 8.33375 9.86288 8.39971 9.80248 8.44698L6.63695 10.9212C6.57368 10.9706 6.5011 10.9978 6.42672 10.9999C6.35234 11.002 6.27888 10.9789 6.21392 10.9331C6.14896 10.8873 6.09488 10.8204 6.05727 10.7394C6.01966 10.6583 5.99989 10.566 6 10.4721L6 5.5279C5.99989 5.43395 6.01966 5.34167 6.05727 5.26062C6.09488 5.17956 6.14896 5.11267 6.21392 5.06687C6.27888 5.02108 6.35234 4.99803 6.42672 5.00013C6.5011 5.00223 6.57368 5.02939 6.63695 5.07881L6.63695 5.07986Z"/>\n            </svg>\n        '),
        chart: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M15.9907 2.2384C14.323 1.7503 12.9381 1.67912 11.9719 2.37447C10.9917 3.07993 10.75 4.34832 10.75 5.67821V8.55821C10.75 9.85871 11.0129 10.9405 11.6928 11.6952C12.3886 12.4676 13.3836 12.7482 14.5 12.7482H17.82C19.1499 12.7482 20.4183 12.5065 21.1237 11.5263C21.8191 10.5601 21.7479 9.17523 21.2598 7.50753C20.5379 5.0529 18.4453 2.96035 15.9907 2.2384ZM12.25 5.67821C12.25 4.40809 12.5083 3.83649 12.8481 3.59194C13.2019 3.33732 13.9569 3.20614 15.5689 3.67789C17.534 4.25607 19.2423 5.96451 19.8204 7.92959C20.2921 9.5414 20.1609 10.2963 19.9063 10.6501C19.6617 10.9899 19.0901 11.2482 17.82 11.2482H14.5C13.6164 11.2482 13.1114 11.0288 12.8072 10.6912C12.4871 10.3359 12.25 9.69771 12.25 8.55821V5.67821Z" />\n                <path fill=').concat(firstColor, ' d="M8.90978 4.74308C9.31565 4.66033 9.57757 4.26422 9.49482 3.85836C9.41206 3.4525 9.01596 3.19057 8.61009 3.27333C3.61914 4.291 0.00345111 9.09742 0.879478 14.5374L0.879777 14.5393C1.55168 18.6465 4.8505 21.9467 8.95973 22.6085C14.4224 23.4955 19.2288 19.8567 20.2353 14.8459C20.3168 14.4398 20.0537 14.0445 19.6476 13.9629C19.2415 13.8813 18.8462 14.1444 18.7646 14.5505C17.9111 18.7997 13.8375 21.8809 9.20015 21.1279L9.19912 21.1277C5.72911 20.5692 2.9286 17.77 2.36024 14.298C1.61686 9.6784 4.68104 5.60534 8.90978 4.74308Z" />\n            </svg>\n        '),
        check: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M8.25 13.0098C8.25 12.5956 8.58579 12.2598 9 12.2598H12C12.4142 12.2598 12.75 12.5956 12.75 13.0098C12.75 13.424 12.4142 13.7598 12 13.7598H9C8.58579 13.7598 8.25 13.424 8.25 13.0098Z"/>\n                <path fill=').concat(firstColor, ' d="M9 8.25977C8.58579 8.25977 8.25 8.59555 8.25 9.00977C8.25 9.42398 8.58579 9.75977 9 9.75977H12C12.4142 9.75977 12.75 9.42398 12.75 9.00977C12.75 8.59555 12.4142 8.25977 12 8.25977H9Z" />\n                <path fill=').concat(firstColor, ' d="M4.99561 13C4.99561 12.4477 5.44332 12 5.99561 12H6.00459C6.55687 12 7.00459 12.4477 7.00459 13C7.00459 13.5523 6.55687 14 6.00459 14H5.99561C5.44332 14 4.99561 13.5523 4.99561 13Z" />\n                <path fill=').concat(firstColor, ' d="M5.99561 8C5.44332 8 4.99561 8.44772 4.99561 9C4.99561 9.55229 5.44332 10 5.99561 10H6.00459C6.55687 10 7.00459 9.55229 7.00459 9C7.00459 8.44772 6.55687 8 6.00459 8H5.99561Z"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M6 1.25C4.34646 1.25 3.11215 1.74912 2.30736 2.68106C1.52033 3.59244 1.25 4.79713 1.25 6V21C1.25 22.4434 2.89266 23.2743 4.05084 22.3994L4.05289 22.3978L5.76 21.12C5.85765 21.0468 6.00044 21.0516 6.09967 21.1503L7.75808 22.8187L7.75967 22.8203C8.44256 23.5032 9.55744 23.5032 10.2403 22.8203L11.9203 21.1403C12.0086 21.0521 12.1465 21.0482 12.2327 21.1145L13.9506 22.4004L13.9529 22.4022C15.1035 23.2564 16.75 22.4418 16.75 21V11.75H19.42C20.3706 11.75 21.2197 11.446 21.8328 10.8328C22.446 10.2197 22.75 9.37056 22.75 8.42V6C22.75 4.69125 22.214 3.50518 21.364 2.64334L21.3603 2.63967C20.5033 1.78264 19.3161 1.26186 18.0269 1.25003L18.02 1.25L18.0069 1.25003L18 1.25H6ZM16.75 4.01V10.25H19.42C20.0494 10.25 20.4903 10.054 20.7722 9.77217C21.054 9.4903 21.25 9.04943 21.25 8.42V6C21.25 5.10967 20.8867 4.29651 20.2979 3.69852C19.7158 3.11742 18.9052 2.75912 18.0168 2.75C17.3176 2.75174 16.75 3.32011 16.75 4.01ZM15.25 4C15.25 3.55044 15.3589 3.12542 15.5517 2.75H6C4.65354 2.75 3.88785 3.14588 3.44264 3.66144C2.97967 4.19756 2.75 4.99287 2.75 6V21C2.75 21.2157 2.98539 21.3247 3.14711 21.2022L3.15056 21.1996L4.86 19.92C5.56217 19.3934 6.53959 19.4689 7.16033 20.0897L7.16192 20.0913L8.82033 21.7597C8.91751 21.8563 9.08274 21.8566 9.17967 21.7597L10.8597 20.0797C11.4701 19.4693 12.4493 19.3922 13.1428 19.9221L14.8471 21.1978L14.8479 21.1984C15.0173 21.3232 15.25 21.1979 15.25 21V4Z"/>\n            </svg>\n        '),
        "chevron-down": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" d="M14 5L8 11L2 5"/>\n            </svg>\n        '),
        "chevron-right": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M5 13.9485L10.9104 8L5 2.05155L6.04482 0.999999L13 8L6.04482 15L5 13.9485Z"/>\n            </svg>\n        '),
        close: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M11.9998 13.0616L17.8334 18.8953L18.8941 17.8346L13.0604 12.001L18.894 6.16735L17.8334 5.10669L11.9998 10.9403L6.16613 5.10669L5.10547 6.16735L10.9391 12.001L5.10547 17.8346L6.16613 18.8953L11.9998 13.0616Z"/>\n            </svg>\n        '),
        collapse: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M10.5 13.5066L3 13.5066L10.5 21.0066L10.5 13.5066Z" />\n                <path fill=').concat(firstColor, ' d="M13.5 10.5066H21L13.5 3.00659V10.5066Z" />\n            </svg>\n        '),
        "cost": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M23.2958 9.05338C22.951 9.40281 22.9023 9.63794 22.9023 9.75488C22.9023 10.5833 22.2308 11.2549 21.4023 11.2549C20.5739 11.2549 19.9023 10.5833 19.9023 9.75488C19.9023 8.62495 20.442 7.67414 21.1606 6.94604C21.8725 6.22475 22.828 5.64489 23.8896 5.19066C26.0181 4.27994 28.8529 3.75488 31.9023 3.75488C34.9518 3.75488 37.7865 4.27994 39.9151 5.19066C40.9767 5.64489 41.9322 6.22475 42.6441 6.94604C43.3627 7.67414 43.9023 8.62495 43.9023 9.75488C43.9023 10.5833 43.2308 11.2549 42.4023 11.2549C41.5739 11.2549 40.9023 10.5833 40.9023 9.75488C40.9023 9.63794 40.8537 9.40281 40.5089 9.05338C40.1573 8.69713 39.5741 8.30785 38.7349 7.9488C37.0619 7.23295 34.6466 6.75488 31.9023 6.75488C29.158 6.75488 26.7428 7.23295 25.0697 7.9488C24.2306 8.30785 23.6474 8.69713 23.2958 9.05338Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M21.4023 8.25488C22.2308 8.25488 22.9023 8.92646 22.9023 9.75488C22.9023 9.87182 22.951 10.107 23.2958 10.4564C23.6474 10.8126 24.2306 11.2019 25.0697 11.561C26.7428 12.2768 29.158 12.7549 31.9023 12.7549C34.6466 12.7549 37.0619 12.2768 38.7349 11.561C39.5741 11.2019 40.1573 10.8126 40.5089 10.4564C40.8537 10.107 40.9023 9.87182 40.9023 9.75488C40.9023 8.92646 41.5739 8.25488 42.4023 8.25488C43.2308 8.25488 43.9023 8.92646 43.9023 9.75488C43.9023 10.8848 43.3627 11.8356 42.6441 12.5637C41.9322 13.285 40.9767 13.8649 39.9151 14.3191C37.7865 15.2298 34.9518 15.7549 31.9023 15.7549C28.8529 15.7549 26.0181 15.2298 23.8896 14.3191C22.828 13.8649 21.8725 13.285 21.1606 12.5637C20.442 11.8356 19.9023 10.8848 19.9023 9.75488C19.9023 8.92646 20.5739 8.25488 21.4023 8.25488Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M21.4023 14.2549C22.2308 14.2549 22.9023 14.9265 22.9023 15.7549C22.9023 15.8718 22.951 16.107 23.2958 16.4564C23.6474 16.8126 24.2306 17.2019 25.0697 17.561C26.7428 18.2768 29.158 18.7549 31.9023 18.7549C34.6466 18.7549 37.0619 18.2768 38.7349 17.561C39.5741 17.2019 40.1573 16.8126 40.5089 16.4564C40.8537 16.107 40.9023 15.8718 40.9023 15.7549C40.9023 14.9265 41.5739 14.2549 42.4023 14.2549C43.2308 14.2549 43.9023 14.9265 43.9023 15.7549C43.9023 16.8848 43.3627 17.8356 42.6441 18.5637C41.9322 19.285 40.9767 19.8649 39.9151 20.3191C37.7865 21.2298 34.9518 21.7549 31.9023 21.7549C28.8529 21.7549 26.0181 21.2298 23.8896 20.3191C22.828 19.8649 21.8725 19.285 21.1606 18.5637C20.442 17.8356 19.9023 16.8848 19.9023 15.7549C19.9023 14.9265 20.5739 14.2549 21.4023 14.2549Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M42.4022 20.2549C43.2306 20.2549 43.9022 20.9265 43.9022 21.7549C43.9022 23.0137 43.1533 23.9894 42.3437 24.665C41.5164 25.3554 40.4194 25.9153 39.2257 26.3573C36.8262 27.2457 34.4012 27.665 31.3516 27.665C30.5231 27.665 29.8516 26.9935 29.8516 26.165C29.8516 25.3366 30.5231 24.665 31.3516 24.665C34.0957 24.665 36.1619 24.2927 38.184 23.544C39.2011 23.1674 39.9528 22.7528 40.4215 22.3617C40.6518 22.1695 40.7793 22.0114 40.8443 21.9016C40.9031 21.8021 40.9023 21.7581 40.9022 21.755C40.9022 20.9266 41.5738 20.2549 42.4022 20.2549Z" />\n                <path fill=').concat(firstColor, '  fillRule="evenodd" clipRule="evenodd" d="M21.4023 8.25488C22.2308 8.25488 22.9023 8.92646 22.9023 9.75488V14.2549C22.9023 15.0833 22.2308 15.7549 21.4023 15.7549C20.5739 15.7549 19.9023 15.0833 19.9023 14.2549V9.75488C19.9023 8.92646 20.5739 8.25488 21.4023 8.25488Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M21.4023 12.7549C22.2308 12.7549 22.9023 13.4265 22.9023 14.2549V21.7549C22.9023 22.5833 22.2308 23.2549 21.4023 23.2549C20.5739 23.2549 19.9023 22.5833 19.9023 21.7549V14.2549C19.9023 13.4265 20.5739 12.7549 21.4023 12.7549Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M42.4023 8.25488C43.2308 8.25488 43.9023 8.92646 43.9023 9.75488V14.2549C43.9023 15.0833 43.2308 15.7549 42.4023 15.7549C41.5739 15.7549 40.9023 15.0833 40.9023 14.2549V9.75488C40.9023 8.92646 41.5739 8.25488 42.4023 8.25488Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M42.4023 12.7549C43.2308 12.7549 43.9023 13.4265 43.9023 14.2549V28.127C43.9023 28.9554 43.2308 29.627 42.4023 29.627C41.5739 29.627 40.9023 28.9554 40.9023 28.127V14.2549C40.9023 13.4265 41.5739 12.7549 42.4023 12.7549Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M42.4032 26.2549C43.2316 26.2549 43.9032 26.9265 43.9032 27.7549C43.9032 28.8848 43.3635 29.8356 42.6449 30.5637C41.9331 31.285 40.9775 31.8649 39.9159 32.3191C37.7874 33.2298 35.787 33.7345 32.7376 33.7345C32.2108 33.7345 31.7022 33.7142 31.193 33.6735C30.3672 33.6074 29.7513 32.8845 29.8174 32.0587C29.8834 31.2329 30.6064 30.617 31.4322 30.6831C31.8605 30.7173 32.2893 30.7345 32.7376 30.7345C35.4819 30.7345 37.0628 30.2768 38.7358 29.561C39.575 29.2019 40.1581 28.8126 40.5097 28.4564C40.8546 28.107 40.9032 27.8718 40.9032 27.7549C40.9032 26.9265 41.5748 26.2549 42.4032 26.2549Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M7.49042 25.5569C7.14524 25.9067 7.09766 26.1408 7.09766 26.2549C7.09766 26.369 7.14524 26.6031 7.49042 26.9528C7.84196 27.309 8.42501 27.6986 9.26391 28.0581C10.9364 28.7749 13.3514 29.2549 16.0977 29.2549C18.8439 29.2549 21.2589 28.7749 22.9314 28.0581C23.7703 27.6986 24.3534 27.309 24.7049 26.9528C25.0501 26.6031 25.0977 26.369 25.0977 26.2549C25.0977 26.1408 25.0501 25.9067 24.7049 25.5569C24.3534 25.2007 23.7703 24.8111 22.9314 24.4516C21.2589 23.7348 18.8439 23.2549 16.0977 23.2549C13.3514 23.2549 10.9364 23.7348 9.26391 24.4516C8.42501 24.8111 7.84196 25.2007 7.49042 25.5569ZM8.08216 21.6942C10.2099 20.7823 13.0449 20.2549 16.0977 20.2549C19.1504 20.2549 21.9854 20.7823 24.1132 21.6942C25.1744 22.149 26.129 22.7291 26.8401 23.4496C27.5576 24.1766 28.0977 25.1263 28.0977 26.2549C28.0977 27.3834 27.5576 28.3331 26.8401 29.0601C26.129 29.7807 25.1744 30.3608 24.1132 30.8156C21.9854 31.7275 19.1504 32.2549 16.0977 32.2549C13.0449 32.2549 10.2099 31.7275 8.08216 30.8156C7.02093 30.3608 6.0663 29.7807 5.35518 29.0601C4.63769 28.3331 4.09766 27.3834 4.09766 26.2549C4.09766 25.1263 4.63769 24.1766 5.35518 23.4496C6.0663 22.7291 7.02093 22.149 8.08216 21.6942Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M5.59766 30.7549C6.42608 30.7549 7.09766 31.4265 7.09766 32.2549C7.09766 32.3718 7.14626 32.607 7.49114 32.9564C7.84274 33.3126 8.42589 33.7019 9.26506 34.061C10.9381 34.7768 13.3534 35.2549 16.0977 35.2549C18.842 35.2549 21.2572 34.7768 22.9303 34.061C23.7694 33.7019 24.3526 33.3126 24.7042 32.9564C25.049 32.607 25.0977 32.3718 25.0977 32.2549C25.0977 31.4265 25.7692 30.7549 26.5977 30.7549C27.4261 30.7549 28.0977 31.4265 28.0977 32.2549C28.0977 33.3848 27.558 34.3356 26.8394 35.0637C26.1275 35.785 25.172 36.3649 24.1104 36.8191C21.9819 37.7298 19.1471 38.2549 16.0977 38.2549C13.0482 38.2549 10.2135 37.7298 8.08494 36.8191C7.02332 36.3649 6.0678 35.785 5.35593 35.0637C4.63733 34.3356 4.09766 33.3848 4.09766 32.2549C4.09766 31.4265 4.76923 30.7549 5.59766 30.7549Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M5.59766 36.7549C6.42608 36.7549 7.09766 37.4265 7.09766 38.2549C7.09766 38.3718 7.14626 38.607 7.49114 38.9564C7.84274 39.3126 8.42589 39.7019 9.26506 40.061C10.9381 40.7768 13.3534 41.2549 16.0977 41.2549C18.842 41.2549 21.2572 40.7768 22.9303 40.061C23.7694 39.7019 24.3526 39.3126 24.7042 38.9564C25.049 38.607 25.0977 38.3718 25.0977 38.2549C25.0977 37.4265 25.7692 36.7549 26.5977 36.7549C27.4261 36.7549 28.0977 37.4265 28.0977 38.2549C28.0977 39.3848 27.558 40.3356 26.8394 41.0637C26.1275 41.785 25.172 42.3649 24.1104 42.8191C21.9819 43.7298 19.1471 44.2549 16.0977 44.2549C13.0482 44.2549 10.2135 43.7298 8.08494 42.8191C7.02332 42.3649 6.0678 41.785 5.35593 41.0637C4.63733 40.3356 4.09766 39.3848 4.09766 38.2549C4.09766 37.4265 4.76923 36.7549 5.59766 36.7549Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M26.5977 24.7549C27.4261 24.7549 28.0977 25.4265 28.0977 26.2549V38.2549C28.0977 39.0833 27.4261 39.7549 26.5977 39.7549C25.7692 39.7549 25.0977 39.0833 25.0977 38.2549V26.2549C25.0977 25.4265 25.7692 24.7549 26.5977 24.7549Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M5.59766 24.7549C6.42608 24.7549 7.09766 25.4265 7.09766 26.2549V38.2549C7.09766 39.0833 6.42608 39.7549 5.59766 39.7549C4.76923 39.7549 4.09766 39.0833 4.09766 38.2549V26.2549C4.09766 25.4265 4.76923 24.7549 5.59766 24.7549Z" />\n            </svg>\n        '),
        "desktop-screenshots": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect stroke=').concat(firstColor, ' strokeWidth="2" x="3" y="7" width="26" height="16" rx="2"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M10 26L22 26"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M20 11H23C24.1046 11 25 11.8954 25 13V16"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 19H9C7.89543 19 7 18.1046 7 17V14"/>\n            </svg>\n        '),
        "download-doc": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <g clipPath="url(#clip0_21370_39890)">\n                    <path fill=').concat(firstColor, ' d="M16 2.00293L21 7.00293V21.0109C20.9997 21.2741 20.895 21.5264 20.7088 21.7124C20.5226 21.8984 20.2702 22.0029 20.007 22.0029H3.993C3.73038 22.0011 3.47902 21.896 3.29322 21.7104C3.10742 21.5248 3.00209 21.2735 3 21.0109V2.99493C3 2.44693 3.445 2.00293 3.993 2.00293H16ZM13 12.0029V8.00293H11V12.0029H8L12 16.0029L16 12.0029H13Z" />\n                </g>\n                <defs>\n                    <clipPath id="clip0_21370_39890">\n                        <rect width="24" height="24" fill="white" transform="translate(0 0.00292969)"/>\n                    </clipPath>\n                </defs>\n            </svg> \n        '),
        "edit-time": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <mask id="mask" fill="white">\n                    <path d="M18.7802 28.7022C18.898 29.2401 18.5575 29.7754 18.0126 29.8546C15.3825 30.2367 12.6903 29.863 10.2542 28.7666C7.51419 27.5334 5.24364 25.4514 3.77813 22.8283C2.31262 20.2052 1.72992 17.1803 2.11614 14.2005C2.50236 11.2207 3.83701 8.44421 5.92283 6.28142C8.00866 4.11864 10.735 2.6843 13.6988 2.19042C16.6627 1.69653 19.7068 2.1693 22.3812 3.53885C25.0556 4.9084 27.2185 7.10206 28.5501 9.79559C29.734 12.1903 30.205 14.8673 29.9184 17.5095C29.859 18.057 29.3364 18.4166 28.7945 18.3184C28.2526 18.2202 27.8973 17.7013 27.9502 17.1532C28.1645 14.9333 27.7565 12.6903 26.7624 10.6794C25.6205 8.36954 23.7657 6.48836 21.4722 5.3139C19.1787 4.13944 16.5683 3.73402 14.0266 4.15755C11.485 4.58108 9.147 5.8111 7.3583 7.6658C5.56959 9.52051 4.42505 11.9015 4.09385 14.4568C3.76265 17.0121 4.26235 19.6062 5.5191 21.8556C6.77585 24.1051 8.72297 25.8905 11.0727 26.948C13.1183 27.8687 15.3746 28.1951 17.5852 27.9006C18.1311 27.8279 18.6625 28.1642 18.7802 28.7022Z"/>\n                </mask>\n                <path stroke=').concat(firstColor, ' strokeWidth="4" d="M18.7802 28.7022C18.898 29.2401 18.5575 29.7754 18.0126 29.8546C15.3825 30.2367 12.6903 29.863 10.2542 28.7666C7.51419 27.5334 5.24364 25.4514 3.77813 22.8283C2.31262 20.2052 1.72992 17.1803 2.11614 14.2005C2.50236 11.2207 3.83701 8.44421 5.92283 6.28142C8.00866 4.11864 10.735 2.6843 13.6988 2.19042C16.6627 1.69653 19.7068 2.1693 22.3812 3.53885C25.0556 4.9084 27.2185 7.10206 28.5501 9.79559C29.734 12.1903 30.205 14.8673 29.9184 17.5095C29.859 18.057 29.3364 18.4166 28.7945 18.3184C28.2526 18.2202 27.8973 17.7013 27.9502 17.1532C28.1645 14.9333 27.7565 12.6903 26.7624 10.6794C25.6205 8.36954 23.7657 6.48836 21.4722 5.3139C19.1787 4.13944 16.5683 3.73402 14.0266 4.15755C11.485 4.58108 9.147 5.8111 7.3583 7.6658C5.56959 9.52051 4.42505 11.9015 4.09385 14.4568C3.76265 17.0121 4.26235 19.6062 5.5191 21.8556C6.77585 24.1051 8.72297 25.8905 11.0727 26.948C13.1183 27.8687 15.3746 28.1951 17.5852 27.9006C18.1311 27.8279 18.6625 28.1642 18.7802 28.7022Z" mask="url(#mask)"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" d="M16 7V14.6528C16 15.5097 15.6336 16.3257 14.9931 16.895L11.5 20"/>\n                <circle fill=').concat(firstColor, ' cx="17.5" cy="22.5" r="1.5"/>\n                <circle fill=').concat(firstColor, ' cx="22.5" cy="22.5" r="1.5"/>\n                <circle fill=').concat(firstColor, ' cx="27.5" cy="22.5" r="1.5"/>\n            </svg>\n        '),
        email: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M3.16795 8.44541C3.4743 7.98588 4.09517 7.8617 4.5547 8.16806L16 15.7983L27.4453 8.16806C27.9048 7.8617 28.5257 7.98588 28.8321 8.44541C29.1384 8.90493 29.0142 9.5258 28.5547 9.83216L16.5547 17.8322C16.2188 18.0561 15.7812 18.0561 15.4453 17.8322L3.4453 9.83216C2.98577 9.5258 2.8616 8.90493 3.16795 8.44541Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M3 7C3 6.44772 3.44772 6 4 6H28C28.5523 6 29 6.44772 29 7V23C29 24.6569 27.6569 26 26 26H6C4.34315 26 3 24.6569 3 23V7ZM5 8V23C5 23.5523 5.44772 24 6 24H26C26.5523 24 27 23.5523 27 23V8H5Z"/>\n            </svg>\n        '),
        email2: "\n            <svg width=".concat(size, "px height=").concat(size, 'px  viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M7.5 9.00391C6.67157 9.00391 6 9.67548 6 10.5039V30.0039C6 30.8323 6.67157 31.5039 7.5 31.5039H21C21.8284 31.5039 22.5 32.1755 22.5 33.0039C22.5 33.8323 21.8284 34.5039 21 34.5039H7.5C5.01472 34.5039 3 32.4892 3 30.0039V10.5039C3 8.01862 5.01472 6.00391 7.5 6.00391H34.5C36.9853 6.00391 39 8.01863 39 10.5039V18.0039C39 18.8323 38.3284 19.5039 37.5 19.5039C36.6716 19.5039 36 18.8323 36 18.0039V10.5039C36 9.67548 35.3284 9.00391 34.5 9.00391H7.5Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M9.27939 12.6322C9.76091 11.958 10.6977 11.8019 11.3719 12.2834L20.1281 18.5379C20.6497 18.9104 21.3503 18.9104 21.8719 18.5379L30.6281 12.2834C31.3023 11.8019 32.2391 11.958 32.7206 12.6322C33.2021 13.3063 33.046 14.2431 32.3719 14.7246L23.6156 20.9791C22.0509 22.0967 19.9491 22.0967 18.3844 20.9791L9.62814 14.7246C8.95402 14.2431 8.79788 13.3063 9.27939 12.6322Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M25.5 32.2539C25.5 26.8691 29.8652 22.5039 35.25 22.5039C40.6348 22.5039 45 26.8691 45 32.2539C45 33.3682 44.7624 34.6328 44.0636 35.6667C43.3142 36.7755 42.1031 37.5039 40.5 37.5039C38.9294 37.5039 37.7926 36.7757 36.9322 36.021C36.4183 36.2508 35.8487 36.3789 35.25 36.3789C32.9718 36.3789 31.125 34.5321 31.125 32.2539C31.125 29.9757 32.9718 28.1289 35.25 28.1289C37.5282 28.1289 39.375 29.9757 39.375 32.2539C39.375 32.8287 39.2569 33.3766 39.0442 33.8742C39.573 34.3167 39.9778 34.5039 40.5 34.5039C41.0857 34.5039 41.3746 34.2878 41.578 33.9868C41.832 33.611 42 33.0006 42 32.2539C42 28.526 38.9779 25.5039 35.25 25.5039C31.5221 25.5039 28.5 28.526 28.5 32.2539C28.5 36.2992 31.8639 39.0039 36 39.0039C36.8284 39.0039 37.5 39.6755 37.5 40.5039C37.5 41.3323 36.8284 42.0039 36 42.0039C30.6401 42.0039 25.5 38.3582 25.5 32.2539ZM35.25 31.1289C34.6287 31.1289 34.125 31.6326 34.125 32.2539C34.125 32.8752 34.6287 33.3789 35.25 33.3789C35.5611 33.3789 35.8403 33.2546 36.0455 33.0494C36.2507 32.8442 36.375 32.565 36.375 32.2539C36.375 31.6326 35.8713 31.1289 35.25 31.1289Z"/>\n            </svg>\n        '),
        enter: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M1.875 9.9999H13.2507M13.2507 9.9999L10.4068 7.56226M13.2507 9.9999L10.4068 12.4375" stroke="').concat(firstColor, '" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>\n                <path fill="none" d="M7.29199 5.48634C7.30174 3.71905 7.65212 3.21327 8.27615 2.58923C8.99038 1.875 10.1393 1.875 12.4372 1.875H13.2498C15.5485 1.875 16.6974 1.875 17.4116 2.58923C18.125 3.30265 18.125 4.4524 18.125 6.75029V13.2507C18.125 15.5486 18.125 16.6983 17.4116 17.4117C16.6966 18.126 15.5485 18.126 13.2498 18.126H12.4372C10.1393 18.126 8.99038 18.126 8.27615 17.4117C7.65212 16.7877 7.30174 16.282 7.29199 14.5147" stroke="').concat(firstColor, '" stroke-width="1.7" stroke-linecap="round"/>\n            </svg>\n        '),
        enterprises: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M22.825 4.93224C17.8133 1.83581 11.1543 2.46092 6.80764 6.80759C2.4609 11.1543 1.83579 17.8134 4.93229 22.8251M27.0677 9.1749C30.1642 14.1867 29.5391 20.8457 25.1924 25.1924C20.8457 29.5391 14.1867 30.1643 9.17495 27.0678"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M6.66672 15.9999L10.4001 9.46657H21.6001L25.3334 15.9999L16.0001 25.3332L6.66672 15.9999ZM16.9334 16.9332H21.7602L16.9334 21.7601V16.9332ZM10.2399 16.9332H15.0667V21.7601L10.2399 16.9332ZM19.2611 11.3332L16.0008 15.0506L12.7472 11.3332H19.2611ZM21.001 12.1805L18.4698 15.0666H22.6502L21.001 12.1805ZM9.34996 15.0666H13.5341L11.0027 12.1744L9.34996 15.0666Z"/>\n            </svg>\n        '),
        expand: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">\n                <path d="M4.5 19.501H12L4.5 12.001V19.501Z" fill=').concat(firstColor, ' />\n                <path d="M19.5 4.50098L12 4.50098L19.5 12.001V4.50098Z" fill=').concat(firstColor, " />\n            </svg>\n        "),
        "export-reports": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M23.5 5H24C25.6569 5 27 6.34315 27 8V26C27 27.6569 25.6569 29 24 29H7.35044C6.05233 29 5 27.9477 5 26.6496V26.6496C5 25.9242 5.33487 25.2395 5.90741 24.7942L18.5 15M8.5 5H8C6.34315 5 5 6.34315 5 8V20"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M19.3643 13.8737L14.0217 13.8669"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M19.3644 13.8736L19.2991 19.0291"/>\n                <rect fill=').concat(secondColor, ' x="11" y="2" width="10" height="4" rx="2"/>\n            </svg>\n        '),
        freelancers: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\n                <rect fill=').concat(secondColor, ' x="4" y="15" width="24" height="2"/>\n                <path fill=').concat(firstColor, ' d="M24.2183 19.5C25.2863 19.5 25.882 20.1583 26.3166 20.6391C26.6937 21.0566 26.8626 21.2143 27.1429 21.2143H28V22.9286H27.1429C26.0761 22.9286 25.4814 22.2718 25.0461 21.7911L25.0446 21.7894C24.6674 21.372 24.4986 21.2143 24.2183 21.2143C23.9774 21.2143 23.8583 21.3214 23.5163 21.75L23.5154 21.7511C23.14 22.22 22.5726 22.9286 21.4754 22.9286C20.3774 22.9286 19.81 22.2197 19.4346 21.75C19.0917 21.3214 18.9734 21.2143 18.7326 21.2143C18.4917 21.2143 18.3726 21.3214 18.0306 21.75L18.0297 21.7511C17.6543 22.22 17.0869 22.9286 15.9906 22.9286C14.8934 22.9286 14.326 22.2189 13.9506 21.7491C13.6094 21.3214 13.4911 21.2143 13.2511 21.2143C13.0103 21.2143 12.8911 21.3214 12.5491 21.75L12.5474 21.7522C12.1719 22.2211 11.6054 22.9286 10.5091 22.9286C9.41114 22.9286 8.84371 22.2189 8.46914 21.75C8.12629 21.3214 8.00886 21.2143 7.76714 21.2143C7.49029 21.2143 7.32229 21.3711 6.94943 21.7869C6.51743 22.2686 5.92514 22.9286 4.85714 22.9286H4V21.2143H4.85714C5.134 21.2143 5.30114 21.0574 5.67486 20.6417C6.10686 20.16 6.69914 19.5 7.76714 19.5C8.86343 19.5 9.43082 20.2086 9.80626 20.6775L9.80714 20.6786C10.15 21.1071 10.2683 21.2143 10.5091 21.2143C10.75 21.2143 10.8683 21.1071 11.2103 20.6786L11.2112 20.6775C11.5866 20.2086 12.154 19.5 13.2511 19.5C14.3483 19.5 14.9157 20.2097 15.2911 20.6794C15.6323 21.1071 15.7506 21.2143 15.9906 21.2143C16.2323 21.2143 16.3497 21.1071 16.6926 20.6786L16.6935 20.6775C17.0689 20.2086 17.6363 19.5 18.7334 19.5C19.8297 19.5 20.3971 20.2086 20.7725 20.6775L20.7734 20.6786C21.1154 21.1071 21.2337 21.2143 21.4754 21.2143C21.7171 21.2143 21.8354 21.1071 22.1774 20.6786L22.1783 20.6775C22.5538 20.2086 23.1211 19.5 24.2183 19.5Z"/>\n                <path fill=').concat(firstColor, ' d="M24.2183 24.5723C25.2863 24.5723 25.882 25.2306 26.3166 25.7114C26.6937 26.1288 26.8626 26.2866 27.1429 26.2866H28V28.0008H27.1429C26.0761 28.0008 25.4814 27.3441 25.0461 26.8634L25.0446 26.8617C24.6674 26.4443 24.4986 26.2866 24.2183 26.2866C23.9774 26.2866 23.8583 26.3937 23.5163 26.8223L23.5154 26.8234C23.14 27.2922 22.5726 28.0008 21.4754 28.0008C20.3774 28.0008 19.81 27.292 19.4346 26.8223C19.0917 26.3937 18.9734 26.2866 18.7326 26.2866C18.4917 26.2866 18.3726 26.3937 18.0306 26.8223L18.0297 26.8234C17.6543 27.2922 17.0869 28.0008 15.9906 28.0008C14.8934 28.0008 14.326 27.2911 13.9506 26.8214C13.6094 26.3937 13.4911 26.2866 13.2511 26.2866C13.0103 26.2866 12.8911 26.3937 12.5491 26.8223L12.5474 26.8245C12.1719 27.2933 11.6054 28.0008 10.5091 28.0008C9.41114 28.0008 8.84371 27.2911 8.46914 26.8223C8.12629 26.3937 8.00886 26.2866 7.76714 26.2866C7.49029 26.2866 7.32229 26.4434 6.94943 26.8591C6.51743 27.3408 5.92514 28.0008 4.85714 28.0008H4V26.2866H4.85714C5.134 26.2866 5.30114 26.1297 5.67486 25.714C6.10686 25.2323 6.69914 24.5723 7.76714 24.5723C8.86343 24.5723 9.43082 25.2809 9.80626 25.7497L9.80714 25.7508C10.15 26.1794 10.2683 26.2866 10.5091 26.2866C10.75 26.2866 10.8683 26.1794 11.2103 25.7508L11.2112 25.7497C11.5866 25.2809 12.154 24.5723 13.2511 24.5723C14.3483 24.5723 14.9157 25.282 15.2911 25.7517C15.6323 26.1794 15.7506 26.2866 15.9906 26.2866C16.2323 26.2866 16.3497 26.1794 16.6926 25.7508L16.6935 25.7497C17.0689 25.2809 17.6363 24.5723 18.7334 24.5723C19.8297 24.5723 20.3971 25.2809 20.7725 25.7497L20.7734 25.7508C21.1154 26.1794 21.2337 26.2866 21.4754 26.2866C21.7171 26.2866 21.8354 26.1794 22.1774 25.7508L22.1783 25.7497C22.5538 25.2809 23.1211 24.5723 24.2183 24.5723Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M17 6.08296C17.9116 6.2359 18.7535 6.5944 19.4764 7.10916L21.6569 4.92869L23.0711 6.34291L20.8907 8.52334C21.4055 9.2463 21.7641 10.0883 21.917 11H25V13H21.917C21.7966 13.7179 21.5487 14.3926 21.1973 15H18.6458C19.4762 14.2671 20 13.1947 20 12C20 9.79086 18.2091 8 16 8C13.7909 8 12 9.79086 12 12C12 13.1947 12.5238 14.2671 13.3542 15H10.8027C10.4513 14.3926 10.2034 13.7179 10.083 13H7V11H10.083C10.2359 10.0885 10.5943 9.24674 11.1089 8.52391L8.92893 6.3439L10.3431 4.92969L12.523 7.10957C13.2461 6.59458 14.0882 6.23594 15 6.08296V3H17V6.08296Z"/>\n            </svg>\n        '),
        globe: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="16" r="10"/>\n                <ellipse stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="16" rx="4" ry="10"/>\n                <ellipse stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="16" rx="4" ry="10" transform="rotate(-90 16 16)"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M27.9589 17.0008C27.9861 16.6711 28 16.3375 28 16.0008C28 15.664 27.9861 15.3305 27.9589 15.0008H31V17.0008H27.9589ZM26.8586 21.1153C26.5724 21.722 26.2368 22.3007 25.8571 22.8465L28.4904 24.3668L29.4904 22.6348L26.8586 21.1153ZM6.14292 22.8465C5.76318 22.3007 5.42761 21.722 5.14138 21.1153L2.50962 22.6348L3.50962 24.3668L6.14292 22.8465ZM4.04107 17.0008H1V15.0008H4.04107C4.01387 15.3305 4 15.664 4 16.0008C4 16.3375 4.01387 16.6711 4.04107 17.0008ZM5.14138 10.8863C5.42761 10.2796 5.76318 9.70085 6.14292 9.1551L3.50961 7.63477L2.50961 9.36682L5.14138 10.8863ZM25.8571 9.1551C26.2368 9.70085 26.5724 10.2796 26.8586 10.8863L29.4904 9.36682L28.4904 7.63477L25.8571 9.1551Z" />\n            </svg>\n        '),
        graph: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M4.20004 12C4.9954 8.08174 8.08174 4.9954 12 4.20004V12H4.20004ZM2.16592 12C3.00895 6.97499 6.97499 3.00895 12 2.16592C12.6504 2.0568 13.3186 2 14 2V14H2C2 13.3186 2.0568 12.6504 2.16592 12Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M17 4C16.4477 4 16 4.44772 16 5V16H5C4.44772 16 4 16.4477 4 17C4 24.1797 9.8203 30 17 30C24.1797 30 30 24.1797 30 17C30 9.8203 24.1797 4 17 4ZM18 17V6.04484C23.6065 6.55007 28 11.262 28 17C28 23.0751 23.0751 28 17 28C11.262 28 6.55007 23.6065 6.04484 18H17C17.5523 18 18 17.5523 18 17Z"/>\n            </svg>\n        '),
        "graph-performance": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M6 12.0049C6 8.69117 8.68629 6.00488 12 6.00488H27C27.8284 6.00488 28.5 6.67646 28.5 7.50488C28.5 8.33331 27.8284 9.00488 27 9.00488H12C10.3431 9.00488 9 10.348 9 12.0049V36.0049C9 37.6617 10.3431 39.0049 12 39.0049H15.8571C16.6856 39.0049 17.3571 39.6765 17.3571 40.5049C17.3571 41.3333 16.6856 42.0049 15.8571 42.0049H12C8.68629 42.0049 6 39.3186 6 36.0049V12.0049Z" />\n              <path fill=').concat(firstColor, '  fillRule="evenodd" clipRule="evenodd" d="M40.5 19.5049C41.3284 19.5049 42 20.1765 42 21.0049V36.0049C42 39.3186 39.3137 42.0049 36 42.0049H22.5C21.6716 42.0049 21 41.3333 21 40.5049C21 39.6765 21.6716 39.0049 22.5 39.0049H36C37.6569 39.0049 39 37.6617 39 36.0049V21.0049C39 20.1765 39.6716 19.5049 40.5 19.5049Z" />\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M39.75 10.5049C40.9926 10.5049 42 9.49752 42 8.25488C42 7.01224 40.9926 6.00488 39.75 6.00488C38.5074 6.00488 37.5 7.01224 37.5 8.25488C37.5 9.49752 38.5074 10.5049 39.75 10.5049ZM39.75 13.5049C42.6495 13.5049 45 11.1544 45 8.25488C45 5.35539 42.6495 3.00488 39.75 3.00488C36.8505 3.00488 34.5 5.35539 34.5 8.25488C34.5 11.1544 36.8505 13.5049 39.75 13.5049Z" />\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M34.0607 18.4442C34.6464 19.03 34.6464 19.9798 34.0607 20.5655L27.853 26.7732C26.7362 27.89 24.9447 27.9497 23.7561 26.9096L21.0684 24.5578L16.0607 29.5655C15.4749 30.1513 14.5251 30.1513 13.9393 29.5655C13.3536 28.9798 13.3536 28.03 13.9393 27.4442L18.9474 22.4362C20.0646 21.3189 21.8557 21.2605 23.0439 22.3001L25.7316 24.6519L31.9393 18.4442C32.5251 17.8584 33.4749 17.8584 34.0607 18.4442Z" />\n            </svg>\n        '),
        "login-2": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M23.8373 17.1781C24.3765 16.5491 25.3234 16.4763 25.9524 17.0154L32.7778 22.8658C33.1103 23.1508 33.3016 23.5668 33.3016 24.0047C33.3016 24.4426 33.1103 24.8586 32.7778 25.1436L25.9524 30.9939C25.3234 31.533 24.3765 31.4602 23.8373 30.8312C23.2982 30.2022 23.371 29.2553 24 28.7161L27.7467 25.5047H4.5C3.67157 25.5047 3 24.8331 3 24.0047C3 23.1762 3.67157 22.5047 4.5 22.5047H27.7467L24 19.2932C23.371 18.7541 23.2982 17.8071 23.8373 17.1781Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M23.6299 6.20577C22.2034 6.39764 21.4547 6.74766 20.9226 7.2797C20.2233 7.97909 19.8119 8.48157 19.5246 9.2143C19.222 9.98584 19.0113 11.1372 19 13.1804C18.9954 14.0088 18.3201 14.6767 17.4917 14.6721C16.6633 14.6675 15.9955 13.9922 16 13.1638C16.0122 10.9655 16.2335 9.38918 16.7317 8.11899C17.245 6.80997 18.003 5.95667 18.8013 5.15838C19.9834 3.97626 21.4705 3.46921 23.23 3.23254C24.9231 3.00481 27.0746 3.00484 29.7391 3.00488H31.9081C34.5735 3.00484 36.7255 3.00481 38.4188 3.23254C40.1786 3.4692 41.6657 3.97624 42.8478 5.15838C44.0293 6.33989 44.5356 7.8274 44.772 9.58658C44.9994 11.2798 44.9994 13.4317 44.9993 16.0963V31.9158C44.9994 34.5804 44.9994 36.7323 44.772 38.4255C44.5356 40.1847 44.0293 41.6722 42.8478 42.8537C41.665 44.0352 40.1779 44.5429 38.4181 44.7795C36.725 45.0073 34.5735 45.0072 31.9082 45.0072H29.739C27.0746 45.0072 24.9231 45.0073 23.23 44.7795C21.4705 44.5429 19.9834 44.0358 18.8013 42.8537C18.0031 42.0554 17.2451 41.2022 16.7317 39.8932C16.2335 38.623 16.0122 37.0467 16 34.8484C15.9955 34.02 16.6633 33.3447 17.4917 33.3402C18.3201 33.3356 18.9954 34.0035 19 34.8319C19.0113 36.8751 19.222 38.0264 19.5246 38.7979C19.8119 39.5305 20.2232 40.033 20.9226 40.7324C21.4547 41.2644 22.2034 41.6144 23.6299 41.8063C25.0997 42.004 27.0486 42.0072 29.8485 42.0072H31.7986C34.5995 42.0072 36.5485 42.004 38.0182 41.8063C39.4444 41.6145 40.1937 41.2645 40.727 40.7319C40.7269 40.7319 40.727 40.7319 40.727 40.7319M40.727 40.7319C41.2573 40.2012 41.607 39.4529 41.7987 38.0261C41.9962 36.5559 41.9993 34.6063 41.9993 31.8065V16.2056C41.9993 13.4058 41.9962 11.4562 41.7987 9.98599C41.6069 8.55868 41.2572 7.81038 40.7265 7.2797C40.1945 6.74768 39.4457 6.39765 38.019 6.20577C36.549 6.00807 34.5995 6.00488 31.7986 6.00488H29.8485C27.0486 6.00488 25.0997 6.00807 23.6299 6.20577" />\n            </svg>\n        '),
        "location-dot": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M15.5015 17.6068C17.5348 15.3085 19.25 12.5812 19.25 10.126C19.25 5.83078 16.2037 3.00101 12.5 3.00101C8.79628 3.00101 5.75 5.83078 5.75 10.126C5.75 12.5812 7.46519 15.3085 9.49846 17.6068C10.4784 18.7145 11.463 19.646 12.2044 20.3012C12.3081 20.3929 12.4069 20.4791 12.5 20.5593C12.5931 20.4791 12.6919 20.3929 12.7956 20.3012C13.537 19.646 14.5216 18.7145 15.5015 17.6068ZM12.5 22.501C12.5 22.501 20.75 16.2253 20.75 10.126C20.75 5.02676 17.0563 1.50101 12.5 1.50101C7.94365 1.50101 4.25 5.02676 4.25 10.126C4.25 16.2253 12.5 22.501 12.5 22.501Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M12.5 12.751C14.1569 12.751 15.5 11.4079 15.5 9.75101C15.5 8.09415 14.1569 6.75101 12.5 6.75101C10.8431 6.75101 9.5 8.09415 9.5 9.75101C9.5 11.4079 10.8431 12.751 12.5 12.751ZM12.5 14.251C14.9853 14.251 17 12.2363 17 9.75101C17 7.26573 14.9853 5.25101 12.5 5.25101C10.0147 5.25101 8 7.26573 8 9.75101C8 12.2363 10.0147 14.251 12.5 14.251Z"/>\n            </svg>\n        '),
        minus: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n                <path fillRule="evenodd" d="M23 17V15H9V17H23Z"/>\n            </svg>\n        '),
        monitoring: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" d="M28 12V8C28 6.34315 26.6569 5 25 5H7C5.34315 5 4 6.34315 4 8V12M28 20V24C28 25.6569 26.6569 27 25 27H7C5.34315 27 4 25.6569 4 24V20"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M3 16H7L9 21L11.5 11L14 18L15 16H17L20 21L22.5 11L25 16H29"/>\n            </svg>\n        '),
        monitoring2: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M18 5H8C6.34315 5 5 6.34315 5 8V24C5 25.6569 6.34315 27 8 27H10.5714"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M15 27H24C25.6569 27 27 25.6569 27 24V14"/>\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="26.5" cy="5.5" r="2.5"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M10 19C10.2687 18.7313 12.0607 16.9393 13.3387 15.6613C13.711 15.289 14.3079 15.2694 14.7041 15.6161L16.4959 17.1839C16.8921 17.5306 17.4893 17.5107 17.8615 17.1385L22 13"/>\n            </svg>\n        '),
        notification: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M17.8417 3.21885C17.5375 2.50244 16.8274 2 16 2C15.1726 2 14.4625 2.50244 14.1583 3.21885C9.73744 4.28405 6.4 9.11108 6.4 14.9048C6.4 15.6463 6.42059 16.3423 6.46068 16.9954C6.56424 18.6824 5.58682 20.1861 4.65368 21.6217L4.65359 21.6218C4.55816 21.7687 4.46319 21.9148 4.36989 22.0603C4.12837 22.437 4 22.8316 4 23.2381C4 25.4749 7.88643 27.3515 13.1258 27.8625C13.4964 29.099 14.643 30 16 30C17.357 30 18.5036 29.099 18.8742 27.8625C24.1136 27.3515 28 25.4749 28 23.2381C28 22.8316 27.8716 22.437 27.6301 22.0603C27.5368 21.9147 27.4418 21.7686 27.3464 21.6218L27.3463 21.6217C26.4132 20.1861 25.4358 18.6824 25.5393 16.9954C25.5794 16.3423 25.6 15.6463 25.6 14.9048C25.6 14.182 25.5481 13.4742 25.4485 12.787C24.99 12.9255 24.5037 13 24 13C23.8172 13 23.6366 12.9902 23.4589 12.9711C23.5511 13.5892 23.6 14.2348 23.6 14.9048C23.6 15.6096 23.5804 16.2645 23.5431 16.8729C23.4568 18.2786 23.875 19.5112 24.3695 20.5184C24.7632 21.3204 25.2738 22.1047 25.6941 22.7503C25.7829 22.8867 25.8677 23.0169 25.9465 23.1398C25.9785 23.1897 25.9921 23.2222 25.9973 23.237C25.9818 23.2842 25.9189 23.417 25.6886 23.6331C25.3267 23.9725 24.6949 24.3704 23.7476 24.7463C21.8644 25.4936 19.1261 26 16 26C12.8739 26 10.1356 25.4936 8.25241 24.7463C7.30506 24.3704 6.67327 23.9725 6.31145 23.6331C6.08112 23.417 6.01822 23.2842 6.00267 23.237C6.00794 23.2222 6.02153 23.1897 6.05353 23.1398C6.13226 23.017 6.21698 22.8869 6.30571 22.7506L6.30586 22.7504C6.72619 22.1047 7.23682 21.3204 7.63053 20.5184C8.12503 19.5112 8.54321 18.2786 8.45692 16.8729C8.41958 16.2645 8.4 15.6096 8.4 14.9048C8.4 9.01116 12.183 5 16 5C17.1682 5 18.3333 5.37575 19.3877 6.06621C19.6522 5.43598 20.0422 4.87139 20.5263 4.40366C19.6968 3.85267 18.7944 3.44841 17.8417 3.21885ZM26.0019 23.2176L26.002 23.2184C26.0019 23.2197 26.0015 23.2224 26.0004 23.2266C26.0009 23.2206 26.0017 23.2176 26.0019 23.2176ZM5.99808 23.2176C5.99834 23.2176 5.9991 23.2206 5.99958 23.2266C5.99806 23.2206 5.99782 23.2176 5.99808 23.2176Z"/>\n                <circle fill=').concat(secondColor, ' cx="24" cy="8" r="4"/>\n            </svg>\n        '),
        "offline-tracking": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <circle fill=').concat(firstColor, ' cx="16" cy="25" r="2"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M4.32639 13.0457C4.34652 13.0284 4.36614 13.0103 4.38518 12.9914C4.39251 12.9841 4.39975 12.9767 4.4069 12.9692C5.79666 11.5086 7.45212 10.3215 9.28776 9.47334C11.4261 8.48528 13.7562 7.9815 16.1117 7.99794C17.7466 8.00936 19.3657 8.27117 20.9136 8.77059L22.4781 7.20611C20.4544 6.42549 18.3024 6.01564 16.1257 6.00044C13.4761 5.98194 10.8552 6.54861 8.44988 7.66C6.40498 8.60488 4.55886 9.92367 3.00499 11.5449L2.95976 11.5923C2.93111 11.6224 2.90256 11.6526 2.87412 11.6829C2.49666 12.0851 2.55377 12.7173 2.97633 13.0718C3.37027 13.4024 3.94258 13.3747 4.32639 13.0457ZM26.1835 9.15758L24.7436 10.5975C25.8436 11.3151 26.8522 12.1661 27.746 13.1322C27.7531 13.1398 27.7602 13.1473 27.7674 13.1547C27.7862 13.1738 27.8056 13.1922 27.8255 13.2097C28.2046 13.5441 28.7765 13.5798 29.175 13.2547C29.6025 12.9061 29.6684 12.2748 29.2966 11.8674C29.2686 11.8367 29.2405 11.8061 29.2123 11.7756L29.1677 11.7276C28.2689 10.7632 27.2679 9.90161 26.1835 9.15758ZM17.587 12.0972C17.0917 12.0363 16.5921 12.0038 16.0907 12.0003C14.1772 11.987 12.2842 12.3962 10.5471 13.1989C9.11344 13.8613 7.81508 14.7782 6.71374 15.9024C6.32684 16.2973 6.38472 16.9318 6.80824 17.2872C7.19182 17.6091 7.74346 17.591 8.13562 17.2954C8.15275 17.2825 8.16958 17.2691 8.18608 17.2551L8.2047 17.239C8.22099 17.2245 8.23695 17.2096 8.25253 17.1941C9.16058 16.2929 10.2208 15.5551 11.3869 15.0163C12.7355 14.3932 14.1951 14.0503 15.6774 14.0068L17.587 12.0972ZM20.4142 14.9268L21.9166 13.4244C23.2218 14.0916 24.4034 14.974 25.4123 16.033C25.7937 16.4333 25.7269 17.0669 25.2985 17.4163C24.9105 17.7328 24.3591 17.707 23.9711 17.406C23.9542 17.3928 23.9375 17.3791 23.9212 17.3649L23.9029 17.3486C23.8868 17.3339 23.871 17.3188 23.8557 17.3031C22.9603 16.3892 21.9104 15.6367 20.752 15.0817C20.6402 15.0281 20.5276 14.9765 20.4142 14.9268ZM15.3094 20.0317L17.2318 18.1092C17.851 18.2199 18.4542 18.4138 19.0246 18.6872C19.4903 18.9103 19.9284 19.1835 20.3316 19.5011C20.3713 19.5324 20.4106 19.5641 20.4497 19.5962C20.5506 19.6793 20.6492 19.7653 20.7454 19.854C21.1481 20.2254 21.0805 20.8565 20.6559 21.2027C20.3056 21.4885 19.8223 21.4887 19.4263 21.2844C19.3685 21.2545 19.3124 21.2203 19.259 21.1819C19.235 21.1647 19.2115 21.1466 19.1886 21.1278C18.8767 20.8709 18.5339 20.652 18.1674 20.4763C17.5015 20.1573 16.7734 19.9892 16.035 19.984C15.7917 19.9824 15.5491 19.9984 15.3094 20.0317Z"/>\n                <path fill=').concat(secondColor, ' d="M25.186 6.00008C25.5765 5.60955 26.2097 5.60955 26.6002 6.00008C26.9908 6.3906 26.9908 7.02377 26.6002 7.41429L7.51446 26.5001C7.12394 26.8906 6.49077 26.8906 6.10025 26.5001C5.70972 26.1095 5.70972 25.4764 6.10025 25.0858L25.186 6.00008Z"/>\n            </svg>\n        '),
        play: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="16" r="12"/>\n                <path fill=').concat(firstColor, ' d="M12 11.6845C12 10.9255 12.8125 10.4432 13.4789 10.8066L21.3905 15.1221C22.0854 15.5011 22.0854 16.4989 21.3905 16.8779L13.4789 21.1934C12.8125 21.5568 12 21.0745 12 20.3155V11.6845Z"/>\n            </svg>\n        '),
        playVideo: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n              <circle cx="12" cy="12.0059" r="12" fillRule="evenodd" />\n              <path d="M9 16.0371V7.97455C9 7.21449 9.81549 6.75146 10.4435 7.15492L16.5576 11.0828C17.1394 11.4566 17.1492 12.3223 16.5761 12.7099L10.462 16.8445C9.83506 17.2685 9 16.8073 9 16.0371Z" fill="white"/>\n            </svg>\n        '),
        plus: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n                <path fillRule="evenodd" d="M15 17.002V23.002H17V17.002H23V15.002H17V9.00195H15V15.002H9V17.002H15Z"/>\n            </svg>\n        '),
        question: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M4.18262 20.1235C7.18451 22.6255 16.753 22.6255 19.8174 20.1235C22.8818 17.6216 22.5691 6.92572 19.8174 4.11102C17.0657 1.29633 6.93435 1.29633 4.18262 4.11102C1.4309 6.92572 1.11821 17.6216 4.18262 20.1235ZM16 11.0357C16 11.5782 15.9304 12.0669 15.7913 12.5017C15.6522 12.9365 15.457 13.3174 15.2058 13.6444C14.9546 13.9714 14.6551 14.2427 14.3072 14.4582C13.9594 14.6737 13.5768 14.8298 13.1594 14.9264C13.1981 15.0751 13.2831 15.1958 13.4145 15.2887C13.5459 15.3816 13.7121 15.4578 13.913 15.5173C14.114 15.5767 14.3478 15.6213 14.6145 15.6511C14.8812 15.6808 15.1691 15.7068 15.4783 15.7291L15.1072 17C14.5043 16.9777 13.9884 16.9201 13.5594 16.8272C13.1304 16.7343 12.7672 16.6061 12.4696 16.4426C12.172 16.2791 11.9362 16.0784 11.7623 15.8406C11.5884 15.6027 11.4551 15.3278 11.3623 15.0156C10.8831 14.9562 10.4386 14.8279 10.029 14.631C9.61932 14.434 9.26377 14.1683 8.96232 13.8339C8.66087 13.4994 8.42512 13.0981 8.25507 12.6299C8.08502 12.1616 8 11.6303 8 11.0357C8 10.3742 8.10821 9.79264 8.32464 9.29097C8.54106 8.7893 8.83285 8.36752 9.2 8.02564C9.56715 7.68376 9.99227 7.42735 10.4754 7.25641C10.9585 7.08547 11.4667 7 12 7C12.5488 7 13.0667 7.08547 13.5536 7.25641C14.0406 7.42735 14.4657 7.68376 14.829 8.02564C15.1923 8.36752 15.4783 8.7893 15.687 9.29097C15.8957 9.79264 16 10.3742 16 11.0357ZM9.86667 11.0357C9.86667 11.4147 9.91498 11.7566 10.0116 12.0613C10.1082 12.366 10.2473 12.628 10.429 12.8473C10.6106 13.0665 10.8328 13.2356 11.0957 13.3545C11.3585 13.4734 11.6599 13.5329 12 13.5329C12.3324 13.5329 12.6319 13.4734 12.8986 13.3545C13.1652 13.2356 13.3894 13.0665 13.571 12.8473C13.7527 12.628 13.8918 12.366 13.9884 12.0613C14.085 11.7566 14.1333 11.4147 14.1333 11.0357C14.1333 10.6566 14.085 10.3129 13.9884 10.0045C13.8918 9.69602 13.7527 9.43218 13.571 9.21293C13.3894 8.99368 13.1652 8.8246 12.8986 8.70569C12.6319 8.58677 12.3324 8.52731 12 8.52731C11.6599 8.52731 11.3585 8.58863 11.0957 8.71126C10.8328 8.83389 10.6106 9.00483 10.429 9.22408C10.2473 9.44333 10.1082 9.70717 10.0116 10.0156C9.91498 10.324 9.86667 10.6641 9.86667 11.0357Z" />\n            </svg>\n        '),
        "question-rounded": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M8 16.001C12.4183 16.001 16 12.4193 16 8.00101C16 3.58273 12.4183 0.00100708 8 0.00100708C3.58172 0.00100708 0 3.58273 0 8.00101C0 12.4193 3.58172 16.001 8 16.001ZM10.5008 3.69061C9.9128 3.15861 9.13347 2.89261 8.1628 2.89261C7.50013 2.89261 6.92147 3.01861 6.4268 3.27061C5.94147 3.52261 5.5728 3.87261 5.3208 4.32061C5.0688 4.76861 4.94747 5.27728 4.9568 5.84661H6.8048C6.8048 5.43594 6.92147 5.11394 7.1548 4.88061C7.39747 4.64728 7.73347 4.53061 8.1628 4.53061C8.57347 4.53061 8.89547 4.65194 9.1288 4.89461C9.37147 5.13728 9.4928 5.46394 9.4928 5.87461C9.4928 6.44394 9.27347 6.83594 8.8348 7.05061C8.39613 7.26528 7.7708 7.37261 6.9588 7.37261H6.3288L6.3988 9.75261H8.1208L8.1768 8.67461C9.14747 8.67461 9.9268 8.43661 10.5148 7.96061C11.1028 7.47528 11.3968 6.77528 11.3968 5.86061C11.3968 4.93661 11.0981 4.21328 10.5008 3.69061ZM6.3708 12.7766C6.60413 12.9913 6.89813 13.0986 7.2528 13.0986C7.59813 13.0986 7.8828 12.9913 8.1068 12.7766C8.3308 12.5526 8.4428 12.2773 8.4428 11.9506C8.4428 11.6239 8.3308 11.3533 8.1068 11.1386C7.8828 10.9146 7.59813 10.8026 7.2528 10.8026C6.89813 10.8026 6.60413 10.9146 6.3708 11.1386C6.1468 11.3533 6.0348 11.6239 6.0348 11.9506C6.0348 12.2773 6.1468 12.5526 6.3708 12.7766Z"/>\n            </svg>\n        '),
        quote: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M16.6393 0.0150146C14.0917 0.0150146 11.5441 0.0150146 9.00398 0.0150146C8.73343 0.0150146 8.3652 0.0527772 8.04205 0.286905C7.79405 0.460613 7.65878 0.717399 7.59866 0.845791C7.52351 1.01195 7.45588 1.20076 7.40327 1.38957L0.0986529 29.5605C-0.0215877 30.0589 -0.0516479 30.5876 0.121198 31.0785C0.136228 31.1087 0.143743 31.1389 0.158773 31.1691C0.45186 31.7884 1.04555 31.9999 1.56409 31.9999C4.8181 31.9999 8.07211 31.9999 11.3186 31.9999L16.6393 0.0150146V0.0150146Z"/>\n                <path fill=').concat(firstColor, ' d="M31.8196 1.09511L32 0C29.4524 0 26.9048 0 24.3647 0C24.0941 0 23.7259 0.0453151 23.4028 0.271891C23.1548 0.453151 23.0195 0.702384 22.9594 0.838329C22.8842 0.996932 22.8166 1.18574 22.764 1.37456L15.4594 29.5454C15.3391 30.0439 15.3091 30.5726 15.4819 31.0635C15.4969 31.1013 15.5045 31.1239 15.5195 31.1541C15.8126 31.781 16.4063 31.9849 16.9248 31.9849C20.1788 31.9849 23.4328 31.9849 26.6793 31.9849L31.8196 1.09511Z"/>\n            </svg>\n        '),
        "quote-classic": "\n            <svg width=".concat(size, 'px viewBox="0 0 78 58" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M61.8515 58.002C56.4382 58.002 51.9528 56.2233 48.3955 52.666C44.9928 49.1086 43.2915 44.0046 43.2915 37.3539C43.2915 30.2393 45.3022 23.2019 49.3235 16.242C53.4995 9.28196 59.2995 3.86862 66.7235 0.00195312L72.0595 8.12195C64.0168 13.69 59.2222 20.7273 57.6755 29.234C59.0675 28.6153 60.6915 28.306 62.5475 28.306C66.8782 28.306 70.4355 29.698 73.2195 32.482C76.0035 35.266 77.3955 38.8233 77.3955 43.154C77.3955 47.4846 75.9262 51.042 72.9875 53.826C70.0488 56.61 66.3368 58.002 61.8515 58.002ZM19.1635 58.002C13.7502 58.002 9.26485 56.2233 5.70751 52.666C2.30485 49.1086 0.603516 44.0046 0.603516 37.3539C0.603516 30.2393 2.61418 23.2019 6.63551 16.242C10.8115 9.28196 16.6115 3.86862 24.0355 0.00195312L29.3715 8.12195C21.3288 13.69 16.5342 20.7273 14.9875 29.234C16.3795 28.6153 18.0035 28.306 19.8595 28.306C24.1902 28.306 27.7475 29.698 30.5315 32.482C33.3155 35.266 34.7075 38.8233 34.7075 43.154C34.7075 47.4846 33.2382 51.042 30.2995 53.826C27.3608 56.61 23.6488 58.002 19.1635 58.002Z" />\n            </svg>\n        '),
        "regular-circle-chevron-left": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke="').concat(firstColor, '" stroke-width="2" d="M26 18.001L20 24.001L26 30.001"/>\n                <rect stroke="').concat(secondColor, '" stroke-width="2" x="1" y="1.00098" width="46" height="46" rx="23"/>\n            </svg>\n        '),
        "regular-circle-chevron-right": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke="').concat(firstColor, '" stroke-width="2" d="M22 30.001L28 24.001L22 18.001"/>\n                <rect stroke="').concat(secondColor, '" stroke-width="2" x="1" y="1.00098" width="46" height="46" rx="23"/>\n            </svg>\n        '),
        "reports": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M23.5 5H24C25.6569 5 27 6.34315 27 8V26C27 27.6569 25.6569 29 24 29H8C6.34315 29 5 27.6569 5 26V8C5 6.34315 6.34315 5 8 5H8.5"/>\n                <rect fill=').concat(secondColor, ' x="11" y="2" width="10" height="4" rx="2"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M10 12H22"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" d="M10 18H17"/>\n            </svg>\n        '),
        "safety-data": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M9 6.00586C7.34315 6.00586 6 7.34901 6 9.00586V39.0059C6 40.6627 7.34315 42.0059 9 42.0059H22.5C23.3284 42.0059 24 42.6774 24 43.5059C24 44.3343 23.3284 45.0059 22.5 45.0059H9C5.68629 45.0059 3 42.3196 3 39.0059V9.00586C3 5.69215 5.68629 3.00586 9 3.00586H34.5C37.8137 3.00586 40.5 5.69215 40.5 9.00586V18.0059C40.5 18.8343 39.8284 19.5059 39 19.5059C38.1716 19.5059 37.5 18.8343 37.5 18.0059V9.00586C37.5 7.34901 36.1569 6.00586 34.5 6.00586H9ZM10.5 12.0059C10.5 11.1774 11.1716 10.5059 12 10.5059H21C21.8284 10.5059 22.5 11.1774 22.5 12.0059C22.5 12.8343 21.8284 13.5059 21 13.5059H12C11.1716 13.5059 10.5 12.8343 10.5 12.0059ZM10.5 19.5059C10.5 18.6774 11.1716 18.0059 12 18.0059H28.5C29.3284 18.0059 30 18.6774 30 19.5059C30 20.3343 29.3284 21.0059 28.5 21.0059H12C11.1716 21.0059 10.5 20.3343 10.5 19.5059ZM10.5 27.0059C10.5 26.1774 11.1716 25.5059 12 25.5059H16.5C17.3284 25.5059 18 26.1774 18 27.0059C18 27.8343 17.3284 28.5059 16.5 28.5059H12C11.1716 28.5059 10.5 27.8343 10.5 27.0059Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M33.7371 22.7145C34.2079 22.4363 34.7926 22.4363 35.2633 22.7145L44.2631 28.0327C44.7198 28.3025 45 28.7936 45 29.324L45 29.3783C45.0001 31.1472 45.0004 34.0593 43.7565 36.9994C42.4691 40.0423 39.9117 42.9862 35.0498 44.9015C34.6965 45.0407 34.3035 45.0407 33.9502 44.9015C29.0884 42.9862 26.5311 40.0423 25.2437 36.9994C23.9999 34.0595 24 31.1476 24 29.3787C24 29.3604 24 29.3422 24 29.3241C24 28.7936 24.2802 28.3025 24.7369 28.0326L33.7371 22.7145ZM27.0044 30.1774C27.0268 31.8294 27.1646 33.8402 28.0066 35.8305C28.9256 38.0026 30.7376 40.2649 34.5 41.8838C38.2625 40.2649 40.0746 38.0026 40.9936 35.8305C41.8356 33.8402 41.9733 31.8294 41.9957 30.1774L34.5002 25.7482L27.0044 30.1774Z" />\n            </svg>\n        '),
        search: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M6.99234 2.5023C9.47762 2.49881 11.4952 4.51069 11.4987 6.99597C11.5022 9.48125 9.49027 11.4988 7.00499 11.5023C4.51972 11.5058 2.50217 9.49391 2.49867 7.00863C2.49518 4.52335 4.50706 2.5058 6.99234 2.5023ZM6.99023 1.0023C10.3039 0.997644 12.994 3.68016 12.9987 6.99386C13.0006 8.38018 12.5322 9.65734 11.7441 10.6744L14.519 13.4415C14.8123 13.734 14.813 14.2088 14.5205 14.5021C14.228 14.7954 13.7531 14.7961 13.4598 14.5036L10.685 11.7366C9.67006 12.5281 8.39385 13.0003 7.0071 13.0023C3.6934 13.007 1.00333 10.3244 0.998673 7.01074C0.994012 3.69703 3.67652 1.00696 6.99023 1.0023Z"/>\n            </svg>\n        '),
        settings: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M23.7324 17C23.9026 16.7058 24 16.3643 24 16C24 15.6357 23.9026 15.2942 23.7324 15H27C27.5523 15 28 15.4477 28 16C28 16.5523 27.5523 17 27 17H23.7324ZM20.2676 17H5C4.44772 17 4 16.5523 4 16C4 15.4477 4.44772 15 5 15H20.2676C20.0974 15.2942 20 15.6357 20 16C20 16.3643 20.0974 16.7058 20.2676 17Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M11.7324 9C11.9026 8.70583 12 8.36429 12 8C12 7.63571 11.9026 7.29417 11.7324 7H27C27.5523 7 28 7.44772 28 8C28 8.55228 27.5523 9 27 9H11.7324ZM8.26756 9H5C4.44772 9 4 8.55228 4 8C4 7.44772 4.44772 7 5 7H8.26756C8.09739 7.29417 8 7.63571 8 8C8 8.36429 8.09739 8.70583 8.26756 9Z"/>\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M11.7324 25C11.9026 24.7058 12 24.3643 12 24C12 23.6357 11.9026 23.2942 11.7324 23H27C27.5523 23 28 23.4477 28 24C28 24.5523 27.5523 25 27 25H11.7324ZM8.26756 25H5C4.44772 25 4 24.5523 4 24C4 23.4477 4.44772 23 5 23H8.26756C8.09739 23.2942 8 23.6357 8 24C8 24.3643 8.09739 24.7058 8.26756 25Z"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M22 18C23.1046 18 24 17.1046 24 16C24 14.8954 23.1046 14 22 14C20.8954 14 20 14.8954 20 16C20 17.1046 20.8954 18 22 18ZM22 20C24.2091 20 26 18.2091 26 16C26 13.7909 24.2091 12 22 12C19.7909 12 18 13.7909 18 16C18 18.2091 19.7909 20 22 20Z"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M10 26C11.1046 26 12 25.1046 12 24C12 22.8954 11.1046 22 10 22C8.89543 22 8 22.8954 8 24C8 25.1046 8.89543 26 10 26ZM10 28C12.2091 28 14 26.2091 14 24C14 21.7909 12.2091 20 10 20C7.79086 20 6 21.7909 6 24C6 26.2091 7.79086 28 10 28Z"/>\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M10 10C11.1046 10 12 9.10457 12 8C12 6.89543 11.1046 6 10 6C8.89543 6 8 6.89543 8 8C8 9.10457 8.89543 10 10 10ZM10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z"/>\n            </svg>\n        '),
        shield: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M26.3888 6.88791C22.8337 6.88791 18.1562 5.61124 16.4889 3.24594C16.2671 2.95852 15.8684 2.91706 15.5983 3.15311C15.5664 3.18088 15.5372 3.21202 15.5111 3.24594C13.8436 5.61104 9.16608 6.88791 5.61118 6.88791C5.27363 6.88791 5 7.17911 5 7.53835V15.9928C5 23.1442 10.8354 27.4555 15.8322 28.9746C15.9418 29.0085 16.0582 29.0085 16.1678 28.9746C21.1646 27.4555 27 23.1442 27 15.9928V7.53835C27 7.17911 26.7264 6.88791 26.3888 6.88791Z"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" d="M21.5766 16C20.9975 16.5375 20.1204 17.2817 19.1221 17.8981C18.0532 18.558 16.959 19 16 19C15.041 19 13.9468 18.558 12.8779 17.8981C11.8796 17.2817 11.0025 16.5375 10.4234 16C11.0025 15.4625 11.8796 14.7183 12.8779 14.1019C13.9468 13.442 15.041 13 16 13C16.959 13 18.0532 13.442 19.1221 14.1019C20.1204 14.7183 20.9975 15.4625 21.5766 16Z"/>\n                <circle fill=').concat(firstColor, ' cx="16" cy="16" r="2"/>\n            </svg>\n        '),
        shield2: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M14.2739 3.92734C14.4021 3.99338 14.4859 4.12537 14.4934 4.27286C14.4976 4.3568 14.5896 6.35558 13.9289 8.67617C13.5379 10.0492 12.9628 11.2484 12.2195 12.2405C11.2829 13.4908 10.0791 14.4105 8.64157 14.9742C8.59596 14.992 8.548 15.001 8.5 15.001C8.452 15.001 8.40404 14.992 8.35843 14.9742C6.92087 14.4105 5.71707 13.4908 4.78046 12.2405C4.03723 11.2484 3.46213 10.0492 3.07114 8.67617C2.41036 6.35558 2.50239 4.3568 2.50663 4.27286C2.51406 4.12537 2.59792 3.99338 2.72612 3.92734L8.32199 1.04427C8.43406 0.986546 8.56594 0.986546 8.67801 1.04427L14.2739 3.92734ZM12.8584 5.1056L8.50045 2.86035L4.14258 5.10558L4.18301 5.60394C4.23948 6.30014 4.36945 7.26034 4.66696 8.27548C5.30058 10.4372 6.44953 12.0624 8.1368 12.9978L8.50045 13.1994L8.86409 12.9978C10.5514 12.0624 11.7003 10.4373 12.3339 8.27548C12.6314 7.26039 12.7614 6.30018 12.8179 5.60399L12.8584 5.1056ZM6.10641 7.85359C5.90892 7.17976 5.79406 6.52642 5.72783 5.97622L8.50045 4.54773L11.273 5.97621C11.2068 6.52647 11.0919 7.17982 10.8945 7.85359C10.3971 9.55064 9.58004 10.7342 8.50045 11.463C7.42085 10.7342 6.60382 9.55066 6.10641 7.85359Z"/>\n            </svg>\n        '),
        shield3: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16 3L7.07968 5.87514C5.84019 6.27465 5 7.42821 5 8.73049V15.6512C5 18.2142 5.51254 20.7999 7.06618 22.8383C9.07844 25.4784 12.183 28.3556 16 29"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M16 3L24.9203 5.87514C26.1598 6.27465 27 7.42821 27 8.73049V15.6512C27 18.2142 26.4875 20.7999 24.9338 22.8383C22.9216 25.4784 19.817 28.3556 16 29"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M14 15H18"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M17 13.2681L15 16.7322"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M15 13.2681L17 16.7322"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M20 15H24"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M23 13.2681L21 16.7322"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M21 13.2681L23 16.7322"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M8 15H12"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M11 13.2681L9 16.7322"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" d="M9 13.2681L11 16.7322"/>\n            </svg>\n        '),
        shield4: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M9 6.00391C7.34315 6.00391 6 7.34705 6 9.00391V39.0039C6 40.6608 7.34315 42.0039 9 42.0039H22.5C23.3284 42.0039 24 42.6755 24 43.5039C24 44.3323 23.3284 45.0039 22.5 45.0039H9C5.68629 45.0039 3 42.3176 3 39.0039V9.00391C3 5.6902 5.68629 3.00391 9 3.00391H34.5C37.8137 3.00391 40.5 5.6902 40.5 9.00391V18.0039C40.5 18.8323 39.8284 19.5039 39 19.5039C38.1716 19.5039 37.5 18.8323 37.5 18.0039V9.00391C37.5 7.34705 36.1569 6.00391 34.5 6.00391H9ZM10.5 12.0039C10.5 11.1755 11.1716 10.5039 12 10.5039H21C21.8284 10.5039 22.5 11.1755 22.5 12.0039C22.5 12.8323 21.8284 13.5039 21 13.5039H12C11.1716 13.5039 10.5 12.8323 10.5 12.0039ZM10.5 19.5039C10.5 18.6755 11.1716 18.0039 12 18.0039H28.5C29.3284 18.0039 30 18.6755 30 19.5039C30 20.3323 29.3284 21.0039 28.5 21.0039H12C11.1716 21.0039 10.5 20.3323 10.5 19.5039ZM10.5 27.0039C10.5 26.1755 11.1716 25.5039 12 25.5039H16.5C17.3284 25.5039 18 26.1755 18 27.0039C18 27.8323 17.3284 28.5039 16.5 28.5039H12C11.1716 28.5039 10.5 27.8323 10.5 27.0039Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M33.7371 22.7125C34.2079 22.4344 34.7926 22.4344 35.2633 22.7125L44.2631 28.0307C44.7198 28.3006 45 28.7916 45 29.3221L45 29.3763C45.0001 31.1452 45.0004 34.0573 43.7565 36.9975C42.4691 40.0403 39.9117 42.9842 35.0498 44.8995C34.6965 45.0387 34.3035 45.0387 33.9502 44.8995C29.0884 42.9842 26.5311 40.0403 25.2437 36.9975C23.9999 34.0575 24 31.1456 24 29.3767C24 29.3584 24 29.3402 24 29.3222C24 28.7916 24.2802 28.3006 24.7369 28.0307L33.7371 22.7125ZM27.0044 30.1755C27.0268 31.8275 27.1646 33.8383 28.0066 35.8285C28.9256 38.0006 30.7376 40.2629 34.5 41.8819C38.2625 40.2629 40.0746 38.0006 40.9936 35.8285C41.8356 33.8383 41.9733 31.8274 41.9957 30.1755L34.5002 25.7462L27.0044 30.1755Z"/>\n            </svg>\n        '),
        slash: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M15.4229 1.25L10.2666 20.4062H8.5791L13.7354 1.25H15.4229Z"/>\n            </svg>\n        '),
        "solid-circle-chevron-right": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill=').concat(firstColor, ' xmlns="http://www.w3.org/2000/svg">\n                <circle fill="evenodd" cx="12" cy="12.001" r="10"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M10.5 8.00098L14.5 12.001L10.5 16.001"/>\n            </svg>\n        '),
        "square-rounded": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <rect fill=').concat(firstColor, ' x="8" y="8.00293" width="8" height="8" rx="2"/>\n            </svg>\n        '),
        star: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M9.69745 4.79919C9.83492 4.65881 9.93064 4.48305 9.97394 4.29149C10.0172 4.09994 10.0064 3.90014 9.94267 3.71437C9.88284 3.52806 9.77185 3.36227 9.62233 3.23589C9.4728 3.1095 9.29076 3.02759 9.09692 2.9995L6.95002 2.66955C6.94 2.66665 6.93077 2.66156 6.92297 2.65464C6.91518 2.64772 6.90903 2.63915 6.90498 2.62956L5.96414 0.629901C5.88164 0.442653 5.74641 0.283412 5.57492 0.171574C5.40343 0.0597354 5.20309 0.000127015 4.99829 8.9784e-06C4.79586 -0.000827177 4.5975 0.0567564 4.42704 0.165838C4.25659 0.274919 4.1213 0.430856 4.03744 0.614904L3.09661 2.61456C3.09147 2.62431 3.08438 2.6329 3.07576 2.63978C3.06715 2.64666 3.05721 2.65169 3.04656 2.65456L0.904665 2.9995C0.710542 3.02839 0.528245 3.1105 0.37805 3.23671C0.227855 3.36291 0.115649 3.52827 0.0539124 3.71437C-0.00749305 3.90078 -0.0166368 4.10043 0.0274726 4.29166C0.071582 4.4829 0.167261 4.65842 0.304134 4.79919L1.88553 6.42391C1.89009 6.43414 1.89244 6.44521 1.89244 6.4564C1.89244 6.4676 1.89009 6.47867 1.88553 6.4889L1.51521 8.75851C1.48078 8.95617 1.50322 9.15953 1.57993 9.34494C1.65663 9.53036 1.78444 9.69022 1.94851 9.80594C2.11257 9.92166 2.30615 9.98848 2.50673 9.99864C2.70731 10.0088 2.90665 9.96187 3.08159 9.86332L4.94824 8.8285C4.95752 8.82368 4.96782 8.82116 4.97827 8.82116C4.98873 8.82116 4.99902 8.82368 5.0083 8.8285L6.87495 9.86332C7.05012 9.95975 7.24892 10.005 7.44862 9.99392C7.64832 9.98282 7.84086 9.91582 8.00425 9.80058C8.16764 9.68534 8.29527 9.52651 8.37256 9.34223C8.44986 9.15796 8.47369 8.95568 8.44134 8.75851L8.09603 6.4989C8.09076 6.48978 8.08799 6.47943 8.08799 6.4689C8.08799 6.45837 8.09076 6.44803 8.09603 6.43891L9.69745 4.79919Z"/>\n            </svg>\n        '),
        team: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <circle stroke=').concat(firstColor, ' strokeWidth="2" cx="25" cy="12" r="2"/>\n                <circle stroke=').concat(firstColor, ' strokeWidth="2" cx="7" cy="12" r="2"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M21 20C21 18.3431 22.3431 17 24 17H26C27.6569 17 29 18.3431 29 20V24C29 25.1046 28.1046 26 27 26H21V20Z"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M3 20C3 18.3431 4.34315 17 6 17H8C9.65685 17 11 18.3431 11 20V26H5C3.89543 26 3 25.1046 3 24V20Z"/>\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="9" r="3"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M11 18C11 16.3431 12.3431 15 14 15H18C19.6569 15 21 16.3431 21 18V26H11V18Z"/>\n            </svg>\n        '),
        teams: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="16" cy="10" r="5"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" d="M23 27V22C23 18.134 19.866 15 16 15V15C12.134 15 9 18.134 9 22V27"/>\n                <path fill=').concat(firstColor, ' d="M8.5 10C8.66902 10 8.83587 10.0093 9.00005 10.0275C9.00287 10.7649 9.11973 11.4755 9.33391 12.1425C9.0731 12.0502 8.79241 12 8.5 12C7.11929 12 6 13.1193 6 14.5C6 15.741 6.90421 16.7708 8.08975 16.9665C7.5565 17.8781 7.19848 18.9047 7.06189 20H7C5.34315 20 4 21.3431 4 23V26C4 26.5523 3.55228 27 3 27C2.44772 27 2 26.5523 2 26V23C2 20.636 3.64062 18.6551 5.84538 18.134C4.72661 17.3153 4 15.9925 4 14.5C4 12.0147 6.01472 10 8.5 10Z"/>\n                <path fill=').concat(firstColor, ' d="M24.9381 20H25C26.6569 20 28 21.3431 28 23V26C28 26.5523 28.4477 27 29 27C29.5523 27 30 26.5523 30 26V23C30 20.636 28.3594 18.6552 26.1546 18.134C27.2734 17.3153 28 15.9925 28 14.5C28 12.0147 25.9853 10 23.5 10C23.331 10 23.1641 10.0093 23 10.0275C22.9971 10.7649 22.8803 11.4755 22.6661 12.1425C22.9269 12.0502 23.2076 12 23.5 12C24.8807 12 26 13.1193 26 14.5C26 15.741 25.0958 16.7708 23.9103 16.9665C24.4435 17.8781 24.8015 18.9047 24.9381 20Z"/>\n            </svg>\n        '),
        timer: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(secondColor, ' strokeWidth="2" strokeLinecap="round" d="M6.94064 10.4545C9.08177 7.17068 12.7874 5 17 5C23.6274 5 29 10.3726 29 17C29 23.6274 23.6274 29 17 29C14.5031 29 12.1844 28.2374 10.264 26.9325"/>\n                <path stroke=').concat(secondColor, ' strokeWidth="2" d="M20 6V4C20 2.89543 19.1046 2 18 2H16C14.8954 2 14 2.89543 14 4V6"/>\n                <circle stroke=').concat(secondColor, ' strokeWidth="2" cx="17" cy="17.0003" r="2" transform="rotate(45 17 17.0003)"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M18.4142 15.5863L21.9497 12.0508"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 15L10 15"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M4 23H10"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M2 19L10 19"/>\n            </svg>\n        '),
        "video-recording": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 12V8C5 6.34315 6.34315 5 8 5H12"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M5 20V24C5 25.6569 6.34315 27 8 27H12"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M27 20V24C27 25.6569 25.6569 27 24 27H20"/>\n                <path stroke=').concat(firstColor, ' strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M27 12V8C27 6.34315 25.6569 5 24 5H20"/>\n                <circle fill=').concat(secondColor, ' cx="16" cy="16" r="4"/>\n            </svg>\n        '),
        "screen-recording": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M7.5 6.00391C6.67157 6.00391 6 6.67548 6 7.50391V13.5039C6 14.3323 5.32843 15.0039 4.5 15.0039C3.67157 15.0039 3 14.3323 3 13.5039V7.50391C3 5.01862 5.01472 3.00391 7.5 3.00391H13.5C14.3284 3.00391 15 3.67548 15 4.50391C15 5.33233 14.3284 6.00391 13.5 6.00391H7.5ZM33 4.50391C33 3.67548 33.6716 3.00391 34.5 3.00391H40.5C42.9853 3.00391 45 5.01863 45 7.50391V13.5039C45 14.3323 44.3284 15.0039 43.5 15.0039C42.6716 15.0039 42 14.3323 42 13.5039V7.50391C42 6.67548 41.3284 6.00391 40.5 6.00391H34.5C33.6716 6.00391 33 5.33233 33 4.50391ZM4.5 33.0039C5.32843 33.0039 6 33.6755 6 34.5039V40.5039C6 41.3323 6.67157 42.0039 7.5 42.0039H13.5C14.3284 42.0039 15 42.6755 15 43.5039C15 44.3323 14.3284 45.0039 13.5 45.0039H7.5C5.01472 45.0039 3 42.9892 3 40.5039V34.5039C3 33.6755 3.67157 33.0039 4.5 33.0039ZM43.5 33.0039C44.3284 33.0039 45 33.6755 45 34.5039V40.5039C45 42.9892 42.9853 45.0039 40.5 45.0039H34.5C33.6716 45.0039 33 44.3323 33 43.5039C33 42.6755 33.6716 42.0039 34.5 42.0039H40.5C41.3284 42.0039 42 41.3323 42 40.5039V34.5039C42 33.6755 42.6716 33.0039 43.5 33.0039Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M14.5607 14.8219C15.4046 13.978 16.5492 13.5039 17.7426 13.5039H28.5C30.9853 13.5039 33 15.5186 33 18.0039V18.5769L34.6584 17.7477C36.6531 16.7503 39 18.2008 39 20.431V27.5769C39 29.807 36.6531 31.2575 34.6584 30.2601L33 29.431V30.0039C33 32.4892 30.9853 34.5039 28.5 34.5039H13.5C11.0147 34.5039 9 32.4892 9 30.0039V22.2465C9 21.0531 9.47411 19.9085 10.318 19.0646L14.5607 14.8219ZM17.7426 16.5039C17.3448 16.5039 16.9633 16.6619 16.682 16.9432L12.4393 21.1859C12.158 21.4672 12 21.8487 12 22.2465V30.0039C12 30.8323 12.6716 31.5039 13.5 31.5039H28.5C29.3284 31.5039 30 30.8323 30 30.0039V27.0039C30 26.484 30.2692 26.0012 30.7114 25.7279C31.1536 25.4546 31.7058 25.4298 32.1708 25.6623L36 27.5769V20.431L32.1708 22.3455C31.7058 22.578 31.1536 22.5532 30.7114 22.2799C30.2692 22.0066 30 21.5238 30 21.0039V18.0039C30 17.1755 29.3284 16.5039 28.5 16.5039H17.7426Z"/>\n            </svg>\n        '),
        screenshots: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M6 8C6 6.89543 6.89543 6 8 6H12C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4H8C5.79086 4 4 5.79086 4 8V12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12V8Z" fill=').concat(firstColor, ' />\n                <path d="M6 24C6 25.1046 6.89543 26 8 26H12C12.5523 26 13 26.4477 13 27C13 27.5523 12.5523 28 12 28H8C5.79086 28 4 26.2091 4 24V20C4 19.4477 4.44772 19 5 19C5.55228 19 6 19.4477 6 20V24Z" fill=').concat(firstColor, ' />\n                <path d="M24 26C25.1046 26 26 25.1046 26 24V20C26 19.4477 26.4477 19 27 19C27.5523 19 28 19.4477 28 20V24C28 26.2091 26.2091 28 24 28H20C19.4477 28 19 27.5523 19 27C19 26.4477 19.4477 26 20 26H24Z" fill=').concat(firstColor, ' />\n                <path d="M26 8C26 6.89543 25.1046 6 24 6H20C19.4477 6 19 5.55228 19 5C19 4.44772 19.4477 4 20 4H24C26.2091 4 28 5.79086 28 8V12C28 12.5523 27.5523 13 27 13C26.4477 13 26 12.5523 26 12V8Z" fill=').concat(firstColor, ' />\n                <circle cx="16" cy="16" r="4" fill=').concat(secondColor, " />\n            </svg>\n        "),
        fivePointedStar: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M12 -0.00050354L14.6942 8.29129H23.4127L16.3593 13.4159L19.0534 21.7077L12 16.5831L4.94658 21.7077L7.64074 13.4159L0.587322 8.29129H9.30583L12 -0.00050354Z" fill=').concat(firstColor, " />\n            </svg>\n        "),
        slider: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M22 30.001L28 24.001L22 18.001" stroke=').concat(firstColor, ' stroke-width="2"/>\n                <rect x="1" y="1.00098" width="46" height="46" rx="23" stroke=').concat(firstColor, ' stroke-width="2"/>\n            </svg>\n        '),
        export: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M26.2 23.401C25.8686 23.8429 25.9582 24.4697 26.4 24.801C26.8418 25.1324 27.4686 25.0429 27.8 24.601L30.7921 20.6116C30.7977 20.6043 30.8033 20.5968 30.8088 20.5893L31.25 20.001L30.8047 19.4073C30.8019 19.4035 30.7991 19.3998 30.7963 19.3961L27.8 15.401C27.4686 14.9592 26.8418 14.8697 26.4 15.201C25.9582 15.5324 25.8686 16.1592 26.2 16.601L28 19.0011L14 19.0011C13.4477 19.0011 13 19.4488 13 20.0011C13 20.5534 13.4477 21.0011 14 21.0011L28 21.0011L26.2 23.401Z" fill=').concat(firstColor, ' />\n                <path fillRule="evenodd" clipRule="evenodd" d="M5 7.00098C5 5.89641 5.89543 5.00098 7 5.00098H13.5V10.501C13.5 11.3294 14.1716 12.001 15 12.001H21V16.001C21 16.5533 21.4477 17.001 22 17.001C22.5523 17.001 23 16.5533 23 16.001V10.2081C23 9.81026 22.842 9.42873 22.5607 9.14742L16.8536 3.44032C16.5722 3.15901 16.1907 3.00098 15.7929 3.00098H7C4.79086 3.00098 3 4.79184 3 7.00098V25.001C3 27.2101 4.79086 29.001 7 29.001H19C21.2091 29.001 23 27.2101 23 25.001V24.001C23 23.4487 22.5523 23.001 22 23.001C21.4477 23.001 21 23.4487 21 24.001V25.001C21 26.1055 20.1046 27.001 19 27.001H7C5.89543 27.001 5 26.1055 5 25.001V7.00098ZM15.5 5.00098V10.001H20.5858L15.5858 5.00098H15.5Z" fill=').concat(secondColor, " />\n            </svg>\n        "),
        "export-1": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' d="M8.96623 10.4712L8.96967 10.4677C9.25499 10.1824 9.713 10.175 10.0073 10.4456C10.0159 10.4535 10.0243 10.4616 10.0325 10.4699L12.0303 12.4677C12.3232 12.7606 12.3232 13.2355 12.0303 13.5284C11.7374 13.8213 11.2626 13.8213 10.9697 13.5284L10.25 12.8087V16.9981C10.25 17.4123 9.91421 17.7481 9.5 17.7481C9.08579 17.7481 8.75 17.4123 8.75 16.9981V12.8087L8.03033 13.5284C7.73744 13.8213 7.26256 13.8213 6.96967 13.5284C6.67678 13.2355 6.67678 12.7606 6.96967 12.4677L8.96623 10.4712Z" />\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M23.2493 9.96547C23.2409 9.76962 23.1575 9.59322 23.0269 9.46434L15.0338 1.47117C14.8978 1.33342 14.7089 1.24805 14.5 1.24805C14.5 1.24805 14.5 1.24805 14.5 1.24805H9.5C6.92603 1.24805 4.92914 1.75825 3.59467 3.09272C2.2602 4.42719 1.75 6.42407 1.75 8.99805V14.998C1.75 17.572 2.2602 19.5689 3.59467 20.9034C4.92914 22.2378 6.92603 22.748 9.5 22.748H15.5C18.074 22.748 20.0709 22.2378 21.4053 20.9034C22.7398 19.5689 23.25 17.572 23.25 14.998V9.99805C23.25 9.98713 23.2498 9.97627 23.2493 9.96547ZM13.75 2.74805H9.5C7.07397 2.74805 5.57086 3.23785 4.65533 4.15338C3.7398 5.06891 3.25 6.57202 3.25 8.99805V14.998C3.25 17.4241 3.7398 18.9272 4.65533 19.8427C5.57086 20.7582 7.07397 21.248 9.5 21.248H15.5C17.926 21.248 19.4291 20.7582 20.3447 19.8427C21.2602 18.9272 21.75 17.4241 21.75 14.998V10.7481H18.5C16.9585 10.7481 15.6921 10.5008 14.8447 9.6534C13.9972 8.80598 13.75 7.53962 13.75 5.99807V2.74805ZM15.25 5.99807V3.80873L20.6893 9.24807H18.5C17.0415 9.24807 16.3079 8.99532 15.9053 8.59274C15.5028 8.19016 15.25 7.45652 15.25 5.99807Z" />\n            </svg>\n        '),
        activity: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path d="M18 5.00195H8C6.34315 5.00195 5 6.3451 5 8.00195V24.002C5 25.6588 6.34315 27.002 8 27.002H10.5714" stroke=').concat(firstColor, ' stroke-width="2" stroke-linecap="round"/>\n                <path d="M15 27.002H24C25.6569 27.002 27 25.6588 27 24.002V14.002" stroke=').concat(firstColor, ' stroke-width="2" stroke-linecap="round"/>\n                <circle cx="26.5" cy="5.50195" r="2.5" stroke=').concat(secondColor, ' stroke-width="2"/>\n                <path d="M10 19.002C10.2687 18.7332 12.0607 16.9413 13.3387 15.6633C13.711 15.291 14.3079 15.2713 14.7041 15.618L16.4959 17.1859C16.8921 17.5326 17.4893 17.5127 17.8615 17.1404L22 13.002" stroke=').concat(secondColor, ' stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n            </svg>\n        '),
        key: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M10.5 17.2559H7.5C5.01472 17.2559 3 19.2706 3 21.7559V24.7559C3 27.2411 5.01472 29.2559 7.5 29.2559H10.5C12.9853 29.2559 15 27.2411 15 24.7559H24.75H28.5V27.7559C28.5 28.5843 29.1716 29.2559 30 29.2559C30.8284 29.2559 31.5 28.5843 31.5 27.7559V23.2559C31.5 22.4274 30.8284 21.7559 30 21.7559H26.25V19.5059C26.25 18.6774 25.5784 18.0059 24.75 18.0059C23.9216 18.0059 23.25 18.6774 23.25 19.5059V21.7559H15C15 19.2706 12.9853 17.2559 10.5 17.2559ZM12 23.2559V21.7559C12 20.9274 11.3284 20.2559 10.5 20.2559H7.5C6.67157 20.2559 6 20.9274 6 21.7559V24.7559C6 25.5843 6.67157 26.2559 7.5 26.2559H10.5C11.3284 26.2559 12 25.5843 12 24.7559V23.2559Z" />\n                <path fill=').concat(secondColor, ' d="M42.0003 24.0059C42.0003 33.1186 34.613 40.5059 25.5003 40.5059C20.0158 40.5059 15.1563 37.83 12.1561 33.7127C11.8407 33.2798 11.3457 33.0059 10.81 33.0059C9.62025 33.0059 8.87035 34.2633 9.55631 35.2354C13.0864 40.2384 18.9118 43.5059 25.5003 43.5059C36.2698 43.5059 45.0003 34.7754 45.0003 24.0059C45.0003 13.2363 36.2698 4.50586 25.5003 4.50586C19.6543 4.50586 14.4092 7.07835 10.8351 11.1531C9.99493 12.111 10.7381 13.5059 12.0123 13.5059C12.4932 13.5059 12.9457 13.288 13.2686 12.9315C16.2876 9.59907 20.6495 7.50586 25.5003 7.50586C34.613 7.50586 42.0003 14.8932 42.0003 24.0059Z" />\n                <path fill=').concat(secondColor, ' d="M24 36.0928C24 36.8197 24.5322 37.4458 25.2579 37.4854C25.5059 37.499 25.7556 37.5059 26.0069 37.5059C33.4627 37.5059 39.5069 31.4617 39.5069 24.0059C39.5069 16.55 33.4627 10.5059 26.0069 10.5059C25.7556 10.5059 25.5059 10.5127 25.2579 10.5263C24.5322 10.566 24 11.192 24 11.9189C24 12.8411 24.8444 13.5293 25.7664 13.5086C25.8463 13.5068 25.9265 13.5059 26.0069 13.5059C31.8059 13.5059 36.5069 18.2069 36.5069 24.0059C36.5069 29.8048 31.8059 34.5059 26.0069 34.5059C25.9265 34.5059 25.8463 34.505 25.7664 34.5032C24.8444 34.4824 24 35.1706 24 36.0928Z" />\n            </svg>\n        '),
        keystrokes: "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M3 10.5039C3 7.1902 5.68629 4.50391 9 4.50391H39C42.3137 4.50391 45 7.1902 45 10.5039V25.5039C45 28.8176 42.3137 31.5039 39 31.5039H9C5.68629 31.5039 3 28.8176 3 25.5039V10.5039ZM9 7.50391C7.34315 7.50391 6 8.84705 6 10.5039V25.5039C6 27.1608 7.34315 28.5039 9 28.5039H39C40.6569 28.5039 42 27.1608 42 25.5039V10.5039C42 8.84705 40.6569 7.50391 39 7.50391H9Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M16.8 36.604C17.2971 35.9413 18.2373 35.8069 18.9 36.304L24 40.129L29.1 36.304C29.7627 35.8069 30.7029 35.9413 31.2 36.604C31.6971 37.2667 31.5627 38.2069 30.9 38.704L24.9 43.204C24.3667 43.604 23.6333 43.604 23.1 43.204L17.1 38.704C16.4373 38.2069 16.3029 37.2667 16.8 36.604Z"/>\n              <path fill=').concat(secondColor, ' d="M14.25 13.8789C14.25 14.9144 13.4105 15.7539 12.375 15.7539C11.3395 15.7539 10.5 14.9144 10.5 13.8789C10.5 12.8434 11.3395 12.0039 12.375 12.0039C13.4105 12.0039 14.25 12.8434 14.25 13.8789Z"/>\n              <path fill=').concat(secondColor, ' d="M14.25 22.1289C14.25 23.1644 13.4105 24.0039 12.375 24.0039C11.3395 24.0039 10.5 23.1644 10.5 22.1289C10.5 21.0934 11.3395 20.2539 12.375 20.2539C13.4105 20.2539 14.25 21.0934 14.25 22.1289Z"/>\n              <path fill=').concat(secondColor, ' d="M37.5 22.1289C37.5 23.1644 36.6605 24.0039 35.625 24.0039C34.5895 24.0039 33.75 23.1644 33.75 22.1289C33.75 21.0934 34.5895 20.2539 35.625 20.2539C36.6605 20.2539 37.5 21.0934 37.5 22.1289Z"/>\n              <path fill=').concat(secondColor, ' d="M22.005 13.8789C22.005 14.9144 21.1655 15.7539 20.13 15.7539C19.0945 15.7539 18.255 14.9144 18.255 13.8789C18.255 12.8434 19.0945 12.0039 20.13 12.0039C21.1655 12.0039 22.005 12.8434 22.005 13.8789Z"/>\n              <path fill=').concat(secondColor, ' d="M29.76 13.8789C29.76 14.9144 28.9205 15.7539 27.885 15.7539C26.8495 15.7539 26.01 14.9144 26.01 13.8789C26.01 12.8434 26.8495 12.0039 27.885 12.0039C28.9205 12.0039 29.76 12.8434 29.76 13.8789Z"/>\n              <path fill=').concat(secondColor, ' d="M37.5 13.8789C37.5 14.9144 36.6605 15.7539 35.625 15.7539C34.5895 15.7539 33.75 14.9144 33.75 13.8789C33.75 12.8434 34.5895 12.0039 35.625 12.0039C36.6605 12.0039 37.5 12.8434 37.5 13.8789Z"/>\n              <path fill=').concat(firstColor, ' d="M18.255 22.1289C18.255 21.0934 19.0945 20.2539 20.13 20.2539H27.885C28.9205 20.2539 29.76 21.0934 29.76 22.1289C29.76 23.1644 28.9205 24.0039 27.885 24.0039H20.13C19.0945 24.0039 18.255 23.1644 18.255 22.1289Z"/>\n            </svg>\n        '),
        "remote-access": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M24.9639 8.38114C21.2062 8.2489 17.4943 10.5673 16.5295 13.8755L16.2296 14.9037L15.1598 14.9539C12.4926 15.0791 10.6367 15.9369 9.40845 17.0676C8.17212 18.2057 7.48026 19.7036 7.2869 21.2619C6.8875 24.4807 8.58612 27.5131 11.4095 28.2034C12.2142 28.4002 12.7071 29.212 12.5103 30.0167C12.3136 30.8215 11.5017 31.3143 10.697 31.1176C5.99714 29.9685 3.7781 25.177 4.30973 20.8925C4.58189 18.6991 5.56772 16.5256 7.37664 14.8604C9.00084 13.3653 11.2163 12.3459 14.0029 12.0368C15.797 7.75018 20.5739 5.22479 25.0694 5.383C27.5433 5.47006 30.0285 6.36238 31.9845 8.28478C33.6762 9.94743 34.8859 12.295 35.4052 15.3424C37.4941 15.2836 39.2631 15.8388 40.6473 16.8655C42.3401 18.121 43.3091 19.972 43.639 21.8726C44.2803 25.5659 42.521 30.086 38.0465 31.1218C37.2394 31.3087 36.4336 30.8059 36.2468 29.9988C36.06 29.1917 36.5628 28.386 37.3698 28.1991C39.8306 27.6295 41.1416 25.0255 40.6833 22.3858C40.4635 21.1198 39.8402 20.002 38.8601 19.2751C37.8994 18.5625 36.4467 18.1151 34.3413 18.4517L32.7557 18.7053L32.6107 17.1061C32.318 13.8801 31.2344 11.7539 29.8816 10.4244C28.5266 9.09263 26.7859 8.44526 24.9639 8.38114Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M31.8574 25.3838H16.8574L16.8574 34.3838H31.8574V25.3838ZM16.8574 22.3838C15.2006 22.3838 13.8574 23.7269 13.8574 25.3838V34.3838C13.8574 36.0406 15.2006 37.3838 16.8574 37.3838H31.8574C33.5143 37.3838 34.8574 36.0406 34.8574 34.3838V25.3838C34.8574 23.7269 33.5143 22.3838 31.8574 22.3838H16.8574Z" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M16.8574 41.1338C16.8574 40.3054 17.497 39.6338 18.286 39.6338H30.4289C31.2178 39.6338 31.8574 40.3054 31.8574 41.1338C31.8574 41.9622 31.2178 42.6338 30.4289 42.6338H18.286C17.497 42.6338 16.8574 41.9622 16.8574 41.1338Z" />\n            </svg>\n        '),
        "removable-device": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M10.5 15.0039C10.5 13.3471 11.8431 12.0039 13.5 12.0039H34.5C36.1569 12.0039 37.5 13.3471 37.5 15.0039V34.5039C37.5 40.3029 32.799 45.0039 27 45.0039H21C15.201 45.0039 10.5 40.3029 10.5 34.5039V15.0039ZM34.5 15.0039L13.5 15.0039V34.5039C13.5 38.646 16.8579 42.0039 21 42.0039H27C31.1421 42.0039 34.5 38.646 34.5 34.5039V15.0039Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M15 7.50391C15 5.01862 17.0147 3.00391 19.5 3.00391H28.5C30.9853 3.00391 33 5.01863 33 7.50391V13.5039C33 14.3323 32.3284 15.0039 31.5 15.0039C30.6716 15.0039 30 14.3323 30 13.5039V7.50391C30 6.67548 29.3284 6.00391 28.5 6.00391H19.5C18.6716 6.00391 18 6.67548 18 7.50391V13.5039C18 14.3323 17.3284 15.0039 16.5 15.0039C15.6716 15.0039 15 14.3323 15 13.5039V7.50391ZM21 9.00391C21 8.17548 21.6716 7.50391 22.5 7.50391H25.5C26.3284 7.50391 27 8.17548 27 9.00391C27 9.83233 26.3284 10.5039 25.5 10.5039H22.5C21.6716 10.5039 21 9.83233 21 9.00391Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M24 18.0039C24.8284 18.0039 25.5 18.6755 25.5 19.5039V25.7011L27 24.7011V21.0039C27 20.1755 27.6716 19.5039 28.5 19.5039C29.3284 19.5039 30 20.1755 30 21.0039V24.7011C30 25.7042 29.4987 26.6409 28.6641 27.1973L25.5 29.3067V37.5039C25.5 38.3323 24.8284 39.0039 24 39.0039C23.1716 39.0039 22.5 38.3323 22.5 37.5039V33.8067L19.3359 31.6973C18.5013 31.1409 18 30.2042 18 29.2011V25.5039C18 24.6755 18.6716 24.0039 19.5 24.0039C20.3284 24.0039 21 24.6755 21 25.5039V29.2011L22.5 30.2011V19.5039C22.5 18.6755 23.1716 18.0039 24 18.0039Z"/>\n            </svg>\n        '),
        "chat-monitoring": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M3 15.0039C3 11.6902 5.68629 9.00391 9 9.00391H18C18.8284 9.00391 19.5 9.67548 19.5 10.5039C19.5 11.3323 18.8284 12.0039 18 12.0039H9C7.34315 12.0039 6 13.3471 6 15.0039V33.0039C6 34.6608 7.34315 36.0039 9 36.0039H39C40.6569 36.0039 42 34.6608 42 33.0039V25.5039C42 24.6755 42.6716 24.0039 43.5 24.0039C44.3284 24.0039 45 24.6755 45 25.5039V33.0039C45 36.3176 42.3137 39.0039 39 39.0039H9C5.68629 39.0039 3 36.3176 3 33.0039V15.0039ZM16.5 43.5039C16.5 42.6755 17.1716 42.0039 18 42.0039H30C30.8284 42.0039 31.5 42.6755 31.5 43.5039C31.5 44.3323 30.8284 45.0039 30 45.0039H18C17.1716 45.0039 16.5 44.3323 16.5 43.5039Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M34.5 6.00391C30.2324 6.00391 27 9.14617 27 12.7539C27 13.9018 27.3178 14.984 27.8853 15.9361C28.2965 16.6258 28.5005 17.5267 28.2375 18.4366L27.7295 20.1934L30.5675 19.2618C31.183 19.0598 31.8083 19.0771 32.3575 19.2244C33.0342 19.4058 33.7529 19.5039 34.5 19.5039C38.7677 19.5039 42 16.3616 42 12.7539C42 9.14617 38.7677 6.00391 34.5 6.00391ZM24 12.7539C24 7.24894 28.8266 3.00391 34.5 3.00391C40.1735 3.00391 45 7.24894 45 12.7539C45 18.2589 40.1735 22.5039 34.5 22.5039C33.4896 22.5039 32.5097 22.3711 31.5806 22.122C31.5304 22.1086 31.5045 22.1123 31.5008 22.113L25.9678 23.9291C25.4395 24.1025 24.8586 23.9694 24.4585 23.5833C24.0583 23.1972 23.9046 22.6215 24.0591 22.0873L25.3547 17.6059C25.3549 17.6031 25.3549 17.5964 25.3531 17.585C25.349 17.5602 25.3369 17.52 25.3084 17.4722C24.4773 16.078 24 14.4682 24 12.7539Z"/>\n            </svg>    \n        '),
        "fair-performance": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M7.50001 19.5039C7.50001 10.3912 14.8873 3.00391 24 3.00391C33.1127 3.00391 40.5 10.3912 40.5 19.5039C40.5 22.3938 39.7571 25.1102 38.4517 27.4725L44.7412 36.797C45.0738 37.2901 45.0836 37.9332 44.7662 38.4362C44.4488 38.9392 43.8642 39.2072 43.2759 39.1193L37.5927 38.2698L36.2513 43.8574C36.1124 44.4358 35.645 44.8775 35.0597 44.9834C34.4743 45.0892 33.8818 44.8392 33.5492 44.3461L27.6492 35.599C26.4753 35.864 25.254 36.0039 24 36.0039C22.7445 36.0039 21.5218 35.8637 20.3466 35.598L14.4517 44.3375C14.1193 44.8304 13.5272 45.0804 12.9421 44.9749C12.3571 44.8695 11.8895 44.4285 11.75 43.8506L10.4031 38.269L4.72326 39.111C4.13521 39.1982 3.55116 38.9298 3.23423 38.4269C2.91731 37.9239 2.92731 37.2812 3.25974 36.7884L9.54609 27.4685C8.24213 25.1072 7.50001 22.3922 7.50001 19.5039ZM24 6.00391C16.5442 6.00391 10.5 12.0481 10.5 19.5039C10.5 26.9598 16.5442 33.0039 24 33.0039C31.4559 33.0039 37.5 26.9598 37.5 19.5039C37.5 12.0481 31.4559 6.00391 24 6.00391ZM30.6115 34.6259L34.13 39.8423L34.9964 36.233C35.178 35.4767 35.9075 34.9846 36.6767 35.0996L40.3477 35.6483L36.6246 30.1285C35.0027 32.0537 32.9484 33.6028 30.6115 34.6259ZM11.3727 30.1253C12.9942 32.051 15.0481 33.6005 17.3847 34.6243L13.8679 39.8382L12.9977 36.2322C12.8155 35.4775 12.0876 34.9865 11.3196 35.1003L7.6501 35.6443L11.3727 30.1253Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M22.3678 11.7385C22.8816 10.0924 25.1184 10.0924 25.6322 11.7385L26.9656 16.0112H31.2805C32.943 16.0112 33.6343 18.2261 32.2893 19.2435L28.7984 21.8842L30.1318 26.1569C30.6455 27.803 28.8359 29.172 27.4909 28.1546L24 25.5139L20.5091 28.1546C19.1641 29.172 17.3545 27.8031 17.8682 26.1569L19.2016 21.8842L15.7107 19.2435C14.3657 18.2261 15.057 16.0112 16.7195 16.0112H21.0344L22.3678 11.7385ZM24 16.1455L23.4978 17.7546C23.2681 18.4908 22.6092 18.9892 21.8657 18.9892H20.2407L21.5553 19.9837C22.1568 20.4387 22.4085 21.2452 22.1788 21.9814L21.6766 23.5904L22.9913 22.596C23.5928 22.141 24.4072 22.141 25.0087 22.596L26.3234 23.5904L25.8212 21.9814C25.5915 21.2452 25.8432 20.4387 26.4447 19.9837L27.7593 18.9892H26.1343C25.3908 18.9892 24.7319 18.4908 24.5022 17.7546L24 16.1455Z"/>\n            </svg>\n        '),
        "work-life-balance": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M24 33.0039C21.5147 33.0039 19.5 35.0186 19.5 37.5039C19.5 39.9892 21.5147 42.0039 24 42.0039C26.4853 42.0039 28.5 39.9892 28.5 37.5039C28.5 35.0186 26.4853 33.0039 24 33.0039ZM16.5 37.5039C16.5 33.3618 19.8579 30.0039 24 30.0039C28.1421 30.0039 31.5 33.3618 31.5 37.5039C31.5 41.646 28.1421 45.0039 24 45.0039C19.8579 45.0039 16.5 41.646 16.5 37.5039Z"/>\n              <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M44.9825 28.276C45.1085 29.0948 44.5468 29.8607 43.7281 29.9867L4.72805 35.9867C3.90926 36.1126 3.14338 35.551 3.01741 34.7322C2.89144 33.9134 3.45309 33.1475 4.27188 33.0216L43.2719 27.0216C44.0907 26.8956 44.8566 27.4572 44.9825 28.276Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M6.69964 15.8461C6.30992 16.2697 6 16.9197 6 17.9018C6 18.8441 6.37144 19.8917 7.06246 21.0017C7.74786 22.1026 8.68633 23.1661 9.66593 24.1103C10.6403 25.0494 11.6208 25.8375 12.3607 26.3921C12.5 26.4966 12.6304 26.5924 12.75 26.679C12.8696 26.5924 13 26.4966 13.1393 26.3921C13.8792 25.8375 14.8597 25.0494 15.8341 24.1103C16.8137 23.1661 17.7521 22.1026 18.4375 21.0017C19.1286 19.8917 19.5 18.8441 19.5 17.9018C19.5 16.9197 19.1901 16.2697 18.8004 15.8461C18.3968 15.4074 17.8259 15.1239 17.1826 15.0339C15.8439 14.8464 14.5805 15.4996 14.1718 16.7149C13.9664 17.3255 13.3942 17.7368 12.75 17.7368C12.1058 17.7368 11.5336 17.3255 11.3282 16.7149C10.9196 15.4996 9.65605 14.8464 8.31742 15.0339C7.67407 15.1239 7.10321 15.4074 6.69964 15.8461ZM12.75 28.5034C11.9391 29.7654 11.9388 29.7652 11.9385 29.7649L11.9354 29.7629L11.9286 29.7586L11.9063 29.744L11.8276 29.6922C11.7606 29.6477 11.665 29.5835 11.5449 29.5008C11.3049 29.3355 10.966 29.096 10.5612 28.7925C9.75415 28.1875 8.67217 27.319 7.58407 26.2703C6.50117 25.2266 5.37714 23.971 4.51567 22.5872C3.65981 21.2125 3 19.6098 3 17.9018C3 16.2336 3.54945 14.8393 4.49177 13.815C5.42023 12.8057 6.65406 12.2375 7.90133 12.0628C9.56746 11.8295 11.4285 12.2971 12.75 13.5299C14.0715 12.2971 15.9325 11.8295 17.5987 12.0628C18.8459 12.2375 20.0798 12.8057 21.0082 13.815C21.9506 14.8393 22.5 16.2336 22.5 17.9018C22.5 19.6098 21.8402 21.2125 20.9843 22.5872C20.1229 23.971 18.9988 25.2266 17.9159 26.2703C16.8278 27.319 15.7458 28.1875 14.9388 28.7925C14.534 29.096 14.1951 29.3355 13.9551 29.5008C13.835 29.5835 13.7394 29.6477 13.6724 29.6922L13.5937 29.744L13.5714 29.7586L13.5646 29.7629L13.5624 29.7644C13.562 29.7646 13.5609 29.7654 12.75 28.5034ZM12.75 28.5034L13.5609 29.7654C13.0669 30.0828 12.4325 30.0824 11.9385 29.7649L12.75 28.5034Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M25.5 13.5039C25.5 11.0186 27.5147 9.00391 30 9.00391H40.5C42.9853 9.00391 45 11.0186 45 13.5039V19.5039C45 21.9892 42.9853 24.0039 40.5 24.0039H30C27.5147 24.0039 25.5 21.9892 25.5 19.5039V13.5039ZM30 12.0039C29.1716 12.0039 28.5 12.6755 28.5 13.5039V19.5039C28.5 20.3323 29.1716 21.0039 30 21.0039H40.5C41.3284 21.0039 42 20.3323 42 19.5039V13.5039C42 12.6755 41.3284 12.0039 40.5 12.0039H30Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M31.5 16.5039C31.5 15.6755 32.1716 15.0039 33 15.0039H37.5C38.3284 15.0039 39 15.6755 39 16.5039C39 17.3323 38.3284 18.0039 37.5 18.0039H33C32.1716 18.0039 31.5 17.3323 31.5 16.5039Z"/>\n              <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M30 7.50391C30 5.01862 32.0147 3.00391 34.5 3.00391H36C38.4853 3.00391 40.5 5.01863 40.5 7.50391V10.5039C40.5 11.3323 39.8284 12.0039 39 12.0039C38.1716 12.0039 37.5 11.3323 37.5 10.5039V7.50391C37.5 6.67548 36.8284 6.00391 36 6.00391H34.5C33.6716 6.00391 33 6.67548 33 7.50391V10.5039C33 11.3323 32.3284 12.0039 31.5 12.0039C30.6716 12.0039 30 11.3323 30 10.5039V7.50391Z"/>\n            </svg>\n        '),
        "user-experience": "\n            <svg width=".concat(size, "px height=").concat(size, 'px viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">\n                <path fill=').concat(firstColor, ' fillRule="evenodd" clipRule="evenodd" d="M26.836 31.0734C26.8359 31.0732 26.8362 31.0736 26.836 31.0734V31.0734ZM35.2299 28.6742C35.2297 28.674 35.23 28.6744 35.2299 28.6742V28.6742ZM26.0643 38.2104L25.9736 38.2711L21.1879 37.9965C20.3053 37.9458 19.7488 38.2999 19.4898 38.6543L19.4886 38.6559C19.3874 38.7938 19.3357 38.9242 19.3158 39.0328C19.3001 39.1199 19.3091 39.1891 19.3289 39.2428C19.3526 39.302 19.4861 39.544 20.1313 39.6677L20.1334 39.6681L31.3208 41.8374C31.9593 41.9619 32.5749 42.0316 33.1426 41.9992C33.6789 41.9673 34.1681 41.8429 34.6123 41.5854L40.116 38.3992C40.1159 38.3993 40.116 38.3992 40.116 38.3992C41.0088 37.882 41.6198 37.0362 41.8736 36.0886M26.0643 38.2104L26.0714 38.2086L26.0643 38.2104ZM26.0714 38.2086H26.0936L26.1033 38.2053H26.1066L26.2575 38.1549L26.4862 38.0783L26.4895 38.0751L26.4988 38.072L26.5019 38.0688L26.5122 38.0653L26.5155 38.0621L26.5246 38.059L26.5788 38.0047L26.5852 38.0015L26.5886 37.9981L26.6015 37.9916L26.6046 37.9885L26.6116 37.985L26.6733 37.9229C26.7585 37.856 26.836 37.7796 26.9034 37.6967C26.9138 37.6844 26.9224 37.6736 26.9292 37.665C26.9465 37.643 26.9598 37.6242 26.9666 37.6146C26.9681 37.6124 26.9702 37.6094 26.9722 37.6065L26.9808 37.595L27.0022 37.5628L27.0279 37.5241L27.106 37.4065L27.1422 37.2976L27.1618 37.2518L27.1747 37.1999L27.1994 37.1254V37.1222L27.2252 37.0445V37.041L27.2284 37.0313V37.0285L27.2317 37.0187V37.015L27.2349 37.0053V36.9517L27.2381 36.9388V36.7779C27.2381 36.6835 27.2295 36.5901 27.2129 36.4986L27.2074 36.4678L27.1994 36.4358V36.4108L27.1962 36.4011V36.3983L27.1716 36.3242L27.1618 36.2845L27.1471 36.2501L27.0717 36.0228L27.0682 36.0193L27.0652 36.0102L27.0619 36.007L27.0587 35.9974L27.0052 35.9435L27.0016 35.9363L26.9799 35.9146L18.1097 20.4927C18.0991 20.472 18.0831 20.4421 18.0629 20.4084C17.9927 20.2725 17.9767 20.1139 18.018 19.9576C18.0585 19.8072 18.1502 19.678 18.279 19.5942C18.2987 19.5831 18.3142 19.5737 18.3239 19.5678L18.3314 19.5632C18.4635 19.4941 18.6166 19.4786 18.7677 19.5189C18.9284 19.5624 19.0619 19.6626 19.1418 19.8027L23.5591 27.4695C23.5877 27.5262 23.6154 27.5718 23.63 27.5952L25.9257 31.588C26.3339 32.3077 27.2511 32.5589 27.9718 32.1445C28.6923 31.7336 28.9369 30.8151 28.5245 30.1031C28.5239 30.1021 28.5233 30.101 28.5227 30.1L26.1836 26.03C26.1089 25.8888 26.0927 25.7249 26.134 25.5704C26.1781 25.4072 26.2807 25.2692 26.4237 25.1858C26.561 25.1057 26.7246 25.0867 26.8815 25.1293C27.0386 25.172 27.1757 25.2723 27.2604 25.4178C27.2607 25.4182 27.261 25.4187 27.2613 25.4192L27.853 26.4508L27.8688 26.4721L30.1501 30.4415L30.1528 30.4462C30.5643 31.1528 31.4777 31.4088 32.2018 30.9895L32.2065 30.9868C32.9139 30.5719 33.1591 29.6637 32.7482 28.9488L30.4284 24.9163C30.428 24.9156 30.4276 24.9149 30.4272 24.9142C30.3477 24.7725 30.3293 24.6038 30.3721 24.4462L30.375 24.4353C30.4129 24.2889 30.4987 24.1656 30.6174 24.085L30.6571 24.0622C30.8016 23.9791 30.9685 23.9613 31.1203 24.0026L31.1222 24.0031C31.2833 24.0464 31.417 24.1468 31.497 24.287L31.4989 24.2904L34.3196 29.189C34.7279 29.9086 35.645 30.1596 36.3656 29.7453C37.0861 29.3344 37.3307 28.416 36.9184 27.7039C36.9178 27.7029 36.9171 27.7018 36.9165 27.7008L34.7665 23.9581C34.7002 23.8292 34.6835 23.67 34.7257 23.5102L34.7263 23.5079C34.7633 23.3664 34.8489 23.2409 34.9758 23.1552L35.0089 23.1362C35.1534 23.0531 35.3203 23.0353 35.472 23.0765L35.4793 23.0785C35.627 23.1174 35.761 23.2129 35.8475 23.3613C35.8479 23.3619 35.8483 23.3625 35.8486 23.3632L36.1745 23.9336L36.179 23.9381L36.4239 24.3631L36.425 24.3651L36.9035 25.2L36.9071 25.2072L41.5148 33.2167C41.5153 33.2177 41.5159 33.2187 41.5165 33.2197C42.0223 34.1165 42.1242 35.146 41.8736 36.0886M23.0618 35.1065L15.4778 21.9245C14.9832 21.0602 14.8888 20.0792 15.12 19.1947L15.1211 19.1904C15.358 18.301 15.9349 17.4935 16.7976 16.9917L16.8236 16.9766L16.8337 16.9716C17.6918 16.4863 18.6654 16.3942 19.5458 16.6304C20.4372 16.8696 21.2419 17.4509 21.7404 18.3143L21.7413 18.3158L24.4058 22.9501C24.5405 22.838 24.685 22.7344 24.8387 22.6409C24.911 22.5933 24.9782 22.5598 25.0175 22.5416C25.8526 22.094 26.7977 22.0069 27.6562 22.2385C27.8087 22.2793 27.9589 22.3304 28.1055 22.3913C28.3825 22.0328 28.7328 21.7194 29.1517 21.4782C30.0173 20.9754 31.0057 20.8797 31.894 21.1179C32.1148 21.1769 32.3304 21.2568 32.5374 21.3569C32.7833 21.0621 33.0805 20.8017 33.4258 20.5916C33.4764 20.558 33.5234 20.5314 33.5648 20.5099C34.4119 20.042 35.3749 19.9523 36.2434 20.1856C37.115 20.4186 37.8989 20.9785 38.3982 21.803C38.4253 21.8449 38.4442 21.8797 38.4546 21.8993L38.4631 21.9152L38.464 21.9169L39.6385 23.9601V23.9632L44.0687 31.6661C44.0832 31.6894 44.1094 31.7324 44.1355 31.782C45.0357 33.3888 45.2084 35.2143 44.7672 36.8657C44.3252 38.5197 43.2612 40.014 41.6807 40.9563C41.6597 40.9695 41.6165 40.9964 41.5655 41.0238L36.116 44.1829C35.2023 44.7136 34.2438 44.9444 33.3087 44.9967L33.2984 44.9973C32.4101 45.0377 31.547 44.9305 30.7492 44.7765L19.5641 42.607C18.0339 42.3093 16.9755 41.4701 16.5305 40.3111M23.0618 35.1065L21.3583 35.0088C21.3582 35.0088 21.3584 35.0088 21.3583 35.0088C19.4659 34.8999 17.9299 35.7091 17.0694 36.8888C16.7141 37.3718 16.4703 37.922 16.3683 38.5009C16.2581 39.1025 16.3057 39.7263 16.5305 40.3111" />\n                <path fill=').concat(secondColor, ' fillRule="evenodd" clipRule="evenodd" d="M15 6.45483C10.2661 6.45483 6.42857 10.3152 6.42857 15.0773C6.42857 19.3479 9.51678 22.8964 13.5694 23.5804C14.5031 23.738 15.133 24.6271 14.9764 25.5664C14.8197 26.5057 13.9358 27.1394 13.0021 26.9818C7.32535 26.0238 3 21.0603 3 15.0773C3 8.41041 8.37258 3.00586 15 3.00586C21.6274 3.00586 27 8.41041 27 15.0773C27 15.9044 26.917 16.7139 26.7585 17.4971C26.5696 18.4303 25.6643 19.0328 24.7366 18.8428C23.8089 18.6527 23.2099 17.7421 23.3989 16.8089C23.5118 16.2509 23.5714 15.672 23.5714 15.0773C23.5714 10.3152 19.7339 6.45483 15 6.45483Z" />\n            </svg>\n        ')
    };
};


;// CONCATENATED MODULE: ./src/components/UI/Icon/Icon.jsx








var Icon = function(param) {
    var mods = param.mods, name = param.name, size = param.size, color = param.color, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Icon, {
        mods: mods
    }).className;
    var ref = (0,_sliced_to_array/* default */.Z)(findColorByName(color), 2), firstColor = ref[0], secondColor = ref[1];
    var icon = getIcon(size, firstColor, secondColor);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.Z, {
            src: icon[name]
        })
    });
};
Icon.displayName = "Icon";
Icon.propTypes = {
    color: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]).isRequired,
    mods: (prop_types_default()).object,
    name: (prop_types_default()).string.isRequired,
    size: (prop_types_default()).number
};
Icon.defaultProps = {
    mods: {},
    size: 32
};
/* harmony default export */ var Icon_Icon = (Icon);

;// CONCATENATED MODULE: ./src/components/UI/Icon/index.js

/* harmony default export */ var UI_Icon = (Icon_Icon);


/***/ }),

/***/ 57202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Link; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Link/Link.jsx








var Link = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, href = param.href, target = param.target, onClick = param.onClick, classNameTail = param.className, linkProps = param.linkProps;
    var className = (0,useMods/* default */.Z)(Link, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        prefetch: false,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            className: (0,css/* default */.Z)(className, classNameTail),
            target: target
        }, linkProps), {
            children: children
        }))
    });
};
Link.displayName = "Link";
Link.propTypes = {
    children: (prop_types_default()).node,
    href: (prop_types_default()).string,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    onClick: (prop_types_default()).func,
    target: (prop_types_default()).string
};
Link.defaultProps = {
    mods: {}
};
/* harmony default export */ var Link_Link = (Link);

;// CONCATENATED MODULE: ./src/components/UI/Link/index.js

/* harmony default export */ var UI_Link = (Link_Link);


/***/ }),

/***/ 61316:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Logo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./src/assets/Images/logoDark.svg
var logoDark = __webpack_require__(95176);
var logoDark_default = /*#__PURE__*/__webpack_require__.n(logoDark);
// EXTERNAL MODULE: ./src/assets/Images/logoLight.svg
var logoLight = __webpack_require__(97271);
var logoLight_default = /*#__PURE__*/__webpack_require__.n(logoLight);
// EXTERNAL MODULE: ./src/assets/Images/logoWithoutText.svg
var logoWithoutText = __webpack_require__(51937);
var logoWithoutText_default = /*#__PURE__*/__webpack_require__.n(logoWithoutText);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Logo/Logo.jsx







var Logo = function(param) {
    var mods = param.mods, type = param.type, width = param.width, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Logo, {
        mods: mods
    }).className;
    return(// eslint-disable-next-line @next/next/no-img-element
    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: type === "light" ? (logoLight_default()) : type === "dark" ? (logoDark_default()) : (logoWithoutText_default()),
        className: className + (classNameTail ? " " + classNameTail : ""),
        width: width,
        alt: "Go to the main page"
    }));
};
Logo.displayName = "Logo";
Logo.propTypes = {
    mods: (prop_types_default()).object,
    type: (prop_types_default()).string,
    width: (prop_types_default()).number
};
Logo.defaultProps = {
    mods: {},
    type: "withoutText"
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ./src/components/UI/Logo/index.js

/* harmony default export */ var UI_Logo = (Logo_Logo);


/***/ }),

/***/ 12881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ UI_Modal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./src/components/UI/Modal/Modal.jsx






var Modal = function(param) {
    var onClose = param.onClose, children = param.children;
    var overlay = (0,react.useRef)(null);
    var wrapper = (0,react.useRef)(null);
    var handleCloseClick = function(e) {
        e.preventDefault();
        onClose();
    };
    var onKeyDown = function(e) {
        if (e.key === "Escape") handleCloseClick(e);
    };
    (0,react.useEffect)(function() {
        document.addEventListener("keydown", onKeyDown);
        return function() {
            return document.removeEventListener("keydown", onKeyDown);
        };
    }, [
        onKeyDown
    ]);
    var modalContent = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ref: overlay,
        className: "fixed bottom-0 left-0 right-0 top-0 z-[1040] mx-auto bg-neutral-900/50",
        onClick: handleCloseClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            ref: wrapper,
            className: "absolute left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 p-7 sm:w-10/12 lg:w-[984px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    className: "absolute right-0 top-0",
                    variant: "link",
                    onClick: handleCloseClick,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "close",
                        color: [
                            "neutral-100"
                        ],
                        size: 24
                    })
                }),
                children
            ]
        })
    });
    return /*#__PURE__*/ react_dom.createPortal(modalContent, document.getElementById("modal-root"));
};
Modal.displayName = "Modal";
Modal.propTypes = {
    children: (prop_types_default()).node,
    onClose: (prop_types_default()).func
};
/* harmony default export */ var Modal_Modal = (Modal);

;// CONCATENATED MODULE: ./src/components/UI/Modal/index.js

/* harmony default export */ var UI_Modal = (Modal_Modal);


/***/ }),

/***/ 70408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Heading; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Typography/Heading/Heading.jsx






var Heading = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, tag = param.tag, color = param.color, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Heading, {
        mix: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mix), {
            tag: tag
        }),
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            color: color
        })
    }, true).className;
    var TagName = tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagName, {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
Heading.displayName = "Heading";
Heading.propTypes = {
    children: (prop_types_default()).node,
    color: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).bool
    ]),
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    tag: (prop_types_default()).string
};
Heading.defaultProps = {
    mix: {},
    mods: {},
    tag: "h1"
};
/* harmony default export */ var Heading_Heading = (Heading);

;// CONCATENATED MODULE: ./src/components/UI/Typography/Heading/index.js

/* harmony default export */ var Typography_Heading = (Heading_Heading);


/***/ }),

/***/ 39466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Typography_Paragraph; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/UI/Typography/Paragraph/Paragraph.jsx







var Paragraph = function(param) {
    var children = param.children, mix = param.mix, mods = param.mods, tag = param.tag, size = param.size, color = param.color, id = param.id, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(Paragraph, {
        mix: mix,
        mods: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, mods), {
            color: color,
            size: size
        })
    }, true).className;
    var TagName = tag;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TagName, {
        className: className + (classNameTail ? " " + classNameTail : ""),
        id: id,
        children: children
    });
};
Paragraph.displayName = "Paragraph";
Paragraph.propTypes = {
    children: (prop_types_default()).node,
    color: (prop_types_default()).string,
    id: (prop_types_default()).string,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object,
    size: (prop_types_default()).string,
    tag: (prop_types_default()).string
};
Paragraph.defaultProps = {
    mix: {},
    mods: {},
    tag: "p"
};
/* harmony default export */ var Paragraph_Paragraph = (Paragraph);

;// CONCATENATED MODULE: ./src/components/UI/Typography/Paragraph/index.js

/* harmony default export */ var Typography_Paragraph = (Paragraph_Paragraph);


/***/ }),

/***/ 26451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_VideoModal; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Icon/index.js + 3 modules
var Icon = __webpack_require__(60726);
// EXTERNAL MODULE: ./src/components/UI/Modal/index.js + 1 modules
var Modal = __webpack_require__(12881);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/VideoModal/VideoModal.jsx





var VideoModal = function(param) {
    var videoUrl = param.videoUrl, className = param.className, iconSize = param.iconSize, btnText = param.btnText;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    (0,react.useEffect)(function() {
        if (document) {
            document.body.style.overflow = showModal ? "hidden" : "auto";
        }
    }, [
        showModal
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: className,
                onClick: function() {
                    return setShowModal(true);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                        name: "playVideo",
                        color: [
                            "violet-700",
                            "neutral-100"
                        ],
                        size: iconSize
                    }),
                    btnText
                ]
            }),
            showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                onClose: function() {
                    return setShowModal(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                    className: "w-full aspect-video",
                    loading: "lazy",
                    src: videoUrl,
                    title: "Traqq: Time Tracker for on-site and remote teams",
                    frameBorder: "0",
                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                    allowFullScreen: true
                })
            })
        ]
    });
};
VideoModal.displayName = "VideoModal";
VideoModal.propTypes = {
    videoUrl: (prop_types_default()).string,
    className: (prop_types_default()).string,
    iconSize: (prop_types_default()).number,
    btnText: (prop_types_default()).string
};
VideoModal.defaultProps = {
    className: "",
    iconSize: 32,
    btnText: ""
};
/* harmony default export */ var VideoModal_VideoModal = (VideoModal);

;// CONCATENATED MODULE: ./src/components/VideoModal/index.js

/* harmony default export */ var components_VideoModal = (VideoModal_VideoModal);


/***/ }),

/***/ 19531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useMods; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/lodash/isObject.js
var isObject = __webpack_require__(13218);
var isObject_default = /*#__PURE__*/__webpack_require__.n(isObject);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useMods/useMods.js
/**
 * @author Aleksey I. Chelnokov <aleksey.chelnokov@auslogics.com>
 * @copyright Copyright (c) 2021 Auslogics Labs Pty Ltd (https://www.auslogics.com)
 */ 





/**
 * Набор функций для работы с состоянием (get/set/del для mods/mix)
 * @param {Object} state объект состояния
 * @param {function (Object): void} setState сеттер нового состояния
 * @returns {Object}
 */ var createStateApi = function(state, setState) {
    var getVal = function(name) {
        return state[name];
    };
    var setVal = function(name, value) {
        if (getVal(name) !== value) {
            setState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), (0,_define_property/* default */.Z)({}, name, value)));
        }
    };
    var delVal = function(name) {
        setState(function(prevState) {
            var nextState = (0,_object_spread/* default */.Z)({}, prevState);
            delete nextState[name];
            return nextState;
        });
    };
    return {
        delVal: delVal,
        getVal: getVal,
        setVal: setVal
    };
};
/**
 * Сборка массива CSS-классов для компонента
 * @param {React.Component} component компонент React
 * @param {string} className дополнительные CSS-классы
 * @param {boolean} shortName укоротить CSS-классы
 * @param {Object} mods модификаторы
 * @param {function (string): boolean | number | string} getMod геттер значения модификатора
 * @param {Object} mix миксы
 * @param {function (string): boolean | number | string} getMix геттер значения микса
 * @returns {string[]}
 */ var buildClassList = function(component, className, shortName, mods, getMod, mix, getMix) {
    var componentDisplayName = getComponentDisplayName(component);
    var classList = [
        componentDisplayName
    ];
    if (className && typeof className === "string") {
        classList.push(className);
    }
    // CSS-классы модификаторов
    var modClassList = bemClassList(mods, getMod, componentDisplayName, shortName);
    // CSS-классы миксов
    var mixClassList = bemClassList(mix, getMix, "", shortName);
    return (0,_to_consumable_array/* default */.Z)(classList).concat((0,_to_consumable_array/* default */.Z)(modClassList), (0,_to_consumable_array/* default */.Z)(mixClassList));
};
/**
 * Get display name for React component instance.
 * @param {Object} componentInstance
 * @return {string}
 */ var getComponentDisplayName = function(componentInstance) {
    var componentName = componentInstance.displayName || componentInstance.constructor.displayName || componentInstance.constructor.name || "Component";
    return componentName.toLowerCase();
};
/**
 * Сборка массива CSS-классов в стиле BEM (для mods/mix)
 * @param {Object} values объект mods/mix
 * @param {function (string): boolean | number | string} getter функция получения значения mod/mix из values
 * @param {string} prefix префикс к названию CSS-класса
 * @returns {string[]}
 */ var bemClassList = function(values, getter, prefix, shortName) {
    var classList = [];
    if (prefix) prefix += "_";
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.keys(values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var name = _step.value;
            var val = getter(name);
            if (typeof val === "boolean" && val) {
                classList.push("".concat(prefix).concat(name));
            } else if (typeof val === "number" || typeof val === "string") {
                shortName ? name = "" : name += "_";
                classList.push("".concat(prefix).concat(name).concat(String(val).replace(/\s+/g, "-")));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return classList;
};
/**
 * Проверка двух объектов на идентичность с точки зрения BEM.
 * Предназначается для проверки эквивалентности объектов модификаторов и миксов.
 * Проверка происходит лишь на самом верхнем уровне вложенности.
 * @param {Object} first первый объект
 * @param {Object} second второй объект
 * @returns {boolean} идентичность объектов с точки зрения BEM
 */ var compareBem = function(first, second) {
    if (!isObject_default()(first) || !isObject_default()(second)) {
        return false;
    }
    var firstKeys = new Set(Object.keys(first));
    var secondKeys = new Set(Object.keys(second));
    var allKeys = new Set((0,_to_consumable_array/* default */.Z)(firstKeys).concat((0,_to_consumable_array/* default */.Z)(secondKeys)));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = allKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (!firstKeys.has(key) || !secondKeys.has(key) || first[key] !== second[key]) {
                return false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
};
/**
 * Hook для работы с mods/mix
 * @param {React.Component} component компонент React
 * @param {Object} options дополнительные CSS-классы, начальные mods и mix
 * @returns {Object} API для работы с mods/mix
 */ var useMods = function(component) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, className = ref.className, tmp = ref.mods, outerMods = tmp === void 0 ? {} : tmp, tmp1 = ref.mix, outerMix = tmp1 === void 0 ? {} : tmp1, shortName = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // модификаторы
    var ref1 = (0,react.useState)(function() {
        return isObject_default()(outerMods) ? outerMods : {};
    }), mods = ref1[0], setMods = ref1[1];
    var ref2 = createStateApi(mods, setMods), getMod = ref2.getVal, setMod = ref2.setVal, delMod = ref2.delVal;
    // если внешние модификаторы изменились, то обновить состояние
    if (!compareBem(mods, outerMods)) {
        setMods(outerMods);
    }
    // миксы
    var ref3 = (0,react.useState)(function() {
        return isObject_default()(outerMix) ? outerMix : {};
    }), mix = ref3[0], setMixes = ref3[1];
    var ref4 = createStateApi(mix, setMixes), getMix = ref4.getVal, setMix = ref4.setVal, delMix = ref4.delVal;
    // если внешние миксы изменились, то обновить состояние
    if (!compareBem(mix, outerMix)) {
        setMixes(outerMix);
    }
    // итоговый массив CSS-классов
    var classList = buildClassList(component, className, shortName, mods, getMod, mix, getMix);
    return {
        className: classList.join(" "),
        delMix: delMix,
        delMod: delMod,
        getMix: getMix,
        getMod: getMod,
        setMix: setMix,
        setMod: setMod
    };
};
/* harmony default export */ var useMods_useMods = (useMods);

;// CONCATENATED MODULE: ./src/hooks/useMods/index.js

/* harmony default export */ var hooks_useMods = (useMods_useMods);


/***/ }),

/***/ 88194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(828);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);



var useUtmTags = function(href, tags) {
    if (!tags) return href;
    //utm tags should work only for these pages
    var activePages = [
        "time-tracking",
        "team-management",
        "team-reporting",
        "employee-monitoring",
        "attendance-tracking",
        "employee-productivity-tracking-software",
        "time-tracking-app-for-enterprises",
        "time-tracking-app-for-small-businesses",
        "time-tracking-app-for-agencies",
        "time-tracking-app-for-teams",
        "time-tracking-app-for-freelancers",
        "screen-monitoring",
        "updates"
    ];
    var url = false;
    try {
        url = new URL(href, "https://traqq.com");
    } catch (e) {
        return href;
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    //const page = router.pathname.split('/').at(-1);//safari - bug
    var page = router.pathname.substring(router.pathname.lastIndexOf("/") + 1);
    if (!page || !activePages.includes(page)) return href;
    //we have the only value for utm_source for all active pages
    tags = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, tags, {
        utm_content: page ? page : "home",
        utm_source: "seo_productpage"
    });
    Object.entries(tags).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        url.searchParams.append(key, value);
    });
    return url.toString();
};
/* harmony default export */ __webpack_exports__["Z"] = (useUtmTags);


/***/ }),

/***/ 23897:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Ads_SwitchToTraqqLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/Ads/SwitchToTraqqWideText/SwitchToTraqqBg.jsx




var SwitchToTraqqWideBg = function(param) {
    var mods = param.mods;
    var className = (0,useMods/* default */.Z)(SwitchToTraqqWideBg, {
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className
    });
};
SwitchToTraqqWideBg.displayName = "Switch-To-Traqq-Wide__Bg";
SwitchToTraqqWideBg.propTypes = {
    mods: (prop_types_default()).object
};
SwitchToTraqqWideBg.defaultProps = {
    mods: {}
};
/* harmony default export */ var SwitchToTraqqBg = (SwitchToTraqqWideBg);

// EXTERNAL MODULE: ./src/components/Ads/SwitchToTraqqWideText/SwitchToTraqqText.jsx
var SwitchToTraqqText = __webpack_require__(33664);
;// CONCATENATED MODULE: ./src/components/Ads/SwitchToTraqqWideText/SwitchToTraqq.jsx






var SwitchToTraqqWide = function(param) {
    var mods = param.mods, bg = param.bg;
    var className = (0,useMods/* default */.Z)(SwitchToTraqqWide, {
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToTraqqBg, {
                mods: {
                    bg: bg
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToTraqqText/* default */.Z, {})
        ]
    });
};
SwitchToTraqqWide.displayName = "Switch-To-Traqq-Wide";
SwitchToTraqqWide.propTypes = {
    bg: (prop_types_default()).string.isRequired,
    mods: (prop_types_default()).object
};
SwitchToTraqqWide.defaultProps = {
    mods: {}
};
/* harmony default export */ var SwitchToTraqq = (SwitchToTraqqWide);

;// CONCATENATED MODULE: ./src/components/Ads/SwitchToTraqqWideText/index.js

/* harmony default export */ var SwitchToTraqqWideText = (SwitchToTraqq);

// EXTERNAL MODULE: ./src/components/Grid/index.js + 1 modules
var Grid = __webpack_require__(4711);
// EXTERNAL MODULE: ./src/components/Info/index.js + 1 modules
var Info = __webpack_require__(54491);
// EXTERNAL MODULE: ./src/components/Section/index.js + 2 modules
var Section = __webpack_require__(62091);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/Container/index.js + 1 modules
var Container = __webpack_require__(76956);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/UI/Typography/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(39466);
;// CONCATENATED MODULE: ./src/layouts/Ads/SwitchToTraqqLayout/SwitchToTraqqLayout.jsx










var SwitchToTraqqLayout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "switch-to-traqq-layout",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
            mods: {
                "bg-neutral": 900
            },
            className: "!mb-0 py-8 480:py-12 1024:py-18 1280:py-[86px]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                    sm: 1,
                    md: 2,
                    items: "center",
                    gx: 6,
                    gy: 8,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Info/* default */.Z, {
                            gap: 4,
                            mods: {
                                md: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "h2 heading heading_white",
                                    children: "Get a competitor discount"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                                    tag: "p",
                                    size: "lg",
                                    color: "white",
                                    children: [
                                        "If you use another time tracker or employee monitoring ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            className: "hidden 1280:inline"
                                        }),
                                        " software, ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            className: "hidden 768:max-1024:inline"
                                        }),
                                        "you can get Traqq ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                            className: "hidden 480:max-768:inline"
                                        }),
                                        " at up to 30% off."
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    tag: "a",
                                    type: "link",
                                    href: "/switch-to-traqq-discount",
                                    variant: "primary",
                                    size: "lg",
                                    children: "Get a discount"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToTraqqWideText, {
                            bg: "narrow",
                            mods: {
                                order: "first"
                            }
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var SwitchToTraqqLayout_SwitchToTraqqLayout = (SwitchToTraqqLayout);

;// CONCATENATED MODULE: ./src/layouts/Ads/SwitchToTraqqLayout/index.js

/* harmony default export */ var Ads_SwitchToTraqqLayout = (SwitchToTraqqLayout_SwitchToTraqqLayout);


/***/ }),

/***/ 65305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/UI/Button/index.js + 1 modules
var Button = __webpack_require__(92317);
// EXTERNAL MODULE: ./src/components/UI/Link/index.js + 1 modules
var Link = __webpack_require__(57202);
// EXTERNAL MODULE: ./src/utils/renderIf.js
var renderIf = __webpack_require__(79810);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(31955);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/CookieAccept/cookie.png
/* harmony default export */ var CookieAccept_cookie = ({"src":"/_next/static/media/cookie.faa2b563.png","height":80,"width":80,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABBElEQVR42mP4sNSNhQEI3i91s/243GvVo0lWc86Xy9iBxG5viGdk+LErgvXDUpfIz+v9F3/fHPr/zmT7//dmOv9/M8O6mgEEvm8P4Hm/2Dn/66bAcxcnOvz/tCbg54f1If9v9Fv//zjH1pHhaYeWyP/9UXE/dkT+/7It8v+nTWH/P28J//16pf//t3Md5zC8mGw+/f5C7//fd0b/uznX6/+ZyS7/gYp/P1rs8//DItd+hjezbKPvzHD5/351wO8f2yP/vFzp/+fdmsB/92a7/n8+2cwR4o6VXtPuTHf6D5T4f3um6/+nCzz+P51u28GADK41aSU8n+204MsqnxUflrjHwMQBw2OLRvPlg3QAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/components/CookieAccept/index.jsx








var CookieAccept = function() {
    var isReady = (0,router.useRouter)().isReady;
    var ref = (0,react.useState)(false), visible = ref[0], setVisible = ref[1];
    var cookie = {
        name: "CookieAccept",
        value: "true",
        path: "/"
    };
    var accept = function() {
        js_cookie/* default.set */.Z.set(cookie.name, cookie.value, {
            path: cookie.path
        });
        setVisible(false);
    };
    (0,react.useEffect)(function() {
        if (isReady && js_cookie/* default.get */.Z.get("CookieAccept") === undefined) {
            setVisible(true);
        }
    }, [
        isReady
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
        isTrue: visible,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "sticky bottom-0 z-[666]",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " absolute bottom-0 right-0 bg-white rounded-t-[12px] p-6 gap-y-6 w-full flex flex-col cookie-shadow 768:w-[340px] 768:bottom-8 768:right-8 768:rounded-[12px] 1024:bottom-12 1024:right-12 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row gap-3 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: CookieAccept_cookie.src,
                                        alt: "Cookie consent",
                                        width: 40,
                                        height: 40
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "paragraph paragraph_lg font-[700]",
                                        children: "Hey, we use cookies ;)"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "paragraph paragraph_xs !text-neutral-700",
                                children: [
                                    "Traqq uses cookies to improve content and ensure you get the best experience on our website. By continuing to browse our website, you agree to our ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        mods: {
                                            underline: true
                                        },
                                        href: "/legal/privacy",
                                        children: "privacy policy"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        onClick: accept,
                        className: "!px-6 !py-2.5 w-full basis-[content] self-center",
                        buttonProps: {
                            "tabIndex": 0
                        },
                        children: "OK"
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_CookieAccept = (CookieAccept);

// EXTERNAL MODULE: ./src/layouts/Ads/SwitchToTraqqLayout/index.js + 4 modules
var SwitchToTraqqLayout = __webpack_require__(23897);
// EXTERNAL MODULE: ./src/hooks/useMods/index.js + 1 modules
var useMods = __webpack_require__(19531);
// EXTERNAL MODULE: ./src/assets/Images/get-on-traqq-layout-bg-1.svg
var get_on_traqq_layout_bg_1 = __webpack_require__(91542);
var get_on_traqq_layout_bg_1_default = /*#__PURE__*/__webpack_require__.n(get_on_traqq_layout_bg_1);
// EXTERNAL MODULE: ./src/assets/Images/get-on-traqq-layout-bg-2.svg
var get_on_traqq_layout_bg_2 = __webpack_require__(49807);
var get_on_traqq_layout_bg_2_default = /*#__PURE__*/__webpack_require__.n(get_on_traqq_layout_bg_2);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/components/Ads/GetOnTraqq/GetOnTraqqBg.jsx






var GetOnTraqqBg = function(param) {
    var mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(GetOnTraqqBg, {
        mix: mix,
        mods: mods
    }, true).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "get-on-traqq-bg__left",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (get_on_traqq_layout_bg_1_default()),
                    alt: "Ready to get on Traqq?"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "get-on-traqq-bg__right",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: (get_on_traqq_layout_bg_2_default()),
                    alt: "Start track time"
                })
            })
        ]
    });
};
GetOnTraqqBg.displayName = "Get-On-Traqq-Bg";
GetOnTraqqBg.propTypes = {
    mods: (prop_types_default()).object
};
GetOnTraqqBg.defaultProps = {
    mods: {}
};
/* harmony default export */ var GetOnTraqq_GetOnTraqqBg = (GetOnTraqqBg);

// EXTERNAL MODULE: ./src/components/Section/index.js + 2 modules
var Section = __webpack_require__(62091);
// EXTERNAL MODULE: ./src/components/UI/Container/index.js + 1 modules
var Container = __webpack_require__(76956);
;// CONCATENATED MODULE: ./src/layouts/Ads/GetOnTraqqLayout/GetOnTraqqLayout.jsx






var GetOnTraqqLayout = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "get-on-traqq-layout",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section/* default */.Z, {
            mods: {
                "bg-neutral": 900
            },
            className: "!mb-0 py-113p md:py-100p 1024:py-[134px]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(GetOnTraqq_GetOnTraqqBg, {
                    mix: {
                        "get-on-traqq-layout__bg": true
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "relative flex flex-col items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "heading heading_text-center heading_white h1",
                            children: "Ready to get on Traqq?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            tag: "a",
                            type: "link",
                            href: "".concat("https://newapp.traqq.com", "/signup"),
                            variant: "primary",
                            size: "lg",
                            className: "mt-6 md:mt-12",
                            children: "Start Now"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var GetOnTraqqLayout_GetOnTraqqLayout = (GetOnTraqqLayout);

;// CONCATENATED MODULE: ./src/layouts/Ads/GetOnTraqqLayout/index.js

/* harmony default export */ var Ads_GetOnTraqqLayout = (GetOnTraqqLayout_GetOnTraqqLayout);

;// CONCATENATED MODULE: ./src/components/Footer/Footer.jsx




var Footer = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(Footer, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: className,
        children: children
    });
};
Footer.displayName = "Footer";
Footer.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
Footer.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Footer_Footer = (Footer);

// EXTERNAL MODULE: ./src/utils/css.js
var css = __webpack_require__(75632);
;// CONCATENATED MODULE: ./src/components/Footer/FooterAction.jsx





var FooterAction = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(FooterAction, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
FooterAction.displayName = "Footer-Action";
FooterAction.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
FooterAction.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Footer_FooterAction = (FooterAction);

;// CONCATENATED MODULE: ./src/components/Footer/FooterCopyright.jsx




var FooterCopyright = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(FooterCopyright, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: className + (classNameTail ? " " + classNameTail : ""),
        children: children
    });
};
FooterCopyright.displayName = "Footer-Copyright";
FooterCopyright.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
FooterCopyright.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Footer_FooterCopyright = (FooterCopyright);

;// CONCATENATED MODULE: ./src/components/Footer/FooterNav.jsx





var FooterNav = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix, classNameTail = param.className;
    var className = (0,useMods/* default */.Z)(FooterNav, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,css/* default */.Z)(className, classNameTail),
        children: children
    });
};
FooterNav.displayName = "Footer-Nav";
FooterNav.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
FooterNav.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Footer_FooterNav = (FooterNav);

;// CONCATENATED MODULE: ./src/components/Footer/FooterNavItem.jsx




var FooterNavItem = function(param) {
    var children = param.children, mods = param.mods, mix = param.mix;
    var className = (0,useMods/* default */.Z)(FooterNavItem, {
        mix: mix,
        mods: mods
    }).className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: className,
        children: children
    });
};
FooterNavItem.displayName = "Footer-Nav__Item";
FooterNavItem.propTypes = {
    children: (prop_types_default()).node,
    mix: (prop_types_default()).object,
    mods: (prop_types_default()).object
};
FooterNavItem.defaultProps = {
    mix: {},
    mods: {}
};
/* harmony default export */ var Footer_FooterNavItem = ((/* unused pure expression or super */ null && (FooterNavItem)));

;// CONCATENATED MODULE: ./src/components/Footer/index.js







// EXTERNAL MODULE: ./src/components/Grid/index.js + 1 modules
var Grid = __webpack_require__(4711);
// EXTERNAL MODULE: ./src/components/Nav/index.js + 3 modules
var Nav = __webpack_require__(19812);
// EXTERNAL MODULE: ./src/components/UI/ButtonGroup/index.js + 1 modules
var ButtonGroup = __webpack_require__(37938);
// EXTERNAL MODULE: ./src/components/UI/Logo/index.js + 1 modules
var Logo = __webpack_require__(61316);
// EXTERNAL MODULE: ./src/components/UI/Typography/Heading/index.js + 1 modules
var Heading = __webpack_require__(70408);
// EXTERNAL MODULE: ./src/components/VideoModal/index.js + 1 modules
var VideoModal = __webpack_require__(26451);
// EXTERNAL MODULE: ./src/hooks/useUtmTags/index.jsx
var useUtmTags = __webpack_require__(88194);
// EXTERNAL MODULE: ./src/assets/Images/australianHeart.png
var australianHeart = __webpack_require__(66054);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge1.svg
var badge1 = __webpack_require__(10129);
var badge1_default = /*#__PURE__*/__webpack_require__.n(badge1);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge2.svg
var badge2 = __webpack_require__(88242);
var badge2_default = /*#__PURE__*/__webpack_require__.n(badge2);
// EXTERNAL MODULE: ./src/assets/Images/badges-actual/badge3.svg
var badge3 = __webpack_require__(25174);
var badge3_default = /*#__PURE__*/__webpack_require__.n(badge3);
// EXTERNAL MODULE: ./src/assets/Images/linkedin.svg
var linkedin = __webpack_require__(53239);
var linkedin_default = /*#__PURE__*/__webpack_require__.n(linkedin);
;// CONCATENATED MODULE: ./src/layouts/Footer/data.js
/* harmony default export */ var data = ([
    {
        heading: "Features",
        id: 1,
        url: "".concat("https://traqq.com", "/features/"),
        url_title: "Time Tracking Features of Traqq",
        items: [
            {
                id: 1,
                link: "/time-tracking",
                title: "Time tracking"
            },
            {
                id: 2,
                link: "/features/employee-monitoring-software/",
                title: "Employee monitoring"
            },
            {
                id: 3,
                link: "/team-management",
                title: "Team management"
            },
            {
                id: 4,
                link: "/features/online-time-reporting-system/",
                title: "Team analysis and reporting"
            },
            {
                id: 5,
                link: "/attendance-tracking",
                title: "Attendance tracking"
            },
            {
                id: 6,
                link: "".concat("https://traqq.com", "/features/productivity-tracker/"),
                title: "Productivity tracking"
            },
            {
                id: 7,
                link: "/updates",
                title: "Product updates"
            }
        ]
    },
    {
        heading: "Use Cases",
        id: 2,
        items: [
            {
                id: 1,
                link: "".concat("https://traqq.com", "/use-cases/enterprise-time-tracking-software/"),
                title: "Enterprises"
            },
            {
                id: 2,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-app-for-small-businesses/"),
                title: "Businesses"
            },
            {
                id: 3,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-software-for-agencies/"),
                title: "Agencies"
            },
            {
                id: 4,
                link: "/time-tracking-app-for-teams",
                title: "Teams"
            },
            {
                id: 5,
                link: "".concat("https://traqq.com", "/use-cases/time-tracking-software-for-freelancers/"),
                title: "Freelancers"
            }
        ]
    },
    {
        heading: "Help Center",
        id: 3,
        items: [
            {
                id: 1,
                link: "/support/getting-started",
                title: "Getting started"
            },
            {
                id: 2,
                link: "/support/desktop-app",
                title: "Desktop app"
            },
            {
                id: 3,
                link: "/support/tracking-time",
                title: "Tracking time"
            },
            {
                id: 4,
                link: "/support/monitoring-teams",
                title: "Monitoring teams"
            },
            {
                id: 5,
                link: "/support/managing-organization",
                title: "Managing organization"
            },
            {
                id: 6,
                link: "/support/reports",
                title: "Reports"
            },
            {
                id: 7,
                link: "/support/faq",
                title: "FAQ"
            }
        ]
    },
    {
        heading: "Company",
        id: 4,
        items: [
            {
                id: 1,
                link: "/about",
                title: "About us"
            },
            {
                id: 2,
                link: "/contact",
                title: "Contact us"
            },
            {
                id: 3,
                link: "".concat("https://traqq.com/blog", "/"),
                title: "Blog"
            },
            {
                id: 4,
                link: "/scientific-collaboration-program",
                title: "Scientific collaboration program"
            }
        ]
    },
    {
        heading: "Why Traqq",
        id: 5,
        items: [
            {
                id: 1,
                link: "https://traqq.com/blog/traqq-vs-clockify-which-time-tracking-solution-is-right-for-you/",
                title: "Traqq vs Clockify"
            },
            {
                id: 2,
                link: "https://traqq.com/blog/traqq-the-best-activtrak-alternative/",
                title: "Traqq vs ActivTrak"
            },
            {
                id: 3,
                link: "https://traqq.com/blog/traqq-vs-time-doctor-a-fresh-take-on-productivity-tracking-in-2025/",
                title: "Traqq vs Time Doctor"
            }
        ]
    }
]);

;// CONCATENATED MODULE: ./src/layouts/Footer/Footer.jsx




















var Navigation = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_Footer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                className: "flex flex-col gap-x-6 768:(flex-row)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterNav, {
                        className: "columns-2 gap-x-6 mb-10 768:(w-3/4 columns-3 mb-14)",
                        children: data.map(function(block) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: "flex break-inside-avoid flex-col not-last:pb-8 768:not-last:pb-12 gap-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                        tag: "span",
                                        className: "h4",
                                        children: block.url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: block.url,
                                            linkProps: {
                                                title: block.url_title
                                            },
                                            children: block.heading
                                        }) : block.heading
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* Nav */.JL, {
                                        className: "flex flex-col gap-y-4",
                                        children: block.items.map(function(item) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavItem */.LY, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavLink */.OL, {
                                                    href: item.link,
                                                    children: item.title
                                                })
                                            }, item.id);
                                        })
                                    })
                                ]
                            }, block.id);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer_FooterAction, {
                        className: "768:w-1/4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/",
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo/* default */.Z, {
                                    width: 48
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mobile-heading-3 mb-6 768:desktop-heading-3",
                                children: "Ready to get started?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonGroup/* default */.Z, {
                                direction: "col",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        tag: "a",
                                        type: "link",
                                        href: (0,useUtmTags/* default */.Z)("".concat("https://newapp.traqq.com", "/signup"), {
                                            utm_medium: "CTA_footer"
                                        }),
                                        variant: "primary",
                                        className: "button_md",
                                        children: "Sign up"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        tag: "a",
                                        type: "link",
                                        href: (0,useUtmTags/* default */.Z)("/demo", {
                                            utm_medium: "CTA_footer"
                                        }),
                                        variant: "outline_primary",
                                        color: "neutral",
                                        className: "button_md mb-6 whitespace-nowrap",
                                        children: "Book a demo"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal/* default */.Z, {
                                videoUrl: "https://www.youtube.com/embed/SNFKyh62lJo?si=XKjwUwtnin6Vsidk&autoplay=1",
                                className: "button button_link justify-center mx-auto mb-6 !text-sm 768:ml-0 768:justify-start 768:text-left",
                                btnText: "How Traqq works",
                                iconSize: 24
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-y-0.5 mb-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "desktop-subtitle",
                                                children: "Designed in Sydney, Australia"
                                            }),
                                            "\xa0",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: australianHeart/* default.src */.Z.src,
                                                alt: "Traqq Australia",
                                                width: 24,
                                                height: 24,
                                                className: "inline",
                                                loading: "lazy"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "desktop-body-4",
                                        children: "Level 10, 88 Phillip Street, Sydney NSW 2000. Traqq Pty Ltd."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                xs: 3,
                                md: 2,
                                lg: 3,
                                gx: 4,
                                gy: 4,
                                className: "mb-4 items-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (badge1_default()),
                                        alt: "G2 Easiest Admin",
                                        width: 78,
                                        height: 102,
                                        loading: "lazy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (badge2_default()),
                                        alt: "G2 High Performer EMEA",
                                        width: 78,
                                        height: 102,
                                        loading: "lazy",
                                        className: (0,css/* default */.Z)("w-[84px] -ml-[1px]")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: (badge3_default()),
                                        alt: "G2 High Performer",
                                        width: 78,
                                        height: 102,
                                        loading: "lazy"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer_FooterCopyright, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    className: "desktop-body-4 text-neutral-700 flex flex-col gap-y-1 768:(flex-row justify-between)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,css/* default */.Z)("flex flex-col gap-y-1 768:(flex-row-reverse gap-x-2)"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                                    href: "https://www.linkedin.com/company/traqq-time-tracking-software",
                                    target: "_blank",
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: (linkedin_default()),
                                            alt: "Follow us on LinkedIn",
                                            width: 16,
                                            height: 16
                                        }),
                                        "\xa0",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "LinkedIn"
                                        })
                                    ]
                                }),
                                "Copyright 2019 - ",
                                new Date().getFullYear(),
                                " Traqq. All rights reserved."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* Nav */.JL, {
                            direction: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* NavItem */.LY, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavLink */.OL, {
                                            href: "/legal/privacy",
                                            mods: {
                                                neutral: 700
                                            },
                                            className: "!leading-5",
                                            children: "Privacy policy"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "divider divider_solid divider_vertical"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavItem */.LY, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* NavLink */.OL, {
                                        href: "/legal/terms",
                                        mods: {
                                            neutral: 700
                                        },
                                        className: "!leading-5",
                                        children: "Terms of use"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var layouts_Footer_Footer = (Navigation);

;// CONCATENATED MODULE: ./src/layouts/Footer/index.js

/* harmony default export */ var layouts_Footer = (layouts_Footer_Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./src/components/Seo/index.js
var Seo = __webpack_require__(40845);
;// CONCATENATED MODULE: ./src/layouts/Layout/Seo.jsx






var Seo_Seo = function(param) {
    var title = param.title, description = param.description, useTitleTemplate = param.useTitleTemplate, additionalMetaTags = param.additionalMetaTags, defaultSeoConfigProp = param.defaultSeoConfig;
    var asPath = (0,router.useRouter)().asPath;
    var pathname = asPath.split("?")[0];
    var canonical = "".concat("https://traqq.com").concat(pathname !== "/" ? pathname : "");
    var defaultSeoConfig = (0,_object_spread/* default */.Z)({
        title: title,
        description: description,
        canonical: canonical,
        norobots: true,
        titleTemplate: "%s ".concat(useTitleTemplate && "-", " ").concat(useTitleTemplate),
        openGraph: {
            images: [
                {
                    alt: description,
                    height: 630,
                    type: "image/jpeg",
                    url: "".concat("https://traqq.com", "/og-thumbnail.jpg"),
                    width: 1200
                }
            ],
            locale: "en_US",
            site_name: "Traqq | traqq.com",
            type: "website"
        },
        additionalMetaTags: additionalMetaTags
    }, defaultSeoConfigProp);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* DefaultSeoTraqq */.gA, (0,_object_spread/* default */.Z)({}, defaultSeoConfig))
    });
};
Seo_Seo.propTypes = {
    defaultSeoConfig: (prop_types_default()).object,
    description: (prop_types_default()).string,
    title: (prop_types_default()).string,
    useTitleTemplate: (prop_types_default()).string
};
Seo_Seo.defaultProps = {
    useTitleTemplate: "Traqq"
};
/* harmony default export */ var Layout_Seo = (Seo_Seo);

;// CONCATENATED MODULE: ./src/layouts/Layout/Layout.jsx










var Layout = function(param) {
    var children = param.children, title = param.title, description = param.description, useTitleTemplate = param.useTitleTemplate, additionalMetaTags = param.additionalMetaTags, defaultSeoConfig = param.defaultSeoConfig;
    var pathname = (0,router.useRouter)().pathname;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout_Seo, {
                title: title,
                description: description,
                useTitleTemplate: useTitleTemplate,
                additionalMetaTags: additionalMetaTags,
                defaultSeoConfig: defaultSeoConfig
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: pathname !== "/" && ![
                    "pricing",
                    "support",
                    "about",
                    "contact",
                    "blog",
                    "demo",
                    "switch-to-traqq-discount",
                    "legal",
                    "terms",
                    "privacy",
                    "404",
                    "500",
                    "400",
                    "401",
                    "403",
                    "502",
                    "503",
                    "504",
                    "action-forbidden",
                    "land/enterprise-time-tracking",
                    "land/time-tracking-solution",
                    "feedback",
                    "online-timer",
                    "online-stopwatch",
                    "pomodoro-timer",
                    "scientific-collaboration-program"
                ].some(function(item) {
                    return pathname.includes(item);
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SwitchToTraqqLayout/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: [
                    "pricing"
                ].some(function(item) {
                    return pathname.includes(item);
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Ads_GetOnTraqqLayout, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(renderIf/* default */.Z, {
                isTrue: ![
                    "404",
                    "500",
                    "400",
                    "401",
                    "403",
                    "502",
                    "503",
                    "504",
                    "action-forbidden",
                    "land/enterprise-time-tracking",
                    "land/time-tracking-solution",
                    "land/effective-time-tracker"
                ].some(function(item) {
                    return pathname.includes(item);
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts_Footer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_CookieAccept, {})
        ]
    });
};
Layout.propTypes = {
    children: (prop_types_default()).node,
    defaultSeoConfig: (prop_types_default()).object,
    description: (prop_types_default()).string,
    title: (prop_types_default()).string,
    useTitleTemplate: (prop_types_default()).string
};
Layout.defaultProps = {
    useTitleTemplate: "Traqq"
};
/* harmony default export */ var Layout_Layout = (Layout);

;// CONCATENATED MODULE: ./src/layouts/Layout/index.js

/* harmony default export */ var layouts_Layout = (Layout_Layout);


/***/ }),

/***/ 75632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var css = (__webpack_require__(85078).css);
/* harmony default export */ __webpack_exports__["Z"] = (css);


/***/ }),

/***/ 79810:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var RenderIf = function(param) {
    var children = param.children, isTrue = param.isTrue;
    return isTrue ? children : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (RenderIf);


/***/ }),

/***/ 10129:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 88242:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 25174:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 91542:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU2IiBoZWlnaHQ9IjE4MSIgdmlld0JveD0iMCAwIDE1NiAxODEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTUzMDFfNTA2MikiPgogICAgICAgIDxwYXRoIGQ9Ik0yMC4yODUxIDEwMi4xOTNDMzUuOTA2IDg2LjU3MjUgNjEuMjMyNiA4Ni41NzI1IDc2Ljg1MzYgMTAyLjE5M0wxMzYuODk2IDE2Mi4yMzZDMTUyLjUxNyAxNzcuODU3IDE1Mi41MTcgMjAzLjE4MyAxMzYuODk2IDIxOC44MDRMNzkuODk1NiAyNzUuODA1QzY0LjI3NDcgMjkxLjQyNiAzOC45NDgxIDI5MS40MjYgMjMuMzI3MSAyNzUuODA1TC0zNi43MTU0IDIxNS43NjJDLTUyLjMzNjQgMjAwLjE0MSAtNTIuMzM2MyAxNzQuODE1IC0zNi43MTU0IDE1OS4xOTRMMjAuMjg1MSAxMDIuMTkzWiIgZmlsbD0iI0ZGNzY2NCIvPgogICAgICAgIDxwYXRoIGQ9Ik0yMC4yODUxIDI4LjI4NzJDMzUuOTA2IDEyLjY2NjIgNjEuMjMyNiAxMi42NjYyIDc2Ljg1MzYgMjguMjg3MkwxMzYuODk2IDg4LjMyOTdDMTUyLjUxNyAxMDMuOTUxIDE1Mi41MTcgMTI5LjI3NyAxMzYuODk2IDE0NC44OThMNzkuODk1NiAyMDEuODk5QzY0LjI3NDcgMjE3LjUyIDM4Ljk0ODEgMjE3LjUyIDIzLjMyNzEgMjAxLjg5OUwtMzYuNzE1NCAxNDEuODU2Qy01Mi4zMzY0IDEyNi4yMzUgLTUyLjMzNjMgMTAwLjkwOSAtMzYuNzE1NCA4NS4yODc2TDIwLjI4NTEgMjguMjg3MloiIGZpbGw9IiNGRjc2NjQiLz4KICAgICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyOC4yMjcgMTUzLjU2OUw3OS44OTU2IDIwMS45MDFDNjQuMjc0NyAyMTcuNTIyIDM4Ljk0ODEgMjE3LjUyMiAyMy4zMjcxIDIwMS45MDFMLTI4LjA0NjYgMTUwLjUyN0wyMC4yODUxIDEwMi4xOTVDMzUuOTA2MSA4Ni41NzQyIDYxLjIzMjYgODYuNTc0MyA3Ni44NTM2IDEwMi4xOTVMMTI4LjIyNyAxNTMuNTY5WiIgZmlsbD0iI0ZGQzhDMCIvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xNTMwMV81MDYyIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjE1NiIgaGVpZ2h0PSIxODAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuMDAyOTI5NjkpIi8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),

/***/ 49807:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjcwIiBoZWlnaHQ9IjI3MyIgdmlld0JveD0iMCAwIDI3MCAyNzMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBvcGFjaXR5PSIwLjIiIGQ9Ik04NCAyNTkuNTAzQzQ0LjUxMTYgMjU5LjUwMyAxMi41IDIyNy40OTEgMTIuNSAxODguMDAzTDEyLjUgLTE0My45OTdDMTIuNSAtMTgzLjQ4NSA0NC41MTE2IC0yMTUuNDk3IDg0IC0yMTUuNDk3TDQxNiAtMjE1LjQ5N0M0NTUuNDg4IC0yMTUuNDk3IDQ4Ny41IC0xODMuNDg1IDQ4Ny41IC0xNDMuOTk3TDQ4Ny41IDE4OC4wMDNDNDg3LjUgMjI3LjQ5MSA0NTUuNDg4IDI1OS41MDMgNDE2IDI1OS41MDNMODQgMjU5LjUwM1oiIHN0cm9rZT0iIzU4NTY2OCIgc3Ryb2tlLXdpZHRoPSIyNSIvPgogICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMjAgMzAuMDAyOUgxNDBDMTI4LjQwMiAzMC4wMDI5IDExOSAzOS40MDUgMTE5IDUxLjAwMjlWMTMxLjAwM0MxMTkgMTQyLjYwMSAxMjguNDAyIDE1Mi4wMDMgMTQwIDE1Mi4wMDNIMjIwQzIzMS41OTggMTUyLjAwMyAyNDEgMTQyLjYwMSAyNDEgMTMxLjAwM1Y1MS4wMDI5QzI0MSAzOS40MDUgMjMxLjU5OCAzMC4wMDI5IDIyMCAzMC4wMDI5Wk0xNDAgMjcuMDAyOUMxMjYuNzQ1IDI3LjAwMjkgMTE2IDM3Ljc0ODEgMTE2IDUxLjAwMjlWMTMxLjAwM0MxMTYgMTQ0LjI1OCAxMjYuNzQ1IDE1NS4wMDMgMTQwIDE1NS4wMDNIMjIwQzIzMy4yNTUgMTU1LjAwMyAyNDQgMTQ0LjI1OCAyNDQgMTMxLjAwM1Y1MS4wMDI5QzI0NCAzNy43NDgxIDIzMy4yNTUgMjcuMDAyOSAyMjAgMjcuMDAyOUgxNDBaIiBmaWxsPSIjMjBDMjg4Ii8+CiAgICA8cGF0aCBkPSJNMTQ5IC0xMjkuOTk3SDM3OVY5NC4wMDI5SDE4OUMxNjYuOTA5IDk0LjAwMjkgMTQ5IDc2LjA5NDMgMTQ5IDU0LjAwMjlWLTEyOS45OTdaIiBmaWxsPSIjNjc2QkQyIi8+CiAgICA8cGF0aCBkPSJNMjQ0IDk0LjAwMzhWNTEuMDAyOUMyNDQgMzcuNzQ4MSAyMzMuMjU1IDI3LjAwMjkgMjIwIDI3LjAwMjlIMTQ5VjMwLjAwMjlIMjIwQzIzMS41OTggMzAuMDAyOSAyNDEgMzkuNDA1IDI0MSA1MS4wMDI5Vjk0LjAwMzhIMjQ0WiIgZmlsbD0iI0YyRjNGRiIvPgo8L3N2Zz4K"

/***/ }),

/***/ 53239:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNyIgZmlsbD0ibm9uZSI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDA3N0I1IiBkPSJNMTYgMEgwdjE2aDE2VjBaIi8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTcuNjMgNi4wNnY2LjItNi4yWm0tMy4yIDB2Ni4yLTYuMlpNNS42IDQuMzFhMS4xNiAxLjE2IDAgMSAxLTIuMzIgMCAxLjE2IDEuMTYgMCAwIDEgMi4zMSAwWk04LjY2IDYuMDZ2LjgzYy4yNi0uNC43OS0uOTUgMS44LS45NSAxLjM4IDAgMi4zOC44NyAyLjM4IDIuNzh2My41M2gtMi4wNlY4Ljk3YzAtLjg0LS4yOC0xLjQtMS4wMy0xLjQtLjYgMC0uOTkuNDMtMS4xLjk0djMuNzRINi42VjYuMDZoMi4wN1pNMy40IDEyLjI1VjYuMDZoMi4wN3Y2LjJIMy40WiIvPjwvZz48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0iI2ZmZiIgcng9IjIiLz48L2NsaXBQYXRoPjwvZGVmcz48L3N2Zz4="

/***/ }),

/***/ 95176:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAiIGhlaWdodD0iNDAiIGZpbGw9Im5vbmUiPjxwYXRoIGZpbGw9IiMzRDNCNEYiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTQ4Ljc0IDI1LjZjLS4zMy4yNi0uNzMuNDUtMS4yLjU4LS40OC4xNC0uOTguMi0xLjUuMmE0LjIzIDQuMjMgMCAwIDEtMy4xNi0xLjEzYy0uNzQtLjc2LTEuMTItMS44Ny0xLjEyLTMuMzNWMTYuOEg0MHYtMi43OGgxLjc2di0xLjk4TDQ1LjA4IDExdjMuMDNoMi44NXYyLjc4aC0yLjg1djUuMDZjMCAuNTIuMTIuOTMuMzcgMS4yMS4yNS4yOS42LjQzIDEuMDUuNDMuNTMgMCAuOTctLjE1IDEuMzQtLjQ2bC45IDIuNTRabTYtMTAuMmMuNC0uNi45My0xLjA2IDEuNi0xLjM3LjY4LS4zIDEuNDUtLjQ2IDIuMzMtLjQ2djMuMzNsLS43NC0uMDVjLS45NSAwLTEuNy4zLTIuMjMuODctLjU0LjU4LS44MSAxLjQ0LS44MSAyLjZ2Ni40aC0zLjMyVjEzLjc1aDMuMTd2MS42NFptMTAuOTQtMS44M2MxLjc3IDAgMy4xMy40NiA0LjA4IDEuMzcuOTUuOTIgMS40MyAyLjMgMS40MyA0LjE2djcuNjJoLTMuMXYtMi4wN2MtLjYzIDEuMTUtMS44IDEuNzMtMy41IDEuNzMtLjg3IDAtMS42My0uMTYtMi4yOC0uNDhhMy41IDMuNSAwIDAgMS0xLjk5LTMuMjljMC0xLjE2LjQtMi4wNyAxLjItMi43My44LS42NiAyLjA0LTEgMy43MS0xaDIuNjRjMC0uNzgtLjIyLTEuMzgtLjY2LTEuOC0uNDQtLjQzLTEuMS0uNjQtMS45OC0uNjRhNS4zNSA1LjM1IDAgMCAwLTMuMjkgMS4xNWwtMS4xOS0yLjUyYTYuOTIgNi45MiAwIDAgMSAyLjI0LTEuMTFjLjg3LS4yNiAxLjc3LS40IDIuNy0uNFptLS4yNSAxMC4zOGEyLjcgMi43IDAgMCAwIDEuNS0uNDNjLjQ0LS4yOC43Ni0uNy45NC0xLjI2VjIxSDY1LjZjLTEuMzYgMC0yLjA0LjQ5LTIuMDQgMS40NiAwIC40Ni4xNi44My41IDEuMS4zMy4yNy43OC40IDEuMzcuNFpNODUuMzggMjlWMTMuNzVoLTMuMTZ2MS40NGE0LjIxIDQuMjEgMCAwIDAtMy41Ny0xLjYyIDUuNDMgNS40MyAwIDAgMC00Ljk3IDMuMDNjLS41Ljk3LS43NSAyLjEtLjc1IDMuMzcgMCAxLjI4LjI1IDIuNDEuNzQgMy4zOGE1LjQzIDUuNDMgMCAwIDAgNC45OCAzLjAzYzEuNDUgMCAyLjYtLjUgMy40Mi0xLjVWMjloMy4zMVptLTQuMDgtNi41MmMtLjU1LjYzLTEuMjQuOTQtMi4wOC45NC0uODUgMC0xLjU1LS4zMS0yLjEtLjk0YTMuNjUgMy42NSAwIDAgMS0uODMtMi41YzAtMS4wNS4yNy0xLjkuODItMi41MmEyLjY5IDIuNjkgMCAwIDEgMi4xLS45M2MuODUgMCAxLjU0LjMxIDIuMS45My41NC42My44MiAxLjQ3LjgyIDIuNTEgMCAxLjA1LS4yOCAxLjg5LS44MyAyLjUxWk0xMDAgMjlWMTMuNzVoLTMuMTd2MS40NGE0LjIxIDQuMjEgMCAwIDAtMy41Ny0xLjYyIDUuNDMgNS40MyAwIDAgMC00Ljk3IDMuMDNjLS41Ljk3LS43NCAyLjEtLjc0IDMuMzcgMCAxLjI4LjI0IDIuNDEuNzQgMy4zOGE1LjQzIDUuNDMgMCAwIDAgNC45NyAzLjAzYzEuNDYgMCAyLjYtLjUgMy40Mi0xLjVWMjlIMTAwWm0tNC4wOC02LjUyYy0uNTUuNjMtMS4yNS45NC0yLjA4Ljk0LS44NSAwLTEuNTYtLjMxLTIuMS0uOTRhMy42NSAzLjY1IDAgMCAxLS44NC0yLjVjMC0xLjA1LjI4LTEuOS44My0yLjUyYTIuNjkgMi42OSAwIDAgMSAyLjEtLjkzYy44NCAwIDEuNTQuMzEgMi4wOS45My41NS42My44MyAxLjQ3LjgzIDIuNTEgMCAxLjA1LS4yOCAxLjg5LS44MyAyLjUxWiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iIzMyQ0Q5NSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNOS4zMyAyLjY3QzkuMzMgMS4xOSAxMC41MyAwIDEyIDBhMjAgMjAgMCAxIDEgMCA0MCAyLjY3IDIuNjcgMCAxIDEgMC01LjMzIDE0LjY3IDE0LjY3IDAgMCAwIDAtMjkuMzQgMi42NyAyLjY3IDAgMCAxLTIuNjctMi42NloiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPjxwYXRoIGZpbGw9IiNGRkMxMTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTkuMzMgMTAuNjdDOS4zMyA5LjE5IDEwLjUzIDggMTIgOEExMiAxMiAwIDEgMSAwIDIwYTIuNjcgMi42NyAwIDEgMSA1LjMzIDBBNi42NyA2LjY3IDAgMSAwIDEyIDEzLjMzYTIuNjcgMi42NyAwIDAgMS0yLjY3LTIuNjZaIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjIwIiByPSI0IiBmaWxsPSIjRjQ0QjVFIi8+PC9zdmc+"

/***/ }),

/***/ 97271:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 51937:
/***/ (function(module) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iIzMyQ0Q5NSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMzggMi44NUEyLjY1IDIuNjUgMCAwIDEgMTYuMDMuMjFhMTkuODYgMTkuODYgMCAxIDEgMCAzOS43MSAyLjY1IDIuNjUgMCAxIDEgMC01LjMgMTQuNTcgMTQuNTcgMCAxIDAgMC0yOS4xMiAyLjY1IDIuNjUgMCAwIDEtMi42NS0yLjY1WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iI0ZGQzExMSIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTMuMzggMTAuOGEyLjY1IDIuNjUgMCAwIDEgMi42NS0yLjY1QTExLjkyIDExLjkyIDAgMSAxIDQuMSAyMC4wNmEyLjY1IDIuNjUgMCAwIDEgNS4zIDAgNi42MiA2LjYyIDAgMSAwIDYuNjMtNi42MiAyLjY1IDIuNjUgMCAwIDEtMi42NS0yLjY0WiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PHBhdGggZmlsbD0iI0Y0NEI1RSIgZD0iTTE2LjA4IDI0LjA1YTMuOTcgMy45NyAwIDEgMCAwLTcuOTUgMy45NyAzLjk3IDAgMCAwIDAgNy45NVoiLz48L3N2Zz4="

/***/ })

}]);